import { Box } from "@mui/material";
import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useGetNetworksHeatMapQuery } from "../../store/apis/search";
import Table from "./Table";
import { useWindowSize } from "@react-hook/window-size";
//@ts-ignore
import { INITIAL_VALUE, ReactSVGPanZoom } from "react-svg-pan-zoom";
export type CountryDataType = { country_id: Number; country_title: string; operator_count: number; network_count: number; score: number };

interface HeatMapProps {
  filterValues: any;
  loading?: boolean;
}
interface FilterType {
  name: string;
  value: string;
}

const filterLabels = [
  { name: "technologyIds", humanLabel: "Technologies" },
  { name: "featureIds", humanLabel: "Features" },
  { name: "statusIds", humanLabel: "Statuses" },
  { name: "usageIds", humanLabel: "Usage" },
  { name: "ituRegionIds", humanLabel: "ITU Regions" },
  { name: "regionIds", humanLabel: "Regions" },
  { name: "countryIds", humanLabel: "Countries" },
  { name: "speedIds", humanLabel: "UE Category" },
  { name: "frequencyBandIds", humanLabel: "Frequencies" },
  { name: "downloadSpeed", humanLabel: "Download Speed" },
  { name: "downloadSpeedControl", humanLabel: "downloadSpeedControl" },
  { name: "sunsetTechnologyIds", humanLabel: "Switch Off Tech" },
  { name: "satelliteVendorIds", humanLabel: "Satellite Vendors" },
  { name: "satelliteUseCaseIds", humanLabel: "Satellite NTN" },
];
const humanize = (machineLabel: string) => {
  // let humanLabel = "";
  const foundItem = filterLabels.find(item => item.name === machineLabel);
  //@ts-ignore
  return foundItem ? foundItem.humanLabel : machineLabel;
};

const HeatMap: React.FC<HeatMapProps> = ({ filterValues = [], loading }) => {
  const { data = { meta: {} }, isLoading, isFetching, isUninitialized } = useGetNetworksHeatMapQuery({ values: filterValues });
  const { data: dataObject = {} } = data;
  const [showTable, setshowTable] = useState(false);
  const mapDiv = useRef<HTMLDivElement>(null);
  const Viewer = useRef<HTMLDivElement>(null);

  const disallowed = ["frequencyBandControl", "featureControl", "publicStatusIds"];
  const {
    meta: { filters },
  } = data;
  let cleanFilters: FilterType[] = [];
  if (filters) {
    //@ts-ignore
    cleanFilters = Object.entries(filters)
      .filter(entry => !disallowed.includes(entry[0]))
      .map(entry => {
        return { name: entry[0], value: entry[1] ?? "" };
      });
  }

  let maxScore = 0;
  let styleCountries = () => "";
  if (dataObject.length > 0) {
    const countriesWithScore = dataObject.toSorted((a: CountryDataType, b: CountryDataType) => b.score - a.score);
    maxScore = countriesWithScore[0].score;
    styleCountries = () => {
      const styleArray = Object.values(countriesWithScore).map(
        // @ts-ignore
        item => `#map-pane path[data-name="${item.country_title}"] {fill: ${heatColor};fill-opacity: ${item.score / maxScore};}`,
      );
      return styleArray.join("");
    };
  }

  const [showTooltip, setShowTooltip] = useState(false);
  const [countryName, setCountryName] = useState("");
  const [countryData, setCountryData] = useState(null);
  const [cursorCoords, setcursorCoords] = useState({ x: 0, y: 0 });
  const [ViewerTop, setViewerTop] = useState(20);

  useEffect(() => {
    let myTop = 20;
    if (mapDiv.current) {
      myTop = mapDiv.current.offsetTop + 20;
      setViewerTop(myTop);
    }
  }, [countryData]);

  const tooltipContent = (countryName: string) => {
    setCountryName(countryName);
    if (dataObject.length > 0) {
      const thisCountry = dataObject.find((item: CountryDataType) => item.country_title === countryName);
      setCountryData(thisCountry);
    }
  };

  const doOut = (evt: any) => {
    setShowTooltip(false);
  };

  const doHover = (evt: any) => {
    setShowTooltip(true);
    tooltipContent(evt.target.getAttribute("data-name"));
  };

  const mouseMove = (evt: any) => {
    const pos = evt.currentTarget.getBoundingClientRect();
    setcursorCoords({
      x: evt.clientX - pos.left,
      y: evt.clientY - pos.top,
    });
  };

  const heatColor = "#ee238c";

  const [tool, onChangeTool] = useState("auto");
  const [value, onChangeValue] = useState(INITIAL_VALUE);
  const [width, height] = useWindowSize({ initialWidth: 400, initialHeight: 400 });

  useLayoutEffect(() => {
    //@ts-ignore
    Viewer.current.reset();
    //@ts-ignore
    Viewer.current.fitToViewer();
    //Viewer.current.zoomOnViewerCenter(1);
  }, [width, height]);

  /* Read all the available methods in the documentation */
  //@ts-ignore
  const _zoomOnViewerCenter1 = () => Viewer.current.zoomOnViewerCenter(1.1);
  //@ts-ignore
  const _zoomOnViewerCenter2 = () => Viewer.current.zoomOnViewerCenter(0.9);
  //@ts-ignore
  const _fitToViewer1 = () => Viewer.current.fitToViewer("center", "center");

  useEffect(() => {
    const getPositionsFromD = (d: string | null) => {
      if (d) {
        let sub = d.substr(2, d.length);
        sub = sub.substring(0, sub.indexOf(" "));
        const subArray = sub.split(",");
        if (Viewer) {
          //@ts-ignore
          Viewer.current.setPointOnViewerCenter(subArray[0], subArray[1], 1);
          //Viewer.current.fitSelection(subArray[0], subArray[1], 200, 200);
          //Viewer.current.pan(subArray[0], subArray[1]);
          //Viewer.current.zoom(subArray[0], subArray[1]);
        }
      }
    };

    if (dataObject.length === 1) {
      const myCountry = document.querySelectorAll("[data-name='" + dataObject[0].country_title + "']");
      const firstPath = myCountry[0];
      if (firstPath) {
        getPositionsFromD(firstPath.getAttribute("d"));
      }
    }
  }, [dataObject]);

  return (
    <Box paddingY={4}>
      <Helmet>
        <style type="text/css">{`
        ${styleCountries()}
      `}</style>
      </Helmet>

      <h2>Network penetration per total operators in each country/territory</h2>
      {cleanFilters.length > 0 && (
        <div id="filters" style={{ marginTop: "-20px" }}>
          <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "flex-start", flexWrap: "wrap" }}>
            <h3 style={{ marginRight: "40px" }}>Filters applied:</h3>
            {/* //@ts-ignore */}
            {cleanFilters?.map((item, i) => (
              <p key={i} style={{ marginRight: "40px", marginTop: "20px" }}>
                <strong>{humanize(item.name)} </strong>
                <br />
                {Array.isArray(item.value) ? item.value.join(", ") : item.value}
              </p>
            ))}
          </div>
        </div>
      )}

      {showTooltip && (
        <div
          id="tooltip"
          style={{
            position: "absolute",
            zIndex: 900000000,
            /* right: "20px", */
            left: `${cursorCoords.x + 310}px`,
            top: `${cursorCoords.y + ViewerTop}px`,
            /* display: "none", */
            background: "#eee",
            /* border: "1px solid black", */
            borderRadius: "5px",
            padding: "8px 16px",
            textAlign: "center",
            minWidth: "140px",
            boxShadow: "1px 1px 5px #efefef",
          }}
        >
          <h4 style={{ margin: "4px 0px" }}>{countryName}</h4>
          {/* <p>{countryData && Object.keys(countryData).map(key => key + ": " + countryData[key])}</p> */}
          {countryData && (
            <table style={{ fontSize: "0.7rem" }}>
              <tbody>
                <tr>
                  <th style={{ textAlign: "left" }}>Filtered results: &nbsp;</th>
                  <td style={{ textAlign: "left" }}>{countryData["network_count"]}</td>
                </tr>
                <tr>
                  <th style={{ textAlign: "left" }}>Total operators: &nbsp;</th>
                  <td style={{ textAlign: "left" }}>{countryData["operator_count"]}</td>
                </tr>
                <tr>
                  <th style={{ textAlign: "left" }}>Penetration: &nbsp;</th>
                  <td style={{ textAlign: "left" }}>{Number((countryData["score"] / maxScore) * 100).toFixed()}%</td>
                </tr>
              </tbody>
            </table>
          )}
          {/* {cursorCoords.x + " : " + cursorCoords.y} */}
        </div>
      )}
      <div style={{ position: "relative", bottom: "-50px", left: "10px", marginTop: "-20px", zIndex: 200, maxWidth: "150px" }}>
        <button className="btn" onClick={() => _zoomOnViewerCenter1()}>
          +
        </button>{" "}
        &nbsp;
        <button className="btn" onClick={() => _zoomOnViewerCenter2()}>
          -
        </button>{" "}
        &nbsp;
        <button className="btn" onClick={() => _fitToViewer1()}>
          reset
        </button>
      </div>
      <div
        data-testid="map-pane"
        id="map-pane"
        style={{
          width: "100%",
          height: (width - 420) / 2 + "px",
          margin: "20px 0",
          border: "1px solid #eee",
          overflow: "hidden",
        }}
        //@ts-ignore
        onMouseMove={(ev: Event) => mouseMove(ev)}
        ref={mapDiv}
      >
        <ReactSVGPanZoom
          width={width - 420}
          height={(width - 420) / 2}
          ref={Viewer}
          value={value}
          tool={tool}
          toolbarProps={{ position: "none" }}
          miniatureProps={{ position: "none" }}
          onChangeValue={onChangeValue}
          onChangeTool={onChangeTool}
          detectAutoPan={false}
          background={"white"}
          detectWheel={false}
        >
          <svg
            viewBox="0 0 2000 857"
            fill="#ececec"
            width={width - 420}
            height={(width - 420) / 2}
            stroke="#eee"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth=".2"
            version="1.2"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1323,261.6 1.5,1.8 -2.9,0.8 -2.4,1.1 -5.9,0.8 -5.3,1.3 -2.4,2.8 1.9,2.7 1.4,3.2 -2,2.7 0.8,2.5 -0.9,2.3 -5.2,-0.2 3.1,4.2 -3.1,1.7 -1.4,3.8 1.1,3.9 -1.8,1.8 -2.1,-0.6 -4,0.9 -0.2,1.7 h -4.1 l -2.3,3.7 0.8,5.4 -6.6,2.7 -3.9,-0.6 -0.9,1.4 -3.4,-0.8 -5.3,1 -9.6,-3.3 3.9,-5.8 -1.1,-4.1 -4.3,-1.1 -1.2,-4.1 -2.7,-5.1 1.6,-3.5 -2.5,-1 0.5,-4.7 0.6,-8 5.9,2.5 3.9,-0.9 0.4,-2.9 4,-0.9 2.6,-2 -0.2,-5.1 4.2,-1.3 0.3,-2.2 2.9,1.7 1.6,0.2 h 3 l 4.3,1.4 1.8,0.7 3.4,-2 2.1,1.2 0.9,-2.9 3.2,0.1 0.6,-0.9 -0.2,-2.6 1.7,-2.2 3.3,1.4 -0.1,2 1.7,0.3 0.9,5.4 2.7,2.1 1.5,-1.4 2.2,-0.6 2.5,-2.9 3.8,0.5 z"
              id="AF"
              data-name="Afghanistan"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Angola"
              d="m 1061.2,572 0.6,2 -0.7,3.1 0.9,3 -0.9,2.4 0.4,2.2 -11.7,-0.1 -0.8,20.5 3.6,5.2 3.6,4 -10.4,2.6 -13.5,-0.9 -3.8,-3 -22.7,0.2 -0.8,0.5 -3.3,-2.9 -3.6,-0.2 -3.4,1.1 -2.7,1.2 -0.5,-4 0.9,-5.7 2,-5.9 0.3,-2.7 1.9,-5.8 1.4,-2.6 3.3,-4.2 1.9,-2.9 0.6,-4.7 -0.3,-3.7 -1.6,-2.3 -1.5,-3.9 -1.3,-3.8 0.3,-1.4 1.7,-2.5 -1.6,-6.2 -1.2,-4.3 -2.8,-4.1 0.6,-1.2 2.3,-0.9 1.7,0.1 2,-0.7 16.7,0.1 1.3,4.7 1.6,3.9 1.3,2.1 2.1,3.3 3.8,-0.5 1.8,-0.9 3.1,0.9 0.9,-1.6 1.5,-3.7 3.5,-0.3 0.3,-1.1 h 2.9 l -0.5,2.3 6.8,-0.1 0.1,4.1 1.1,2.4 -0.9,3.9 0.4,4 1.8,2.4 -0.4,7.6 1.4,-0.6 2.4,0.2 3.5,-1 z"
              id="path1"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Angola"
              d="m 995.3,539 -1.5,-4.8 2.3,-2.8 1.7,-1.1 2.1,2.2 -2,1.4 -1,1.6 -0.2,2.8 z"
              id="path2"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Albania"
              d="m 1028,228 0.4,1.2 1.4,-0.6 1.2,1.7 1.3,0.7 0.6,2.3 -0.5,2.2 1,2.7 2.3,1.5 0.1,1.7 -1.7,0.9 -0.1,2.1 -2.2,3.1 -0.9,-0.4 -0.2,-1.4 -3.1,-2.2 -0.7,-3 0.1,-4.4 0.5,-1.9 -0.9,-1 -0.5,-2.1 z"
              id="AL"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1236.2,336.7 1.3,5.1 h -2.8 v 4.2 l 1.1,0.9 -2.4,1.3 0.2,2.6 -1.3,2.6 v 2.6 l -1,1.4 -16.9,-3.2 -2.7,-6.6 -0.3,-1.4 0.9,-0.4 0.4,1.8 4.2,-1 4.6,0.2 3.4,0.2 3.3,-4.4 3.7,-4.1 3,-4 z"
              id="AE"
              data-name="United Arab Emirates"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Argentina"
              d="m 609.1,851.7 -3,-0.2 h -5 l -6,-13.6 3.1,2.8 4.3,4.6 7.8,3.7 7.3,1.5 -0.8,3 -4.4,0.3 z"
              id="path3"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Argentina"
              d="m 578.6,644.7 11.3,10.4 4.6,1 7.3,4.8 5.9,2.5 1.1,2.8 -4.2,9.8 5.8,1.7 6.3,1 4.2,-1 4.3,-5 0.3,-5.6 2.6,-1.3 3.2,3.8 0.4,5.1 -4.2,3.5 -3.3,2.6 -5.3,6.3 -6,8.7 -0.5,5.2 -0.4,6.6 1.2,6.4 -0.9,1.4 0.4,4.1 0.3,3.4 7.8,5.5 0.2,4.4 3.9,2.8 0.3,3.1 -3.3,8.2 -7,3.5 -10.2,1.3 -6,-0.7 2.1,3.9 0.1,4.7 1.8,3.2 -2.5,2.3 -5.1,0.9 -5.6,-2.4 -1.5,1.7 2.5,6.3 4,1.9 2.3,-2 2.5,3.3 -4.2,2 -2.9,4 1.2,6.3 -0.1,3.4 h -4.8 l -3,3.2 0.1,4.8 6.5,4.6 5.2,1.2 0.2,5.7 -4.6,3.5 -0.6,7.3 -3.5,2.4 -0.9,2.9 4.2,6.5 4.6,3.5 -2.1,-0.3 -4.9,-1 -12.1,-0.8 -3.5,-3.6 -1.9,-4.6 -3.1,0.4 -2.6,-2.3 -3.1,-6.5 2.7,-2.8 0.1,-3.9 -1.8,-3.2 0.7,-5.4 -1.1,-8.3 -1.8,-3.7 1.8,-1.2 -1.4,-2.4 -2.8,-1.2 0.8,-2.7 -3.1,-2.4 -3.7,-7.3 1.7,-1.3 -3.3,-7.8 -0.8,-6.5 -0.2,-5.7 2.5,-2.3 -3.3,-6.3 -1.6,-5.8 3,-4.2 -1.4,-5.4 1.6,-6.2 -1.4,-5.9 -1.6,-1.2 -4.9,-11.1 2.1,-6.6 -1.7,-6.2 0.9,-5.9 2.6,-6 3.3,-4 -2,-2.5 0.8,-2.1 -1.6,-10.7 5.6,-3.1 1.2,-6.7 -0.9,-1.6 4,-5.8 7.5,1.6 3.7,4.6 1.6,-5.2 6.4,0.3 z"
              id="path4"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1170.8,253 -1.8,0.2 -2.8,-3.7 -0.2,-1 h -2.3 l -1.9,-1.7 -1,0.1 -2.4,-1.8 -4.2,-1.6 -0.1,-3.1 -1.3,-2.2 7,-1 1.4,1.6 2.2,1.1 -0.7,1.6 3.2,2.2 -1.1,2.1 2.6,1.7 2.5,1 z"
              id="AM"
              data-name="Armenia"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Australia"
              d="m 1683,763.6 3.7,2.2 3.3,-0.9 4.9,-1.2 2.8,0.4 -4.5,7.6 -3.3,2.1 -4,5.2 -0.6,-1.8 -6.6,4.4 -0.8,-0.3 -3,-0.2 0.5,-5.4 2,-4.2 0.6,-5.6 2,-2.9 z"
              id="path5"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Australia"
              d="m 1733.5,590.2 1.2,5 4,-2.4 1.4,2.7 2.3,2.5 -1.1,2.9 0.2,5.5 0.2,3.2 1.3,0.8 0.4,5.5 -1.2,3.3 0.8,4.3 5.4,3.4 3.2,3 3.2,2.8 -1.1,1.6 2.3,4 0.5,7 2.6,-1.4 1.5,2.7 1.6,-0.9 -0.7,6.8 2.9,3.9 1.9,2.4 2.8,5.2 v 5.2 l -1,3.7 -1.8,3.9 0.7,5.5 -2.5,5.7 -2.1,3 -3.8,5.7 -1.5,3.7 -3.1,4.6 -5,5.8 -5.5,3.2 -4.4,4.9 -3.3,3.2 -4.4,5.5 -3.7,3.2 -3.9,4.8 -3.1,4.4 -0.8,2.1 -4.3,2.2 -6.1,0.2 -6.3,2.7 -3.8,2.4 -4.8,2.8 -2.7,-2.9 -2.6,-1.1 2.6,-3.3 -3.5,1.2 -7.2,4.6 -3.6,-1.7 -2.4,-1 -2.8,-0.5 -4.1,-1.8 -1.3,-4 1.5,-4.8 0.4,-3.3 -1.4,-2.6 -4.7,-0.7 3.2,-3.2 0.9,-4.7 -4.7,4.4 -5.3,1.2 4.5,-3.5 2.5,-3.7 3.5,-3.2 1.6,-4.7 -6.8,5.4 -4.3,2.2 -4.3,5.1 -3,-2.6 1.7,-3.4 -1.4,-4.7 -1.8,-2.4 1.6,-1.5 -5.3,-3.9 -3.8,-0.1 -4,-3.2 -9.9,0.6 -7.9,2.3 -6.9,2.2 -5,-0.4 -7,3.3 -5.3,1.4 -2.3,3.4 -3,2.6 -4.7,0.2 -3.6,0.5 -4.2,-1.1 -4.2,0.7 -3.8,0.3 -4.5,3.4 -1.5,-0.3 -3.4,1.8 -3.4,2 -3.8,-0.2 h -3.5 l -4.1,-4.1 -2.4,-1.2 1.5,-3.7 2.9,-0.9 1.5,-1.4 0.6,-2.3 2.3,-4.5 0.7,-3.8 -0.7,-6.5 0.2,-3.7 1.4,-3.6 -0.9,-4.2 0.3,-1.9 -1.7,-2.6 0.7,-5 -1.9,-5.1 -0.1,-2.7 1.8,2.8 -0.5,-6 2.3,1.9 1.1,2.5 0.6,-3.3 -1.6,-5.1 -0.1,-2 -0.8,-1.9 1.3,-3.7 1.5,-1.6 1.3,-3.2 0.1,-3.8 3.1,-4.6 -0.4,4.9 3.1,-4.4 4.9,-2.2 3.2,-2.7 4.7,-2.4 2.6,-0.5 1.4,0.8 4.8,-2.4 3.5,-0.7 1.1,-1.4 1.5,-0.6 3.1,0.2 6.2,-1.9 3.5,-2.9 2,-3.4 3.9,-3.2 0.7,-2.6 0.7,-3.5 4.9,-5.5 1.4,5.6 2.6,-1.3 -1.5,-3 2.3,-3.1 2.2,1.4 1.5,-4.9 3.5,-3.2 1.8,-2.5 2.9,-1.1 0.4,-1.8 2.3,0.7 0.4,-1.6 2.6,-0.9 2.8,-0.9 3.7,3 2.6,3.8 h 3.5 l 3.5,0.6 -0.7,-3.5 3.5,-5.1 2.7,-1.7 -0.6,-1.6 2.9,-3.7 3.7,-2.3 2.7,0.8 4.9,-1.2 0.3,-3.3 -3.9,-2.1 3.1,-0.9 3.6,1.6 2.7,2.6 4.5,1.6 1.7,-0.6 3.3,2 3.5,-1.9 2,0.6 1.5,-1.3 2.2,3.2 -2,3.5 -2.5,2.6 -1.9,0.2 0.3,2.5 -2.2,3.2 -2.5,3.2 0.2,1.8 3.8,3.6 4,2 2.5,2.2 3.3,3.8 h 1.6 l 2.6,1.7 0.5,2 4.9,2.1 4.1,-2.2 1.8,-3.4 1.7,-2.9 1.3,-3.5 2.6,-5.1 -0.2,-3.1 0.7,-1.9 -0.1,-3.6 1.4,-4.9 1.3,-1.3 -0.6,-2.1 1.8,-3.4 1.5,-3.5 0.4,-1.9 2.3,-2.4 1.3,3.2 -0.1,4 1.3,0.8 -0.1,2.7 1.6,3.2 -0.1,3.7 z"
              id="path6"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1010.6,190.8 -0.3,0.8 0.7,2.1 -0.2,2.6 h -2.8 l 1.1,1.4 -1.3,4 -0.9,1.1 -4.4,0.1 -2.4,1.5 -4.2,-0.5 -7.3,-1.7 -1.3,-2.1 -4.9,1.1 -0.5,1.2 -3.1,-0.9 -2.6,-0.2 -2.3,-1.2 0.7,-1.5 -0.2,-1.1 1.4,-0.3 2.7,1.7 0.6,-1.7 4.4,0.3 3.5,-1.1 2.4,0.2 1.7,1.3 0.4,-1.1 -1,-4.1 1.7,-0.8 1.6,-2.9 3.8,2.1 2.6,-2.6 1.7,-0.5 4,1.9 2.3,-0.3 z"
              id="AT"
              data-name="Austria"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Azerbaijan"
              d="m 1169,253.2 -3.8,-0.9 -3.2,-2.9 -1.2,-2.5 1,-0.1 1.9,1.7 h 2.3 l 0.2,1 z"
              id="path7"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Azerbaijan"
              d="m 1175.3,236.2 2.5,-2.6 3.5,3.3 3.6,4.6 2.5,0.3 1.9,1.7 -4.2,0.5 0.1,5 -0.4,2.2 -1.7,1.5 0.8,3.1 -1.3,0.4 -3.9,-3.4 1.2,-3.1 -1.9,-1.9 -1.9,0.5 -5.3,4.7 -0.9,-4.5 -2.5,-1 -2.6,-1.7 1.1,-2.1 -3.2,-2.2 0.7,-1.6 -2.2,-1.1 -1.4,-1.6 1.1,-1.1 4.2,1.9 2.9,0.3 0.6,-0.7 -3.3,-3.5 1.2,-0.8 1.5,0.2 4.3,3.8 2.4,0.5 z"
              id="path8"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1094.9,530.4 -0.6,0.1 v -0.3 l -2,-6.1 -0.01,-0.06 -0.09,-1.04 -1.4,-2.9 3.5,0.5 1.7,-3.7 3.1,0.4 0.3,2.5 1.2,1.5 v 2.1 l -1.4,1.3 -2.3,3.4 z"
              id="BI"
              data-name="Burundi"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 956.5,177.1 -0.4,4.2 -1.3,0.2 -0.4,3.5 -4.4,-2.9 -2.5,0.5 -3.5,-2.9 -2.4,-2.5 -2.2,-0.1 -0.8,-2.2 3.9,-1.2 3.6,0.5 4.5,-1.3 3.1,2.7 z"
              id="BE"
              data-name="Belgium"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 946.7,427 -0.2,2.1 1.3,3.8 -1.1,2.6 0.6,1.7 -2.8,4 -1.7,2 -1.1,4 0.2,4.1 -0.3,10.3 -4.7,0.8 -1.4,-4.4 0.3,-14.8 -1.2,-1.3 -0.2,-3.2 -2,-2.2 -1.7,-1.9 0.7,-3.4 2,-0.7 1.1,-2.8 2.8,-0.6 1.2,-1.9 1.9,-1.9 h 2 z"
              id="BJ"
              data-name="Benin"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 928.5,406 -0.5,3.1 0.8,2.9 3.1,4.2 0.2,3.1 6.5,1.5 -0.1,4.4 -1.2,1.9 -2.8,0.6 -1.1,2.8 -2,0.7 -4.9,-0.1 -2.6,-0.5 -1.8,1 -2.5,-0.5 -9.8,0.3 -0.2,3.7 0.8,4.8 -3.9,-1.6 -2.6,0.2 -2,1.6 -2.5,-1.3 -1,-2.2 -2.5,-1.4 -0.4,-3.7 1.6,-2.7 -0.2,-2.2 4.5,-5.3 0.9,-4.4 1.5,-1.6 2.7,0.9 2.4,-1.3 0.8,-1.7 4.3,-2.8 1.1,-2 5.3,-2.7 3.1,-0.9 1.4,1.2 z"
              id="BF"
              data-name="Burkina Faso"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1440.6,360.3 0.6,4.6 -2.1,-1 1.1,5.2 -2.1,-3.3 -0.8,-3.3 -1.5,-3.1 -2.8,-3.7 -5.2,-0.3 0.9,2.7 -1.2,3.5 -2.6,-1.3 -0.6,1.2 -1.7,-0.7 -2.2,-0.6 -1.6,-5.3 -2.6,-4.8 0.3,-3.9 -3.7,-1.7 0.9,-2.3 3,-2.4 -4.6,-3.4 1.2,-4.4 4.9,2.8 2.7,0.3 1.2,4.5 5.4,0.9 5.1,-0.1 3.4,1.1 -1.6,5.4 -2.4,0.4 -1.2,3.6 3.6,3.4 0.3,-4.2 h 1.5 z"
              id="BD"
              data-name="Bangladesh"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1072.6,221.6 -2.3,2.6 -1.3,4.5 2.1,3.6 -4.6,-0.8 -5,2 0.3,3.2 -4.6,0.6 -3.9,-2.3 -4,1.8 -3.8,-0.2 -0.8,-4.2 -2.8,-2.1 0.7,-0.8 -0.6,-0.8 0.6,-2 1.8,-2 -2.8,-2.7 -0.7,-2.4 1.1,-1.4 1.8,2.6 1.9,-0.4 4,0.9 7.6,0.4 2.3,-1.6 5.9,-1.5 4,2.3 z"
              id="BG"
              data-name="Bulgaria"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1023,214.3 1.9,-0.1 -1.1,2.8 2.7,2.5 -0.5,2.9 -1.1,0.3 -0.9,0.6 -1.6,1.5 -0.4,3.5 -4.8,-2.4 -2.1,-2.7 -2.1,-1.4 -2.5,-2.4 -1.3,-1.9 -2.7,-3 0.8,-2.6 2,1.5 1,-1.4 2.3,-0.1 4.5,1.1 3.5,-0.1 z"
              id="BA"
              data-name="Bosnia and Herzegovina"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1081.6,162.7 -3.9,-0.2 -0.8,0.6 1.5,2 2,4 -4.1,0.3 -1.3,1.4 0.3,3.1 -2.1,-0.6 -4.3,0.3 -1.5,-1.5 -1.7,1.1 -1.9,-0.9 -3.9,-0.1 -5.7,-1.5 -4.9,-0.5 -3.8,0.2 -2.4,1.6 -2.3,0.3 -0.5,-2.8 -1.9,-2.8 2.8,-1.3 -0.4,-2.4 -1.7,-2.3 -0.6,-2.7 h 4.7 l 4.8,-2.3 0.5,-3.4 3.6,-2 -1,-2.7 2.7,-1 4.6,-2.3 5.3,1.5 0.9,1.5 2.4,-0.7 4.8,1.4 1.1,2.9 -0.7,1.6 3.8,4 2.1,1.1 v 1.1 l 3.4,1.1 1.7,1.6 z"
              id="BY"
              data-name="Belarus"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 427.8,399.8 h -1.7 l 1.3,-7.2 0.7,-5.1 0.1,-1 0.7,-0.3 0.9,0.8 2.5,-3.9 1.1,-0.1 -0.1,1 h 1 l -0.3,1.8 -1.3,2.7 0.4,1 -0.9,2.3 0.3,0.6 -1,3.3 -1.3,1.7 -1.1,0.2 z"
              id="BZ"
              data-name="Belize"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 602.5,631.4 -0.3,-2 -5.4,-3.3 -5.2,-0.1 -9.6,1.9 -2.1,5.6 0.2,3.5 -1.5,7.7 -1,-1.4 -6.4,-0.3 -1.6,5.2 -3.7,-4.6 -7.5,-1.6 -4,5.8 -3.9,0.9 -3.1,-8.9 -3.7,-7.2 1.1,-6.2 -3.2,-2.7 -1.2,-4.6 -3.2,-4.4 2.9,-6.9 -2.9,-5.4 1.1,-2.2 -1.2,-2.4 1.9,-3.2 -0.3,-5.4 v -4.6 l 1.1,-2.1 -5.5,-10.4 4.2,0.6 2.9,-0.2 1.1,-1.9 4.8,-2.6 2.9,-2.4 7.3,-1.1 -0.4,4.8 0.9,2.5 -0.3,4.3 6.5,5.7 6.4,1.1 2.3,2.4 3.9,1.3 2.5,1.8 h 3.5 l 3.4,1.9 0.5,3.7 1.2,1.9 0.3,2.7 -1.7,0.1 2.8,7.5 10.7,0.3 -0.5,3.7 0.8,2.5 3.2,1.8 1.7,4 -0.6,5.1 -1.3,2.8 0.8,3.6 z"
              id="BO"
              data-name="Bolivia"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 605.8,489.6 3.1,0.6 0.6,-1.4 -1,-1.2 0.6,-1.9 2.3,0.6 2.7,-0.7 3.2,1.4 2.5,1.3 1.7,-1.7 1.3,0.2 0.8,1.8 2.7,-0.4 2.2,-2.5 1.8,-4.7 3.4,-5.9 2,-0.3 1.3,3.6 3,11.2 3.1,1.1 0.1,4.4 -4.3,5.3 1.7,1.9 10.1,1 0.2,6.5 4.3,-4.2 7.1,2.3 9.5,3.9 2.8,3.7 -0.9,3.6 6.6,-2 11,3.4 8.5,-0.2 8.4,5.3 7.4,7.2 4.4,1.8 4.8,0.3 2.1,2 2,8.2 1.1,3.9 -2.1,10.6 -2.7,4.2 -7.7,8.9 -3.4,7.3 -4,5.5 -1.4,0.2 -1.3,4.7 0.9,12 -1.1,9.9 -0.3,4.2 -1.6,2.6 -0.5,8.6 -5.2,8.3 -0.5,6.7 -4.3,2.7 -1.1,3.9 h -6 l -8.5,2.4 -3.7,2.9 -6,1.9 -6.1,5.1 -4.1,6.4 -0.3,4.8 1.3,3.5 -0.3,6.5 -0.8,3.1 -3.4,3.6 -4.5,11.3 -4,5 -3.2,3.1 -1.5,6.1 -2.9,3.6 -2.1,-3.6 1.8,-3.1 -3.8,-4.3 -4.8,-3.6 -6.3,-4.1 -1.9,0.2 -6.3,-5 -3.4,0.7 6,-8.7 5.3,-6.3 3.3,-2.6 4.2,-3.5 -0.4,-5.1 -3.2,-3.8 -2.6,1.3 0.7,-3.7 0.3,-3.8 -0.3,-3.6 -2.1,-1.1 -2,1 -2.1,-0.3 -0.8,-2.4 -1.1,-5.9 -1.2,-1.9 -3.9,-1.8 -2.2,1.3 -5.9,-1.3 -0.4,-8.7 -2,-3.5 1.6,-1.4 -0.8,-3.6 1.3,-2.8 0.6,-5.1 -1.7,-4 -3.2,-1.8 -0.8,-2.5 0.5,-3.7 -10.7,-0.3 -2.8,-7.5 1.7,-0.1 -0.3,-2.7 -1.2,-1.9 -0.5,-3.7 -3.4,-1.9 h -3.5 l -2.5,-1.8 -3.9,-1.3 -2.3,-2.4 -6.4,-1.1 -6.5,-5.7 0.3,-4.3 -0.9,-2.5 0.4,-4.8 -7.3,1.1 -2.9,2.4 -4.8,2.6 -1.1,1.9 -2.9,0.2 -4.2,-0.6 -3.2,1.1 -2.6,-0.7 -0.1,-9.7 -4.4,3.7 -5,-0.1 -2.3,-3.5 -3.8,-0.3 1,-2.8 -3.3,-3.9 -2.6,-5.8 1.5,-1.1 -0.2,-2.8 3.4,-1.8 -0.7,-3.5 1.4,-2.2 0.3,-3 6.3,-4.4 4.6,-1.2 0.8,-1 5.1,0.3 2.2,-17.6 0.1,-2.8 -0.9,-3.6 -2.6,-2.4 0.1,-4.7 3.2,-1 1.1,0.7 0.2,-2.5 -3.3,-0.7 v -4 l 11,0.2 1.9,-2.3 1.6,2.1 1,3.8 1.1,-0.8 3.1,3.4 4.4,-0.4 1.1,-2 4.2,-1.5 2.4,-1.1 0.7,-2.7 4.1,-1.8 -0.3,-1.4 -4.8,-0.5 -0.7,-4.1 0.3,-4.3 -2.5,-1.6 1.1,-0.6 4.1,0.8 4.5,1.6 1.7,-1.5 4.1,-1 6.4,-2.4 2.1,-2.5 -0.7,-1.8 3,-0.2 1.2,1.4 -0.8,2.9 2,0.9 1.2,3 -1.6,2.3 -1,5.4 1.4,3.3 0.3,3 3.5,3 2.8,0.3 0.6,-1.3 1.8,-0.3 2.6,-1.1 1.8,-1.7 3.2,0.6 z"
              id="BR"
              data-name="Brazil"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1573.1,472.8 2.2,-2.4 4.6,-3.6 -0.1,3.2 -0.1,4.1 -2.7,-0.2 -1.1,2.2 z"
              id="BN"
              data-name="Brunei"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1428.8,323.5 2.6,2.1 0.5,3.9 -4.5,0.2 -4.7,-0.4 -3.2,1 -5.5,-2.5 -0.4,-1.2 2.6,-4.8 2.6,-1.6 4.3,1.4 2.9,0.2 z"
              id="BT"
              data-name="Bhutan"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1067.6,615.7 1.9,5.1 1.1,1.2 1.6,3.7 6.1,7 2.3,0.7 -0.1,2.3 1.5,4.1 4.3,1 3.4,2.9 -8.1,4.7 -5.2,4.8 -2,4.3 -1.8,2.4 -3,0.5 -1.2,3.1 -0.6,2 -3.6,1.4 -4.5,-0.3 -2.5,-1.8 -2.3,-0.7 -2.8,1.4 -1.5,3.1 -2.7,1.9 -2.8,2.9 -4,0.7 -1.1,-2.3 0.6,-3.9 -3,-6.1 -1.4,-1 0.6,-18.7 5.5,-0.2 0.8,-22.9 4.2,-0.2 8.7,-2.3 2,2.7 3.7,-2.5 h 1.7 l 3.2,-1.5 z"
              id="BW"
              data-name="Botswana"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1061.3,446.5 3.9,2.5 3.1,2.6 0.1,2.1 3.9,3.3 2.4,2.8 1.4,3.8 4.3,2.6 0.9,2 -1.8,0.7 -3.7,-0.1 -4.2,-0.7 -2.1,0.5 -0.9,1.6 -1.8,0.2 -2.2,-1.4 -6.3,3.2 -2.6,-0.6 -0.8,0.5 -1.6,3.9 -4.3,-1.3 -4.1,-0.6 -3.6,-2.4 -4.7,-2.2 -3,2.1 -2.2,3.2 -0.5,4.5 -3.6,-0.3 -3.9,-1.1 -3.3,3.4 -3,6 -0.6,-1.9 -0.3,-2.9 -2.6,-2.1 -2.1,-3.3 -0.5,-2.3 -2.7,-3.4 0.5,-1.9 -0.6,-2.7 0.4,-5 1.4,-1.1 2.8,-6.5 4.6,-0.5 1,-1.7 1,0.2 1.4,1.4 7.1,-2.4 2.4,-2.5 2.9,-2.3 -0.6,-2.2 1.6,-0.6 5.5,0.4 5.2,-3 4,-7 2.8,-2.6 3.6,-1.1 0.7,2.7 3.3,4 v 2.7 l -0.8,2.6 0.4,2 1.9,1.9 z"
              id="CF"
              data-name="Central African Republic"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Canada"
              d="m 605.9,203.6 3.4,0.9 4.7,-0.2 -3.3,2.6 -2,0.4 -5.5,-2.7 -0.6,-2.1 2.5,-1.9 z"
              id="path9"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Canada"
              d="m 620.3,187.6 -2.4,0.1 -5.8,-1.9 -3.5,-3 1.9,-0.5 5.9,1.6 4.2,2.6 z"
              id="path10"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Canada"
              d="m 312.4,191.3 -3.1,0.9 -6.3,-2.8 v -2.2 l -2.9,-2.2 0.3,-1.8 -4.3,-1.1 0.6,-3.4 1.5,-1.4 4.1,1.3 2.4,1 4.1,0.6 0.2,2.2 0.4,2.9 3.2,2.6 z"
              id="path11"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Canada"
              d="m 651.5,177.8 -5,5.4 3.9,-2.1 2.9,1.4 -2.4,2.1 3.8,1.7 2.8,-1.5 4.3,1.9 -2.8,4.6 3.8,-1.1 -0.3,3.3 0.5,3.9 -3.6,5.6 -2.4,0.2 -2.9,-1.2 2.5,-5.1 -1.2,-0.8 -7.3,5.4 -3,-0.2 4.4,-3 -4.4,-1.5 -5.5,0.4 -9.6,-0.2 -0.2,-1.8 3.8,-2.3 -1.7,-1.6 5.4,-3.8 8.2,-9.9 4.2,-3.5 5,-2.1 2.1,0.2 -1.5,1.7 z"
              id="path12"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Canada"
              d="m 291.5,156.4 1.5,0.8 5,-0.5 -7.2,6.9 0.3,5 h -1.9 l -0.7,-2.8 0.5,-2.9 -0.8,-1.9 1.3,-2.7 z"
              id="path13"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Canada"
              d="m 574.9,108.9 -3.6,3 -1.7,-0.5 -0.1,-1.7 0.4,-0.4 2.8,-1.7 1.7,0.1 z"
              id="path14"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Canada"
              d="m 565.2,105.7 -7.2,3.2 -3,-0.2 v -1.5 l 5,-2.7 6,0.1 z"
              id="path15"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Canada"
              d="m 562.1,88.9 -0.9,2.5 2.7,-0.9 1.5,1.5 3.5,2 3.8,1.7 -1.4,2.7 3.5,-0.4 1.9,1.9 -5,1.8 -5.9,-1.4 -0.8,-2.6 -6.3,3.1 -8.2,2.9 0.7,-3.3 -6.3,0.5 5.7,-2.8 3.6,-4.5 5.1,-5.1 z"
              id="path16"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Canada"
              d="m 607,80.6 -4.9,0.3 0.7,-2.7 3.8,-3.1 4.3,-0.7 2.3,1.5 -1.5,2.3 -0.9,0.8 z"
              id="path17"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Canada"
              d="m 532.5,69.9 -4.1,1.9 -4.2,-1.6 -3.9,0.5 -3.4,-2.4 5,-1.7 4.9,-2.3 3,1.5 1.6,1 0.4,1 z"
              id="path18"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Canada"
              d="m 585.5,212.5 -2.2,-3.6 2.9,-8.5 -1.6,-1.8 -3.7,1 -1.1,-1.6 -5.5,4.7 -3.2,4.9 -2.8,2.9 -2.5,1 -1.7,0.3 -1.1,1.5 h -9.3 l -7.8,0.1 -2.7,1.1 -6.8,4.4 v -0.1 l -0.9,-0.4 -2,0.9 -1.9,1.3 -1.8,-1.1 -4.7,0.8 -3.9,0.9 -1.9,0.8 -2.3,2.1 1.8,0.7 1.7,-0.4 h 0.3 l -0.3,1.9 -4.8,0.7 -2.8,0.8 -1.7,1 -2.6,-0.6 -1.6,0.3 -2.9,1.8 -4.6,2 -2.7,-0.4 2,-2.2 3.7,-3.5 4.1,-2.1 1.1,-1.8 0.9,-3 3.8,-3.5 0.9,-4 1.1,3.9 3.8,0.9 2.4,-2.1 -1.4,-4.8 -0.9,-2 -4,-1.2 -3.8,-0.7 h -3.9 l -3.4,-0.8 -0.4,-1.4 -1.4,0.9 -1.2,-0.2 1.9,-2.1 -1.8,-0.8 1.9,-2.4 -1.2,-1.8 1.7,-1.8 -5.2,-0.9 -0.1,-3.6 -0.8,-0.8 -3.3,-0.2 -4.1,-1.2 -1.5,0.8 -1.8,1.5 -3.3,1 -3.1,2.5 -5.4,-1.7 -4.4,0.8 -3.9,-1.9 -4.6,-1 -3.3,-0.4 -1,-1 0.9,-3.4 h -1.7 l -1.3,2.4 h -10.2 -17 -16.8 -14.9 -14.8 -14.7 -15.1 -4.8 -14.7 -14.1 -0.7 l -5.4,-6.1 -1.6,-2.7 -7,-2.6 1.3,-5.5 3.6,-3.7 -4.1,-2.7 3.1,-4.9 -2.1,-4.4 2.5,-3.2 5.1,-2.9 3.2,-3.8 -4.6,-3.8 1.4,-6.9 1.1,-4.2 -1.6,-2.7 -0.8,-2.4 0.6,-3.1 -6.5,1.9 -7.6,3.3 -0.3,-3.8 -0.5,-2.6 -2.8,-1.6 -4.2,-0.2 35.6,-32.7 24.6,-20.4 6,1.3 3.3,2.6 3.7,0.5 6.3,-2.2 7,-1.7 5.3,0.6 8.9,-2.3 8.2,-1.3 0.2,2.2 4.5,-1.3 3.9,-2.5 2.1,0.6 1.4,4.8 9.5,-3.7 -3.9,4.1 6,-0.9 3.2,-1.5 4.6,0.3 3.9,2.2 7.5,2 4.7,0.9 4.4,-0.3 2.9,2.8 -8.5,2.7 6.4,1.1 11.9,-0.6 4.4,-1 1.4,3.3 7.1,-2.7 -2.1,-2.4 4.5,-1.8 5.2,-0.3 3.9,-0.5 2.1,1.3 1.5,2.9 5,-0.4 5.3,2.5 7.2,-0.9 6,0.1 2.4,-3.4 4.5,-0.9 4.9,1.8 -4.3,5.2 6.2,-4.4 3.2,0.2 6.4,-5.5 -1.6,-3.3 -2.9,-2.2 5.5,-5.9 8.2,-3.8 4.5,0.9 2,2.3 0.4,6 -5.8,2.6 6.7,1.1 -4.4,5.5 8.9,-4.2 2.2,3.5 -4.3,4 1.3,3.7 7.3,-3.9 6.5,-4.8 4.7,-5.9 5.5,0.4 5.4,0.8 3.6,2.7 -1.7,2.7 -5.1,2.9 0.9,2.9 -2.4,2.7 -10.9,3.9 -6.5,0.9 -3.2,-1.7 -3.3,2.8 -7.4,4.7 -3,2.5 -7.7,3.8 -6.5,0.4 -5.1,2.4 -2.9,3.8 -5.7,0.7 -8.7,4.7 -9.4,6.5 -5,4.6 -4.9,6.9 6,1 -1.5,5.5 -0.8,4.6 7.3,-1.2 7,2.6 3.3,2.3 1.7,2.8 4.9,1.7 3.6,2.5 7.6,0.4 4.8,0.6 -3.6,5.2 -1.7,6.1 0.1,6.9 4.4,5.9 4.7,-2 5.6,-6.4 2.3,-9.6 -1.7,-3.2 9,-2.9 7.5,-4.2 4.8,-4.2 1.7,-4 -0.4,-5.1 -3.2,-4.5 8.9,-6.2 1,-5.3 3.9,-9 3.8,-1.4 6.7,1.6 4.2,0.6 4.5,-1.6 3.1,2 3.6,3.4 0.2,2.2 7.7,0.5 -2.6,4.9 -2.3,7.4 3.8,1 1.6,3.5 8.2,-3.3 7.5,-6.6 4.2,-2.7 1.1,5.3 2.6,7.5 2,7.2 -3.4,3.8 4.8,3.4 2.9,3.4 6.9,1.6 2.4,1.9 v 5.2 l 3.4,0.8 1.1,2.3 -2,6.9 -4.3,2.3 -4.2,2.2 -8.8,2.2 -7.9,5 -8.6,1.1 -10.1,-1.4 h -7.3 l -5.3,0.4 -5.7,4.5 -7.4,2.8 -10.1,8.2 -7.9,5.8 4.7,-1 10.9,-8.3 12.3,-5.2 7.6,-0.6 3.3,3.1 -6.1,4.2 -0.6,6.7 0.1,4.8 5.6,3.1 8.6,-0.9 7.2,-7.1 -1,4.6 2.5,2.3 -7.4,4.1 -12.4,3.8 -5.8,2.5 -7.2,4.6 -3.7,-0.5 1.5,-5.3 10.4,-5.3 -8.1,0.2 z"
              id="path19"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Canada"
              d="m 479,48.7 -4.7,2.4 10.5,-1.5 2.6,2.6 7.3,-2.7 1.8,1.7 -2.2,5.1 4.3,-2.1 2.8,-5.3 4.3,-0.8 3,0.8 2.2,2.1 -2.7,5.1 -2.4,3.7 4.2,2.6 5,2.6 -2.6,2.3 -7.1,0.5 0.8,2 -3.2,2 -6.7,-0.8 -5.7,-1.5 -5.1,0.3 -9.5,1.9 -11.3,0.8 -7.9,0.5 0.3,-2.6 -4.1,-1.4 -4.3,0.6 -0.6,-4.3 3.3,-0.6 7.3,-0.9 5.5,0.3 6.2,-1 -6.5,-1.2 -9.1,0.4 -5.7,-0.1 v -1.9 l 11.7,-2.2 -6.3,0.1 -5.4,-1.4 7.8,-3.9 5.2,-2.1 14.2,-3.1 z"
              id="path20"
            />
            <path onMouseOver={ev => doHover(ev)} data-name="Canada" d="m 518.5,47.2 -7,3.4 -2.3,-3.6 2.1,-0.8 5.5,-0.2 z" id="path21" />
            <path onMouseOut={ev => doOut(ev)} data-name="Canada" d="m 518.5,47.2 -7,3.4 -2.3,-3.6 2.1,-0.8 5.5,-0.2 z" id="path21" />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Canada"
              d="m 627.1,48.8 -0.7,1.4 -4.1,-0.1 -4.1,-0.1 -4.9,0.7 -0.9,-0.4 -2.1,-2.7 1.7,-1.8 2.2,-0.4 8.4,0.6 z"
              id="path22"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Canada"
              d="m 587.3,48.5 0.3,3.2 7.2,-4.1 11.7,-2.1 2.3,5.3 -3.2,3.4 9,-1.5 5.3,-2.1 6.8,2.6 3.7,2.5 -1.1,2.3 8.2,-1.2 1.9,3.4 8.4,2.1 2.2,2.1 0.9,5.1 -9.1,2.5 7.7,3.6 5.9,1.2 3.3,5 6.5,0.4 -3.3,3.9 -10.9,6.5 -4,-2.4 -3.8,-5.4 -5.9,0.7 -2.3,3.3 2.7,3.2 4.5,2.6 1,1.5 -0.1,5.7 -3.6,4.1 -4.7,-1.6 -8.6,-4.5 3.6,4.9 2.8,3.5 -0.3,2 -10.9,-2.3 -7.6,-3.4 -3.8,-2.7 2.4,-1.7 -4.8,-2.9 -4.7,-2.7 -0.9,1.6 -13.1,0.9 -2.4,-1.9 5.4,-4.2 8.1,-0.1 9.3,-0.7 -0.2,-2 3.1,-2.8 8.8,-5.4 0.4,-2.5 -0.5,-1.8 -4.7,-2.7 -7.1,-1.8 3.5,-1.4 -2,-3.4 -3.4,-0.3 -1.9,-1.8 -3.3,1.6 -7.9,0.7 -14,-1.2 -7.4,-1.6 -5.9,-0.8 -1.9,-1.9 6.3,-2.4 h -5.7 l 3.3,-5.3 7.1,-4.6 6,-2.1 11.2,-1.4 z"
              id="path23"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Canada"
              d="m 536.9,45 3.6,1.1 7.6,-0.7 -0.5,1.5 -6.1,2.5 3.8,2.2 -5.2,4.7 -8.4,2 -3.4,-0.4 -0.9,-2 -5.9,-4 1.7,-1.7 7.4,0.6 -0.9,-3.3 z"
              id="path24"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Canada"
              d="m 559.5,50.5 -7.8,3.9 -4.4,-0.2 1.8,-4.6 2.6,-2.5 4.2,-2.2 5.2,-1.4 7.9,0.2 6.2,1.2 -10.1,4.6 z"
              id="path25"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Canada"
              d="m 443.7,57.7 -13.5,2.6 0.6,-2.3 -6,-2.8 4.4,-2.2 7.5,-3.8 7.6,-3.4 0.4,-3.1 14,-0.8 4.2,1.1 9.5,0.3 1.9,1.4 1.6,2.2 -6.5,1.3 -13.9,3.6 -9.2,3.7 z"
              id="path26"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Canada"
              d="m 568.9,39.3 -4.1,1.9 -5.2,-0.4 -3.2,-1.3 4.5,-2.2 6.9,-1.4 1.4,1.8 z"
              id="path27"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Canada"
              d="m 560.1,30.6 0.2,2.3 -2.8,2.5 -5.8,3.8 -6.9,0.5 -3.2,-0.8 3.4,-2.9 -6.6,0.3 4.3,-3.8 3.8,0.2 7.7,-1.7 4.9,0.3 z"
              id="path28"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Canada"
              d="m 520.7,33.2 -0.7,1.7 4.4,-0.8 3.6,0.2 -2.3,2.5 -5.1,2.3 -13.9,0.8 -12.3,2.2 -6,0.1 1.5,-1.6 10.7,-2.3 -17.9,0.6 -4.2,-0.9 11.7,-4.8 5.4,-1.4 8.3,1.7 2.9,2.9 6.1,0.4 0.7,-4.7 5.8,-1.8 3.1,0.5 z"
              id="path29"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Canada"
              d="m 576.4,28.8 2.3,1.6 h 7.4 l 1.4,1.6 -2.8,1.8 3.1,1.1 1.2,1.2 4.9,0.2 5.1,0.4 7.1,-1 8.1,-0.5 5.8,0.4 2.3,1.9 -1,2 -3.6,1.4 -6.7,1.1 -4.3,-0.7 -11.8,0.8 -8,0.1 -5.6,-0.6 -8.6,-1.6 1.6,-2.8 2.1,-2.4 -1.4,-2.2 -7,-0.6 -2.6,-1.5 3.8,-2 z"
              id="path30"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Canada"
              d="m 500.7,26.2 -5.8,3.7 -5.3,1.7 -3.8,0.2 -9.9,2.1 -7.1,0.8 -3.6,-1.1 11.7,-3.7 12.2,-3.1 5.5,0.1 z"
              id="path31"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Canada"
              d="m 581.9,26.8 -1.8,0.1 -6.6,-0.3 0.7,-1.3 7.2,0.1 1.6,0.8 z"
              id="path32"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Canada"
              d="m 523.1,25.9 -8.8,1.4 -3.3,-1.5 5.1,-1.5 6,-0.5 4.1,0.7 z"
              id="path33"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Canada"
              d="m 530.9,21.7 -5.7,0.9 h -6 l 1,-0.7 5.7,-1.3 1.7,0.2 z"
              id="path34"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Canada"
              d="m 577.7,24.2 -6.6,1 -1.6,-1.1 0.6,-1.7 2.2,-1.9 4.4,0.2 1.7,0.3 2.3,1.6 z"
              id="path35"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Canada"
              d="m 563.9,23 -1.1,1.9 -5.3,-0.5 -4,-1.5 -7.8,-0.2 5.3,-1.3 -2.8,-1.1 2.2,-1.8 6.1,0.6 7.5,1.7 z"
              id="path36"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Canada"
              d="m 618,16.9 2.7,1.5 -6.5,1.3 -10.6,3.5 -6.8,0.3 -6.8,-0.6 -1.6,-1.9 2.1,-1.6 4.3,-1.2 h -6.6 l -2,-1.5 0.4,-1.9 4.9,-1.9 4.1,-1.3 4,-0.3 -0.3,-1 8.3,-0.2 1.6,2.2 4.7,0.9 4.8,0.9 z"
              id="path37"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Canada"
              d="m 697.2,2.9 8.7,0.3 6.7,0.5 5.2,1 -1.1,1 -9.8,1.7 -9,0.8 -4,0.9 h 7.5 l -10.5,2.5 -6.8,1.2 -9.3,3.5 -8.1,0.7 -3.1,1 -11.3,0.4 4.4,0.6 -3.3,0.8 0.7,2.3 -5,1.6 -6.9,1.3 -3.5,1.8 -6.6,1.5 -0.5,1.1 6.5,-0.2 -1.1,1.2 -12.7,2.9 -8.5,-1.4 -11.7,0.8 -5,-0.6 -6.8,-0.3 2.1,-2.3 8,-1.1 2,-3.4 2.6,-0.3 7.5,2 -1.7,-3 -4.9,-0.9 5,-1.8 7.6,-1.1 2.8,-1.6 -3,-1.7 1.1,-2.2 9.4,0.1 2.2,0.5 7.3,-1.6 -7.3,-0.5 -12.6,0.3 -4.4,-1.4 -0.8,-1.7 -2.5,-1.2 1.1,-1.3 6,-0.8 4.2,-0.1 7.4,-0.6 6.8,-1.5 3.9,0.2 2.4,1.1 5,-2 5.2,-0.6 6.5,-0.4 10.4,-0.2 1.3,0.4 10.3,-0.6 7,0.2 z"
              id="path38"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 974.4,197.5 0.2,1.1 -0.7,1.5 2.3,1.2 2.6,0.2 -0.3,2.5 -2.1,1.1 -3.8,-0.8 -1,2.5 -2.4,0.2 -0.9,-1 -2.7,2.2 -2.5,0.3 -2.2,-1.4 -1.8,-2.7 -2.4,1 v -2.9 l 3.6,-3.5 -0.2,-1.6 2.3,0.6 1.3,-1.1 h 4.2 l 1,-1.3 z"
              id="CH"
              data-name="Switzerland"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="China"
              d="m 1542.2,381.9 -4.3,3.1 -4.9,-2 -1,-5.5 2.2,-2.9 5.8,-1.8 3.3,0.1 1.6,2.5 -2,2.8 z"
              id="path39"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="China"
              d="m 1565.6,185.5 9,4.5 6,5.8 h 7.6 l 2.6,-2.4 6.9,-1.9 1.3,5.7 -0.3,2.3 2.8,6.8 0.6,6.2 -6.9,-1.1 -2.9,2.2 4.7,5.4 3.9,7.5 -2.5,0.1 1.9,3.3 -5.5,-3.8 v 3.6 l -6.4,2.7 2.8,3.4 -4.6,-0.3 -3.6,-2 -1.1,4.6 -3.9,3.4 -2.1,4.1 -6.3,1.8 -2.4,3 -4.8,1.8 1.3,-3 -2.3,-2.5 2,-4.3 -4.5,-3.3 -3.4,2.2 -3.6,4.5 -1.3,4.1 -5,0.3 -1.3,3 4.8,4.3 4.8,1.1 1.4,2.8 5.1,1.9 3.8,-4.6 5.9,2.5 3.5,0.2 2.3,3.3 -6.7,1.8 -1,3.5 -3.8,3.2 -0.9,4.5 7.1,3.5 4.6,6.3 5.5,5.9 5.5,4.9 1.6,4.8 -2.8,1.8 2.4,3.4 3.9,2 0.8,5.2 0.1,5.1 -2.8,0.6 -2.1,6.9 -2.3,8.5 -3.4,7.6 -6.4,5.9 -6.6,5.5 -6.1,0.7 -2.9,2.8 -2.3,-2 -2.5,3.1 -7.2,3.3 -5.8,0.9 -0.7,6.8 -3.1,0.4 -2.2,-4.7 0.9,-2.4 -7.8,-2.1 -2.4,1.1 -5.9,-1.7 -3.1,-2.6 0.3,-3.7 -5.3,-1.2 -3.1,-2.4 -4.1,3.4 -5.3,0.8 -4.4,-0.1 -2.7,1.6 -2.7,0.9 2,7.4 -3,-0.2 -0.8,-1.5 -0.5,-2.7 -3.8,1.9 -2.6,-1.2 -4.5,-2.4 0.8,-5.3 -3.7,-1.3 -2.4,-5.9 -5.6,1.1 -0.7,-7.6 4.2,-5.4 -0.9,-5.3 -1.3,-4.9 -2.7,-1.5 -2.7,-3.8 -3.1,0.5 -6.1,-1 1.2,-2.7 -3.6,-4 -3.2,2.7 -4.9,-1.5 -5.4,4 -3.9,4.8 -4.2,0.8 -2.8,-1.7 -2.9,-0.2 -4.3,-1.4 -2.6,1.6 -2.6,4.8 -1.5,-5.1 -3.1,1.4 -6.5,-0.7 -6.5,-1.4 -5,-2.9 -4.5,-1.2 -2.5,-3.1 -3.3,-0.9 -6.4,-4.2 -4.8,-2 -1.9,1.5 -8.6,-4.5 -6.2,-4 -3.2,-7.1 4.1,0.9 -0.6,-3.3 -3,-3.3 -0.8,-5.2 -7.7,-7.6 -9.5,-2.5 -2.9,-5 -4.7,-3 -1.5,-1.8 -1.8,-3.6 -0.5,-2.5 -3.7,-1.5 -1.5,0.7 -3.1,-6 1.1,-1.4 -1.2,-1.5 4.1,-3 3.2,-1.3 5.8,0.9 0.6,-4.1 6.4,-0.7 1,-2.6 6.9,-3.4 0.2,-1.4 -1.7,-3.7 2.9,-1.6 -8.8,-11 9.1,-2.5 2,-1.4 -1,-11.3 10.8,2.1 1.6,-2.9 -2.5,-6.2 3.8,-0.6 1.9,-4.2 1.7,-0.5 3.3,4.4 5.7,3.3 8.2,2.3 5.8,5.1 1.4,7.3 3,2.8 6.5,1.1 7.2,0.8 8,4 3.4,0.7 5,5.8 4.7,3.8 5.6,-0.2 11.3,1.5 6.4,-0.9 5.6,0.9 9.4,3.9 h 6.2 l 3.3,1.9 4.4,-3.4 7.2,-2.2 7.6,-0.2 4.9,-2.2 2,-3.4 2.4,-2.2 -1.9,-2.1 -2.9,-2.4 0.5,-4.1 3.2,0.6 5.9,1.3 3.2,-3.4 6.4,-2.4 1.3,-4.2 2.5,-1.8 6.8,-0.8 4.4,0.7 -0.8,-2.2 -7.2,-4.4 -5.2,-2 -2.5,2.3 -5.5,-1 -2.3,0.8 -2.8,-2.5 -0.3,-6.3 -0.6,-4.7 7.4,2.4 4.4,-3.9 -1.9,-2.8 -0.2,-6.5 1.3,-2 -2.5,-3.4 -3.7,-1.4 1.7,-3.1 5.1,-1.1 6.2,-0.2 8.6,1.9 6,2.2 7.7,6.2 3.8,2.7 4.5,3.8 6.2,6 z"
              id="path40"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 895.9,435.2 2.5,1.4 1,2.2 2.5,1.3 2,-1.6 2.6,-0.2 3.9,1.6 1.5,9.2 -2.4,5.3 -1.5,7.3 2.4,5.5 -0.2,2.6 h -2.6 l -3.9,-1.2 H 900 l -6.7,1.2 -3.9,1.8 -5.6,2.4 -1.1,-0.2 0.4,-5.3 0.6,-0.8 -0.2,-2.5 -2.4,-2.7 -1.8,-0.4 -1.6,-1.8 1.2,-2.9 -0.5,-3.1 0.2,-1.8 h 0.9 l 0.4,-2.8 -0.4,-1.3 0.5,-0.9 2.1,-0.7 -1.4,-5.2 -1.3,-2.6 0.5,-2.2 1.1,-0.5 0.8,-0.6 1.5,1 h 4.4 l 1,-1.8 1,0.1 1.6,-0.7 0.9,2.7 1.3,-0.8 z"
              id="CI"
              data-name="Côte d’Ivoire"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1012.8,454.2 -2.8,6.5 -1.4,1.1 -0.4,5 0.6,2.7 -0.5,1.9 2.7,3.4 0.5,2.3 2.1,3.3 2.6,2.1 0.3,2.9 0.6,1.9 -0.4,3.4 -4.5,-1.5 -4.6,-1.7 -7.1,-0.2 -0.7,-0.4 -3.4,0.8 -3.4,-0.8 -2.7,0.4 -9.3,-0.1 0.9,-5.1 -2.3,-4.3 -2.6,-1 -1.1,-2.9 -1.5,-0.9 0.1,-1.8 1.4,-4.6 2.7,-6.2 h 1.6 l 3.4,-3.8 2.1,-0.1 3.2,2.7 3.9,-2.2 0.5,-2.7 1.3,-2.6 0.8,-3.2 3,-2.6 1.1,-4.5 1.2,-1.5 0.8,-3.3 1.4,-4.1 4.7,-5 0.3,-2.1 0.6,-1.2 -2.3,-2.5 0.2,-2.1 1.5,-0.3 2.3,4.1 0.5,4.2 -0.2,4.3 3.2,5.8 h -3.2 l -1.6,0.4 -2.6,-0.6 -1.2,3 3.4,3.8 2.5,1.1 0.8,2.6 1.8,4.4 z"
              id="CM"
              data-name="Cameroon"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1081.3,468.2 3.5,5.3 2.6,0.8 1.5,-1.1 2.6,0.4 3.1,-1.3 1.4,2.7 5.1,4.3 -0.3,7.5 2.3,0.9 -1.9,2.2 -2.1,1.8 -2.2,3.3 -1.2,3 -0.3,5.1 -1.3,2.5 -0.1,4.8 -1.6,1.8 -0.2,3.8 -0.8,0.5 -0.6,3.6 1.4,2.9 0.1,1 -1.2,10.3 1.5,3.6 -1,2.7 1.8,4.6 3.4,3.5 0.7,3.5 1.6,1.7 -0.3,1.1 -0.9,-0.3 -7.7,1.1 -1.5,0.8 -1.7,4.1 1.2,2.8 -1.1,7.6 -0.9,6.4 1.5,1.2 3.9,2.5 1.6,-1.2 0.2,6.9 h -4.3 l -2.2,-3.5 -2,-2.8 -4.3,-0.9 -1.2,-3.3 -3.5,2 -4.4,-0.9 -1.9,-2.9 -3.5,-0.6 -2.7,0.1 -0.3,-2 -1.9,-0.1 -2.6,-0.4 -3.5,1 -2.4,-0.2 -1.4,0.6 0.4,-7.6 -1.8,-2.4 -0.4,-4 0.9,-3.9 -1.1,-2.4 -0.1,-4.1 -6.8,0.1 0.5,-2.3 h -2.9 l -0.3,1.1 -3.5,0.3 -1.5,3.7 -0.9,1.6 -3.1,-0.9 -1.8,0.9 -3.8,0.5 -2.1,-3.3 -1.3,-2.1 -1.6,-3.9 -1.3,-4.7 -16.7,-0.1 -2,0.7 -1.7,-0.1 -2.3,0.9 -0.8,-2 1.4,-0.7 0.2,-2.8 1,-1.6 2,-1.4 1.5,0.7 2,-2.5 3.1,0.1 0.3,1.8 2.1,1.1 3.4,-4 3.3,-3.1 1.4,-2.1 -0.1,-5.3 2.5,-6.2 2.6,-3.3 3.7,-3.1 0.7,-2 0.1,-2.4 0.9,-2.2 -0.3,-3.7 0.7,-5.7 1.1,-4 1.7,-3.4 0.3,-3.9 0.5,-4.5 2.2,-3.2 3,-2.1 4.7,2.2 3.6,2.4 4.1,0.6 4.3,1.3 1.6,-3.9 0.8,-0.5 2.6,0.6 6.3,-3.2 2.2,1.4 1.8,-0.2 0.9,-1.6 2.1,-0.5 4.2,0.7 3.7,0.1 z"
              id="CD"
              data-name="Congo (DRC)"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1030.9,479.3 -0.3,3.9 -1.7,3.4 -1.1,4 -0.7,5.7 0.3,3.7 -0.9,2.2 -0.1,2.4 -0.7,2 -3.7,3.1 -2.6,3.3 -2.5,6.2 0.1,5.3 -1.4,2.1 -3.3,3.1 -3.4,4 -2.1,-1.1 -0.3,-1.8 -3.1,-0.1 -2,2.5 -1.5,-0.7 -2.1,-2.2 -1.7,1.1 -2.3,2.8 -4.6,-6.8 4.3,-3.6 -2.1,-4.2 2,-1.6 3.8,-0.8 0.4,-2.9 3.1,3.1 5,0.3 1.7,-3 0.7,-4.3 -0.6,-5 -2.7,-3.8 2.5,-7.5 -1.4,-1.2 -4.2,0.5 -1.6,-3.3 0.4,-2.8 7.1,0.2 4.6,1.7 4.5,1.5 0.4,-3.4 3,-6 3.3,-3.4 3.9,1.1 z"
              id="CG"
              data-name="Republic of the Congo"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 524.4,426.2 -3.7,1.1 -1.6,3.2 -2.3,1.8 -1.8,2.4 -0.9,4.6 -1.8,3.8 2.9,0.4 0.6,2.9 1.2,1.5 0.3,2.5 -0.7,2.4 0.1,1.4 1.4,0.5 1.2,2.2 7.3,-0.6 3.3,0.8 3.8,5.6 2.3,-0.7 4.1,0.3 3.2,-0.7 2,1.1 -1.2,3.4 -1.3,2.2 -0.6,4.6 1.1,4.3 1.5,1.9 0.2,1.4 -2.9,3.2 2,1.4 1.5,2.3 1.6,6.4 -1.1,0.8 -1,-3.8 -1.6,-2.1 -1.9,2.3 -11,-0.2 v 4 l 3.3,0.7 -0.2,2.5 -1.1,-0.7 -3.2,1 -0.1,4.7 2.6,2.4 0.9,3.6 -0.1,2.8 -2.2,17.6 -2.9,-3.4 -1.7,-0.1 3.5,-6.6 -4.4,-3 -3.4,0.6 -2.1,-1.1 -3.1,1.7 -4.2,-0.9 -3.5,-6.7 -2.6,-1.6 -1.8,-3.1 -3.8,-3 -1.5,0.6 -2.4,-1.5 -2.8,-2.1 -1.6,1 -4.8,-0.9 -1.4,-2.8 -1.1,0.1 -5.6,-3.6 -0.7,-2 2.1,-0.5 -0.2,-3.2 1.4,-2.4 2.8,-0.4 2.5,-4 2.2,-3.4 -2,-1.5 1.2,-3.7 -1.1,-5.9 1.3,-1.7 -0.7,-5.4 -2.2,-3.5 0.9,-3.1 1.8,0.5 1.1,-1.9 -1.1,-3.8 0.7,-0.9 2.9,0.2 4.5,-4.5 2.4,-0.7 0.1,-2.1 1.4,-5.5 3.4,-2.9 3.5,-0.2 0.6,-1.3 4.4,0.5 4.6,-3.2 2.3,-1.4 2.9,-3.1 2,0.4 1.3,1.7 z"
              id="CO"
              data-name="Colombia"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 454.6,431.6 1.2,3.5 2,2.6 2.5,2.7 -2.2,0.6 -0.1,2.6 1.1,0.9 -0.9,0.8 0.2,1.1 -0.6,1.3 -0.3,1.3 -3,-1.4 -1.1,-1.4 0.7,-1.1 -0.1,-1.4 -1.5,-1.5 -2.2,-1.3 -1.8,-0.8 -0.3,-1.9 -1.4,-1.1 0.2,1.8 -1.2,1.6 -1.2,-1.8 -1.7,-0.7 -0.7,-1.2 0.1,-2 0.9,-2 -1.5,-0.9 1.4,-1.3 0.9,-0.8 3.6,1.7 1.3,-0.8 1.8,0.5 0.8,1.3 1.7,0.5 z"
              id="CR"
              data-name="Costa Rica"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 484.8,355.7 1.9,2.3 5.2,-0.7 1.8,1.5 4.2,4 3.2,2.9 1.8,-0.1 3.2,1.3 -0.6,1.8 4,0.3 3.9,2.6 -0.8,1.5 -3.8,0.8 -3.8,0.3 -3.7,-0.5 -8.1,0.6 4.2,-3.5 -2.1,-1.7 -3.6,-0.4 -1.7,-1.9 -0.8,-3.6 -3.2,0.2 -5,-1.7 -1.5,-1.4 -7.1,-1 -1.8,-1.2 2.3,-1.6 -5.4,-0.3 -4.4,3.3 -2.3,0.1 -1,1.6 -2.8,0.7 -2.3,-0.7 3.2,-1.9 1.5,-2.4 2.7,-1.4 3,-1.2 4.3,-0.6 1.4,-0.8 4.7,0.5 4.4,0.1 z"
              id="CU"
              data-name="Cuba"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 999.7,175.2 2.5,2 3.7,0.5 -0.2,1.7 2.8,1.3 0.6,-1.6 3.4,0.7 0.7,2 3.7,0.3 2.6,3.1 h -1.5 l -0.7,1.1 -1.1,0.3 -0.2,1.4 -0.9,0.3 -0.1,0.6 -1.6,0.6 -2.2,-0.1 -0.6,1.4 -2.4,-1.2 -2.3,0.3 -4,-1.9 -1.7,0.5 -2.6,2.6 -3.8,-2.1 -3,-2.6 -2.6,-1.5 -0.7,-2.7 -1,-1.8 3.4,-1.3 1.7,-1.6 3.5,-1.2 1.1,-1.2 1.3,0.7 z"
              id="CZ"
              data-name="Czechia"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 993.9,158.9 1.4,3.1 -1.2,1.7 1.9,2.1 1.5,3.3 -0.2,2.2 2.4,3.9 -2.2,0.6 -1.3,-0.7 -1.1,1.2 -3.5,1.2 -1.7,1.6 -3.4,1.3 1,1.8 0.7,2.7 2.6,1.5 3,2.6 -1.6,2.9 -1.7,0.8 1,4.1 -0.4,1.1 -1.7,-1.3 -2.4,-0.2 -3.5,1.1 -4.4,-0.3 -0.6,1.7 -2.7,-1.7 -1.4,0.3 -5.5,-1.9 -1,1.3 h -4.2 l 0.4,-4.5 2.4,-4.2 -7.2,-1.2 -2.4,-1.6 0.2,-2.7 -1,-1.4 0.4,-4.2 -1.1,-6.5 h 2.9 l 1.2,-2.3 0.9,-5.6 -0.9,-2.1 0.8,-1.3 4,-0.3 1,1.3 3.1,-3 -1.3,-2.3 -0.4,-3.4 3.7,0.8 2.9,-0.9 0.3,2.3 4.9,1.4 0.1,2.2 4.7,-1.2 2.6,-1.6 5.6,2.4 z"
              id="DE"
              data-name="Germany"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1169.5,428.2 -1.9,3.5 -1.3,-1.2 -1.3,0.5 -3.2,-0.1 -0.2,-2 -0.5,-1.8 1.8,-3 1.9,-2.8 2.4,0.6 1.7,-1.6 1.4,2 -0.1,2.6 -3.1,1.6 z"
              id="DJ"
              data-name="Djibouti"
            />
            <path onMouseOver={ev => doHover(ev)} data-name="Denmark" d="m 986.1,147.7 -2.4,4.9 -5.2,-3.5 -0.9,-2.5 6.8,-2 z" id="path41" />
            <path onMouseOut={ev => doOut(ev)} data-name="Denmark" d="m 986.1,147.7 -2.4,4.9 -5.2,-3.5 -0.9,-2.5 6.8,-2 z" id="path41" />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Denmark"
              d="m 973.3,151.5 -2.9,0.9 -3.7,-0.8 -2.1,-3.4 -0.4,-6.1 0.6,-1.7 1.3,-1.8 4,-0.3 1.6,-1.7 3.6,-1.7 v 3.1 l -1.2,2 0.7,1.6 2.6,0.9 -1,2.3 -1.4,-0.6 -3.1,4.3 z"
              id="path42"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 525.7,386 0.3,-1.8 -1.3,-1.9 1.5,-1.1 0.7,-2.5 -0.1,-3.4 0.8,-1.1 h 4.3 l 3.2,1.6 1.5,-0.1 0.7,2.3 3.1,-0.2 -0.4,1.9 2.5,0.3 2.5,2.3 -2.3,2.6 -2.6,-1.4 -2.6,0.3 -1.8,-0.3 -1.1,1.2 -2.2,0.4 -0.7,-1.6 -1.9,0.9 -2.7,4.4 -1.3,-1 z"
              id="DO"
              data-name="Dominican Republic"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 971,264.6 -1,3.3 1,6.1 -1.1,5.3 -3.2,3.6 0.6,4.8 4.5,3.9 0.1,1.5 3.4,2.6 2.6,11.5 1.9,5.7 0.4,3 -0.8,5.2 0.4,3 -0.6,3.5 0.6,4 -2.2,2.7 3.4,4.7 0.2,2.7 2.1,3.6 2.5,-1.2 4.5,3 2.5,4 -18.8,12.3 -16,12.6 -7.8,2.8 -6.2,0.7 -0.1,-4.1 -2.6,-1.1 -3.5,-1.8 -1.3,-3 -18.7,-14 -18.6,-14 -20.5,-15.6 0.1,-1.2 0.1,-0.4 0.1,-7.6 8.9,-4.8 5.4,-1 4.5,-1.7 2.1,-3.2 6.4,-2.5 0.3,-4.8 3.1,-0.6 2.5,-2.3 7.1,-1.1 1,-2.5 -1.4,-1.4 -1.9,-6.8 -0.3,-3.9 -1.9,-4.1 5.1,-3.5 5.8,-1.1 3.3,-2.6 5.1,-2 9,-1.1 8.8,-0.5 2.7,0.9 4.9,-2.5 5.7,-0.1 2.2,1.5 z"
              id="DZ"
              data-name="Algeria"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 499,502.8 0.8,4.9 -1.7,4.1 -6.1,6.8 -6.7,2.5 -3.4,5.6 -0.9,4.3 -3.1,2.7 -2.5,-3.3 -2.3,-0.7 -2.3,0.5 -0.3,-2.3 1.6,-1.5 -0.7,-2.7 2.9,-4.8 -1.3,-2.8 -2.1,3 -3.5,-2.9 1.1,-1.8 -1,-5.8 2,-1 1,-4 2.1,-4.1 -0.3,-2.6 3.1,-1.4 3.9,-2.5 5.6,3.6 1.1,-0.1 1.4,2.8 4.8,0.9 1.6,-1 2.8,2.1 z"
              id="EC"
              data-name="Ecuador"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1112.1,301.4 3.9,9.4 0.7,1.6 -1.3,2.6 -0.7,4.8 -1.2,3.4 -1.2,1.1 -2,-2.1 -2.7,-2.8 -4.7,-9.2 -0.5,0.6 2.8,6.7 3.9,6.5 4.9,10 2.3,3.5 2,3.6 5.4,7.1 -1,1.1 0.4,4.2 6.8,5.8 1.1,1.3 h -22.1 -21.5 -22.3 l -1,-23.7 -1.3,-22.8 -2,-5.2 1.1,-3.9 -1,-2.8 1.7,-3.1 7.2,-0.1 5.4,1.7 5.5,1.9 2.6,1 4,-2 2.1,-1.8 4.7,-0.6 3.9,0.8 1.8,3.2 1.1,-2.1 4.4,1.5 4.3,0.4 z"
              id="EG"
              data-name="Egypt"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1168.9,420.3 -1.7,1.6 -2.4,-0.6 -2,-2.1 -2.5,-3.7 -2.6,-2.1 -1.5,-2.2 -5,-2.6 -3.9,-0.1 -1.4,-1.3 -3.2,1.5 -3.6,-2.9 -1.5,4.8 -6.6,-1.4 -0.7,-2.5 2,-9.5 0.3,-4.2 1.7,-2 4,-1.1 2.7,-3.6 3.6,7.4 1.9,5.9 3.2,3.1 8,6.1 3.3,3.6 3.2,3.8 1.8,2.2 z"
              id="ER"
              data-name="Eritrea"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1053.7,124.6 0.9,1 -2.6,3.4 2.4,5.6 -1.6,1.9 -3.8,-0.1 -4.4,-2.2 -2.1,-0.7 -3.8,1 -0.1,-3.5 -1.5,0.8 -3.3,-2.1 -1,-3.4 5.5,-1.7 5.6,-0.8 5.1,0.9 z"
              id="EE"
              data-name="Estonia"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1147.3,408.5 3.9,0.1 5,2.6 1.5,2.2 2.6,2.1 2.5,3.7 2,2.1 -1.9,2.8 -1.8,3 0.5,1.8 0.2,2 3.2,0.1 1.3,-0.5 1.3,1.2 -1.2,2.2 2.2,3.6 2.2,3.1 2.2,2.3 18.7,7.6 4.8,-0.1 -15.6,19.3 -7.3,0.3 -5,4.5 -3.6,0.1 -1.5,2.1 h -3.9 l -2.3,-2.2 -5.2,2.7 -1.6,2.7 -3.8,-0.6 -1.3,-0.7 -1.3,0.2 -1.8,-0.1 -7.2,-5.4 h -4 l -1.9,-2.1 -0.1,-3.6 -2.9,-1.1 -3.5,-7 -2.6,-1.5 -1,-2.6 -3,-3.1 -3.5,-0.5 1.9,-3.6 3,-0.2 0.8,-1.9 -0.2,-5 v -0.8 l 1.5,-6.7 2.6,-1.8 0.5,-2.6 2.3,-5 3.3,-3.1 2,-6.4 0.7,-5.5 6.6,1.4 1.5,-4.8 3.6,2.9 3.2,-1.5 z"
              id="ET"
              data-name="Ethiopia"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1044.1,70.1 0.4,3.8 7.3,3.7 -2.9,4.2 6.5,6.3 -1.7,4.8 4.9,4.2 -0.9,3.8 7.4,3.9 -0.9,2.9 -3.4,3.4 -8,7.4 -8,0.5 -7.6,2.1 -7.1,1.3 -3.2,-3.2 -4.7,-1.9 0.1,-5.8 -3,-5.2 1.6,-3.4 3.3,-3.5 8.8,-6.2 2.6,-1.2 -0.9,-2.4 -6.5,-2.6 -1.8,-2.2 -1.8,-8.5 -7.2,-3.7 -6,-2.7 2.2,-1.4 5.1,2.8 5.3,-0.2 4.7,1.3 3.4,-2.4 1.1,-4 5.9,-1.8 5.8,2.1 z"
              id="FI"
              data-name="Finland"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1000.5,487.3 -0.4,2.8 1.6,3.3 4.2,-0.5 1.4,1.2 -2.5,7.5 2.7,3.8 0.6,5 -0.7,4.3 -1.7,3 -5,-0.3 -3.1,-3.1 -0.4,2.9 -3.8,0.8 -2,1.6 2.1,4.2 -4.3,3.6 -5.8,-6.5 -3.7,-5.3 -3.5,-6.6 0.2,-2.2 1.3,-2 1.3,-4.7 1.2,-4.8 1.9,-0.3 h 8.2 v -7.7 l 2.7,-0.4 3.4,0.8 3.4,-0.8 z"
              id="GA"
              data-name="Gabon"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="United Kingdom"
              d="m 896.7,158.2 -3.5,-1.2 -3,0.1 1.2,-3.3 -0.9,-3.2 4,-0.3 4.9,3.8 z"
              id="path43"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="United Kingdom"
              d="m 912.6,129.5 -5.1,6.5 4.7,-0.8 h 5.1 l -1.3,4.9 -4.3,5.4 4.9,0.3 0.3,0.7 4.2,7.1 3.2,1 2.9,7 1.4,2.4 5.9,1.1 -0.6,4 -2.4,1.8 1.9,3.2 -4.4,3.2 -6.5,-0.1 -8.4,1.8 -2.2,-1.3 -3.3,2.9 -4.5,-0.7 -3.6,2.4 -2.5,-1.2 7.3,-6.5 4.4,-1.4 -7.6,-1 -1.3,-2.5 5.1,-1.9 -2.5,-3.3 1,-4 7.1,0.6 0.8,-3.6 -3.1,-3.7 -0.1,-0.1 -5.7,-1.1 -1.1,-1.6 1.8,-2.7 -1.5,-1.7 -2.6,2.9 -0.1,-5.9 -2.2,-3 1.9,-6.2 3.8,-4.8 3.6,0.4 z"
              id="path44"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1155.7,227.9 5.1,1.3 2.1,2.6 3.6,1.5 -1.2,0.8 3.3,3.5 -0.6,0.7 -2.9,-0.3 -4.2,-1.9 -1.1,1.1 -7,1 -5.6,-3.2 -5.5,0.3 0.3,-2.7 -2.1,-4.3 -3.4,-2.4 -3,-0.7 -2.2,-1.9 0.4,-0.8 4.6,1.1 7.7,1 7.6,3.1 1.2,1.2 z"
              id="GE"
              data-name="Georgia"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 926.5,431.1 -0.4,2 2.3,3.3 v 4.7 l 0.6,5 1.4,2.4 -1.3,5.7 0.5,3.2 1.5,4.1 1.3,2.3 -8.9,3.7 -3.2,2.2 -5.1,1.9 -5,-1.8 0.2,-2.6 -2.4,-5.5 1.5,-7.3 2.4,-5.3 -1.5,-9.2 -0.8,-4.8 0.2,-3.7 9.8,-0.3 2.5,0.5 1.8,-1 z"
              id="GH"
              data-name="Ghana"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 861.5,421.9 0.3,2.4 h 0.9 l 1.5,-0.9 0.9,0.2 1.6,1.7 2.4,0.5 1.5,-1.4 1.9,-0.9 1.3,-0.9 1.1,0.2 1.3,1.4 0.6,1.8 2.3,2.7 -1.1,1.6 -0.3,2.1 1.2,-0.6 0.7,0.7 -0.3,1.9 1.7,1.9 -1.1,0.5 -0.5,2.2 1.3,2.6 1.4,5.2 -2.1,0.7 -0.5,0.9 0.4,1.3 -0.4,2.8 h -0.9 l -1.6,-0.2 -1.1,2.6 h -1.6 l -1.1,-1.4 0.4,-2.6 -2.4,-3.9 -1.4,0.7 -1.3,0.2 -1.5,0.3 0.1,-2.3 -0.9,-1.7 0.2,-1.9 -1.2,-2.7 -1.6,-2.3 h -4.5 l -1.3,1.2 -1.6,0.2 -1,1.4 -0.6,1.7 -3.1,2.9 -2.4,-3.8 -2.2,-2.5 -1.4,-0.9 -1.4,-1.3 -0.6,-2.8 -0.8,-1.4 -1.7,-1.1 2.6,-3.1 1.7,0.1 1.5,-1 1.2,-0.1 0.9,-0.8 -0.4,-2.1 0.6,-0.7 0.1,-2.2 2.7,0.1 4.1,1.5 1.2,-0.1 0.4,-0.7 3.1,0.5 z"
              id="GN"
              data-name="Guinea"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 831.6,417.4 0.8,-2.9 6.1,-0.1 1.3,-1.6 1.8,-0.1 2.2,1.6 h 1.7 l 1.9,-1 1.1,1.8 -2.5,1.5 -2.4,-0.2 -2.4,-1.3 -2.1,1.5 h -1 l -1.4,0.9 z"
              id="GM"
              data-name="Gambia"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 849.2,421 -0.1,2.2 -0.6,0.7 0.4,2.1 -0.9,0.8 -1.2,0.1 -1.5,1 -1.7,-0.1 -2.6,3.1 -2.9,-2.6 -2.4,-0.5 -1.3,-1.8 0.1,-1 -1.7,-1.3 -0.4,-1.4 3,-1 1.9,0.2 1.5,-0.8 z"
              id="GW"
              data-name="Guinea-Bissau"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 990.3,487.3 v 7.7 h -8.2 l -1.9,0.3 -1.1,-0.9 1.9,-7.2 z"
              id="GQ"
              data-name="Equatorial Guinea"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Greece"
              d="m 1052.7,272.6 3.1,2.2 4.1,-0.4 4,0.4 v 1.2 l 2.8,-0.8 -0.5,1.9 -7.6,0.5 -0.1,-1 -6.6,-1.3 z"
              id="path45"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Greece"
              d="m 1061.9,239.9 -3.2,-0.2 -2.7,-0.6 -6.2,1.6 4,3.6 -2.5,1.1 h -2.9 l -3.1,-3.3 -0.9,1.4 1.6,3.8 2.9,3 -1.9,1.4 3.2,2.9 2.8,1.9 0.4,3.6 -5,-1.7 1.8,3.3 -3.3,0.6 2.5,5.7 -3.5,0.1 -4.6,-2.8 -2.4,-5.1 -1.3,-4.3 -2.3,-2.9 -3,-3.7 -0.5,-1.8 2.2,-3.1 0.1,-2.1 1.7,-0.9 -0.1,-1.7 3.4,-0.5 1.8,-1.4 2.8,0.1 0.8,-1.1 1,-0.2 3.8,0.2 4,-1.8 3.9,2.3 4.6,-0.6 -0.3,-3.2 2.7,1.7 -1.1,4 z"
              id="path46"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 836.3,1.4 19.9,3 -6.7,1.4 -13,0.2 -18.5,0.4 1.4,0.7 12.3,-0.5 9.7,1.4 7,-1.2 2.4,1.4 -4.5,2.4 9.2,-1.6 17.1,-1.5 10,0.8 1.7,1.7 -14.8,2.9 -2.2,1 -11.4,0.8 8.1,0.2 -4.9,3.2 -3.6,2.9 -1.2,5.2 3.7,3.2 -5.9,0.1 -6.5,1.6 6.3,2.6 -0.1,4.2 -4.2,0.5 4.1,4.3 -8.7,0.4 4,2 -1.6,1.8 -5.7,0.8 -5.5,0.1 4.2,3.4 -0.5,2.4 -7.3,-2.2 -2.4,1.4 5,1.3 4.6,3.2 0.6,4.3 -7.4,1 -2.7,-2.1 -4.2,-3 0.5,3.6 -5.4,2.8 10.7,0.2 5.5,0.3 -11.9,4.7 -12.2,4.3 -12.7,1.8 -4.6,0.1 -4.9,2.1 -7.5,5.8 -10.2,3.9 -3,0.3 -6.1,1.3 -6.6,1.4 -4.8,3.4 -1.4,4 -3.4,3.8 -8.6,4.6 0.3,4.5 -3.6,4.8 -4.1,5.7 -6.5,0.4 -5,-4.8 -9,-0.1 -3.2,-3.2 -0.8,-5.6 -4.8,-7.2 -0.7,-3.7 1.5,-5.1 -3.7,-5.1 3.3,-4.1 -1.9,-2 7,-6.4 7.2,-2.1 2.6,-2.2 2.8,-4.2 -5.5,1.9 -2.6,0.8 -4.1,0.7 -4.2,-1.7 1.5,-3.7 3,-2.8 3.8,-0.1 7.6,1.5 -5.3,-3.4 -2.7,-1.8 -4.4,0.7 -2.6,-1.3 7,-4.8 -1.3,-2 -1.1,-3.5 -1.4,-5.4 -3.6,-1.9 1.4,-2.1 -8.1,-2.9 -7.7,-0.4 -10.1,0.2 -9.5,0.4 -3.1,-1.6 -3.8,-3.1 11,-1.5 7.6,-0.2 -14.6,-1.3 -6.5,-1.9 2.2,-1.8 15.7,-2.2 15,-2.2 2.8,-1.6 -8.1,-1.6 4.6,-1.7 14.7,-2.9 5.4,-0.4 0.2,-1.8 9,-1.1 11,-0.6 h 10.4 l 2.8,1.2 10.6,-2.2 7.1,1.5 4.6,0.3 6.2,1.3 -6.7,-2.1 1.6,-1.7 L 781.4,2.5 793,2.7 798.1,1.3 810,1 Z"
              id="GL"
              data-name="Greenland"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 428.1,387.5 -0.7,5.1 -1.3,7.2 h 1.7 l 1.7,1.2 0.6,-1 1.5,0.8 -2.8,2.5 -2.9,1.8 -0.5,1.2 0.3,1.3 -1.3,1.6 -1.4,0.4 0.3,0.8 -1.2,0.7 -2,1.6 -0.3,0.9 -2.8,-1.1 -3.5,-0.1 -2.4,-1.3 -2.8,-2.6 0.4,-1.9 0.8,-1.5 -0.7,-1.2 3.3,-5.2 h 7.2 l 0.4,-2.2 -0.8,-0.4 -0.5,-1.4 -1.9,-1.5 -1.8,-2.1 2.5,-0.1 0.5,-3.6 h 5.2 z"
              id="GT"
              data-name="Guatemala"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 602.9,463.5 -1,5.8 -3.5,1.6 0.3,1.5 -1.1,3.4 2.4,4.6 h 1.8 l 0.7,3.6 3.3,5.6 -1.3,0.3 -3.2,-0.6 -1.8,1.7 -2.6,1.1 -1.8,0.3 -0.6,1.3 -2.8,-0.3 -3.5,-3 -0.3,-3 -1.4,-3.3 1,-5.4 1.6,-2.3 -1.2,-3 -2,-0.9 0.8,-2.9 -1.2,-1.4 -3,0.2 -3.7,-4.8 1.6,-1.8 v -3 l 3.5,-1 1.4,-1.2 -1.8,-2.4 0.5,-2.3 4.7,-3.8 3.6,2.4 3.3,4.1 0.1,3.4 2.1,0.1 3,3.1 z"
              id="GY"
              data-name="Guyana"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 459.6,405.5 -1.9,-0.1 -0.9,0.9 -2,0.8 h -1.4 l -1.3,0.8 -1.1,-0.2 -0.9,-1 -0.6,0.2 -0.9,1.5 -0.5,-0.1 -0.2,1.4 -2.1,1.7 -1.2,0.8 -0.6,0.8 -1.5,-1.3 -1.4,1.7 h -1.2 l -1.3,0.1 -0.2,3.2 h -0.8 l -0.8,1.5 -1.8,0.3 -0.8,-2 -1.7,-0.6 0.7,-2.6 -0.7,-0.7 -1.2,-0.4 -2.5,0.7 -0.1,-0.8 -1.6,-1.1 -1.1,-1.2 -1.6,-0.6 1.3,-1.6 -0.3,-1.3 0.5,-1.2 2.9,-1.8 2.8,-2.5 0.6,0.3 1.3,-1.1 1.6,-0.1 0.5,0.5 0.9,-0.3 2.6,0.6 2.6,-0.2 1.8,-0.7 0.8,-0.7 1.7,0.3 1.3,0.4 1.5,-0.1 1.2,-0.6 2.5,0.9 0.8,0.2 1.6,1.2 1.5,1.4 1.9,1 z"
              id="HN"
              data-name="Honduras"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1021.5,207.6 1.5,2.5 1.7,1.8 -1.7,2.4 -2.4,-1.4 -3.5,0.1 -4.5,-1.1 -2.3,0.1 -1,1.4 -2,-1.5 -0.8,2.6 2.7,3 1.3,1.9 2.5,2.4 2.1,1.4 2.1,2.7 4.8,2.4 -0.5,1 -5,-2.3 -3.2,-2.3 -4.8,-1.9 -4.7,-4.6 1,-0.5 -2.5,-2.7 -0.3,-2.1 -3.3,-1 -1.4,2.7 -1.6,-2.1 v -2.2 l 0.1,-0.1 3.6,0.2 0.8,-1 1.8,1 2,0.1 -0.1,-1.7 1.7,-0.7 0.3,-2.5 3.9,-1.7 1.6,0.8 4,2.7 4.3,1.2 z"
              id="HR"
              data-name="Croatia"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 526.8,375.3 0.1,3.4 -0.7,2.5 -1.5,1.1 1.3,1.9 -0.3,1.8 -3.6,-1.1 -2.7,0.4 -3.4,-0.4 -2.7,1.2 -2.8,-2 0.7,-2.1 5.1,0.9 4.1,0.5 2.2,-1.4 -2.3,-2.8 0.4,-2.5 -3.5,-1 1.5,-1.7 3.4,0.2 z"
              id="HT"
              data-name="Haiti"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1036.2,191.9 3,1.7 0.5,1.7 -2.9,1.3 -1.9,4.2 -2.6,4.3 -3.9,1.2 -3.2,-0.3 -3.7,1.6 -1.8,1 -4.3,-1.2 -4,-2.7 -1.6,-0.8 -1.2,-2.1 -0.8,-0.1 1.3,-4 -1.1,-1.4 h 2.8 l 0.2,-2.6 2.7,1.7 1.9,0.6 4.1,-0.7 0.3,-1.3 1.9,-0.2 2.3,-0.9 0.6,0.4 2.3,-0.8 1,-1.5 1.6,-0.4 5.5,1.9 z"
              id="HU"
              data-name="Hungary"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Indonesia"
              d="m 1607.5,567.6 -2.4,0.1 -7.1,-4.5 5.4,-1.3 2.8,2 1.8,1.9 z"
              id="path47"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Indonesia"
              d="m 1632.3,558.9 0.5,1.3 -0.1,1.9 -4.1,4.8 -5,1.4 -0.6,-0.7 0.7,-2.2 2.8,-3.9 z"
              id="path48"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Indonesia"
              d="m 1592.7,553.8 1.9,1.7 3.6,-0.5 1.2,2.7 -6.7,1.3 -3.9,0.9 -3.1,-0.1 2.2,-3.7 h 3.2 z"
              id="path49"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Indonesia"
              d="m 1621,553.8 -1.1,3.6 -8.6,1.8 -7.5,-0.8 0.2,-2.4 4.6,-1.3 3.4,1.9 3.8,-0.5 z"
              id="path50"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Indonesia"
              d="m 1540.8,545.3 10.8,0.7 1.4,-2.7 10.3,3.1 1.8,4.2 8.4,1.2 6.7,3.8 -6.6,2.4 -6.1,-2.6 -5.1,0.2 -5.8,-0.5 -5.2,-1.1 -6.4,-2.5 -4.1,-0.6 -2.4,0.8 -10.2,-2.7 -0.8,-2.7 -5.1,-0.5 4.2,-6.1 6.8,0.4 4.4,2.5 2.4,0.5 z"
              id="path51"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Indonesia"
              d="m 1688.7,541.7 -3.2,4.4 -0.2,-4.8 1.1,-2.3 1.3,-2.2 1.2,1.9 z"
              id="path52"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Indonesia"
              d="m 1647.3,524 -2.2,2.2 -3.8,-1.2 -1,-2.8 5.7,-0.3 z"
              id="path53"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Indonesia"
              d="m 1665.7,521.7 1.8,4.9 -4.6,-2.7 -4.7,-0.5 -3.3,0.4 -3.9,-0.2 1.5,-3.5 7,-0.3 z"
              id="path54"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Indonesia"
              d="m 1725.5,518.5 -1,20.9 -1.6,21 -4.6,-5.3 -5.6,-1.3 -1.5,1.8 -7.2,0.2 2.8,-5.2 3.7,-1.8 -1,-7 -2.3,-5.3 -10.7,-5.5 -4.6,-0.5 -8.3,-6 -1.8,3.2 -2.2,0.5 -1.1,-2.3 0.1,-2.8 -4.2,-3.2 6.2,-2.3 4,0.1 -0.4,-1.7 h -8.3 l -2.2,-3.8 -5,-1.2 -2.3,-3.2 7.6,-1.5 2.9,-2.1 9.1,2.6 0.9,2.4 1.3,10.4 5.7,3.8 5,-6.8 6.6,-3.8 h 5 l 4.8,2.2 4.1,2.3 z"
              id="path55"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Indonesia"
              d="m 1636.4,492.7 -4.5,6.4 -4.3,1.2 -5.4,-1.2 -9.5,0.3 -4.9,0.9 -0.8,4.9 5,5.7 3.1,-2.9 10.6,-2.2 -0.5,2.9 -2.5,-0.9 -2.5,3.8 -5.1,2.5 5.1,8.2 -1.1,2.2 4.8,7.4 -0.3,4.2 -3.1,1.9 -2.1,-2.3 3,-5.2 -5.7,2.5 -1.3,-1.8 0.8,-2.5 -3.9,-3.8 0.7,-6.2 -3.9,1.9 0.2,7.5 -0.2,9.2 -3.7,0.9 -2.3,-1.8 1.9,-5.9 -0.6,-6.2 -2.4,-0.1 -1.6,-4.4 2.5,-4.2 0.9,-5.1 3,-9.7 1.1,-2.6 4.8,-4.8 4.5,1.9 7.1,0.9 6.5,-0.3 5.6,-4.6 z"
              id="path56"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Indonesia"
              d="m 1656,494.6 -0.3,5.6 -2.9,-0.7 -0.9,3.9 2.3,3.4 -1.6,0.8 -2.2,-4.1 -1.7,-8.2 1,-5.1 1.8,-2.3 0.5,3.5 3.4,0.5 z"
              id="path57"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Indonesia"
              d="m 1548,488.9 1,4.3 3.9,3.7 3.7,-1.3 3.6,0.4 3.3,-3.2 2.7,-0.6 5.4,1.8 4.6,-1.4 2.6,-8.9 2.1,-2.2 1.7,-7.3 h 6.5 l 5,1.1 -3,5.8 4.4,6 -0.9,3 6.4,5.9 -6.7,0.8 -1.8,4.4 0.2,5.8 -5.5,4.4 -0.4,6.4 -2.5,9.8 -0.7,-2.3 -6.6,2.9 -2.1,-3.9 -4,-0.4 -2.8,-2.1 -6.8,2.4 -1.9,-3.2 -3.8,0.4 -4.6,-0.7 -0.6,-8.6 -2.8,-1.8 -2.7,-5.5 -0.8,-5.6 0.6,-6 z"
              id="path58"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Indonesia"
              d="m 1525.2,539.4 -6.2,0.1 -4.5,-5.3 -7.1,-5.3 -2.3,-3.9 -4.1,-5.2 -2.7,-4.8 -4.2,-9 -4.9,-5.4 -1.7,-5.5 -2.2,-5 -5.2,-4 -3.1,-5.5 -4.4,-3.6 -6.2,-7.1 -0.6,-3.3 3.6,0.3 8.9,1.2 5.2,6.3 4.6,4.4 3.2,2.6 5.5,6.9 5.8,0.1 4.8,4.4 3.4,5.4 4.3,3 -2.3,5.2 3.3,2.2 2,0.2 0.9,4.5 1.9,3.5 4.1,0.6 2.6,4.1 -1.7,8 z"
              id="path59"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1367.6,308 -2.8,3 -0.9,6 5.8,2.4 5.8,3.1 7.8,3.6 7.7,0.9 3.8,3.2 4.3,0.6 6.9,1.5 4.6,-0.1 0.1,-2.5 -1.5,-4.1 -0.2,-2.7 3.1,-1.4 1.5,5.1 0.4,1.2 5.5,2.5 3.2,-1 4.7,0.4 4.5,-0.2 -0.5,-3.9 -2.6,-2.1 4.2,-0.8 3.9,-4.8 5.4,-4 4.9,1.5 3.2,-2.7 3.6,4 -1.2,2.7 6.1,1 1,2.4 -1.7,1.2 1.4,3.9 -4.2,-1.1 -6.2,4.4 0.9,3.7 -2,5.4 0.3,3.1 -1.6,5.3 -4.6,-1.5 0.9,6.7 -1,2.2 1,2.7 -2.5,1.5 -4.4,-10.2 h -1.5 l -0.3,4.2 -3.6,-3.4 1.2,-3.6 2.4,-0.4 1.6,-5.4 -3.4,-1.1 -5.1,0.1 -5.4,-0.9 -1.2,-4.5 -2.7,-0.3 -4.9,-2.8 -1.2,4.4 4.6,3.4 -3,2.4 -0.9,2.3 3.7,1.7 -0.3,3.9 2.6,4.8 1.6,5.3 -0.5,2.4 -3.8,-0.1 -6.6,1.3 0.9,4.8 -2.4,3.8 -7.5,4.4 -5.3,7.5 -3.8,4.1 -5,4.2 0.3,2.9 -2.6,1.6 -4.8,2.3 -2.6,0.3 -1.2,4.9 1.9,8.4 0.7,5.3 -1.9,6.1 0.7,10.9 -2.9,0.3 -2.3,4.9 1.9,2.2 -5.1,1.8 -1.7,4.3 -2.2,1.9 -5.6,-6 -3.1,-9 -2.5,-6.5 -2.2,-3 -3.4,-6.2 -2,-8 -1.4,-4 -5.9,-8.8 -3.5,-12.5 -2.6,-8.2 -0.8,-7.8 -1.7,-6 -7.7,3.9 -4,-0.8 -8.1,-7.8 2.4,-2.3 -1.9,-2.5 -7.1,-5.5 3.2,-4.3 h 12.1 l -1.8,-5.5 -3.5,-3.2 -1.4,-5 -4,-2.8 4.9,-6.8 6.5,0.5 4.5,-6.7 2.2,-6.5 3.9,-6.5 -1,-4.6 3.8,-3.7 -5.1,-3.1 -2.9,-4.4 -3.3,-5.6 2,-2.8 8.5,1.6 5.7,-1 3.8,-5.4 7.7,7.6 0.8,5.2 3,3.3 0.6,3.3 -4.1,-0.9 3.2,7.1 6.2,4 z"
              id="IN"
              data-name="India"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 896.7,158.2 0.7,4.4 -3.9,5.5 -8.8,3.6 -6.8,-0.9 4.3,-6.4 -2.1,-6.2 6.7,-4.8 3.7,-2.8 0.9,3.2 -1.2,3.3 3,-0.1 z"
              id="IE"
              data-name="Ireland"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1169,253.2 1.8,-0.2 5.3,-4.7 1.9,-0.5 1.9,1.9 -1.2,3.1 3.9,3.4 1.3,-0.4 2.5,4.8 5.3,1.3 4.3,3.2 7.7,1.1 8,-1.7 0.2,-1.5 4.4,-1.2 3,-3.7 3.6,0.2 2,-1.2 3.9,0.6 6.6,3.3 4.3,0.7 7.3,5.6 4,0.3 1.7,5.3 -0.6,8 -0.5,4.7 2.5,1 -1.6,3.5 2.7,5.1 1.2,4.1 4.3,1.1 1.1,4.1 -3.9,5.8 3.2,3.4 2.8,3.9 5.7,2.8 1,5.6 2.7,1.1 0.9,2.9 -7.5,3.4 -1.1,7.4 -10.6,-1.9 -6.2,-1.5 -6.3,-0.8 -3.3,-7.9 -2.8,-1.1 -4.1,1.1 -5.1,3.1 -7,-2.1 -6.1,-5 -5.5,-1.8 -4.4,-6.1 -5.2,-8.5 -2.8,1 -3.7,-2.1 -1.7,2.5 -3.5,-3.4 -0.5,-3.4 h -1.7 l 0.2,-4.7 -3.5,-4.8 -7.1,-3.6 -4.6,-6.1 0.5,-5 2.3,-2.2 -0.9,-3.7 -3.8,-2 -4.7,-7.6 -3.8,-5.1 0.7,-2 -2.9,-7.3 3.3,-1.9 1.2,2.5 3.2,2.9 z"
              id="IR"
              data-name="Iran"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1163.5,263.2 4.7,7.6 3.8,2 0.9,3.7 -2.3,2.2 -0.5,5 4.6,6.1 7.1,3.6 3.5,4.8 -0.2,4.7 h 1.7 l 0.5,3.4 3.5,3.4 -3.3,-0.3 -3.7,-0.6 -3.3,6.2 -10.2,-0.5 -16.8,-12.9 -8.6,-4.5 -6.8,-1.8 -3.1,-7.8 11,-6.7 1,-7.7 -1.2,-4.7 2.7,-1.6 2.1,-4 2.1,-1 6.3,0.9 2.1,1.6 z"
              id="IQ"
              data-name="Iraq"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 864.8,84.5 -1.4,3.6 4.4,3.8 -6.1,4.3 -13.1,3.9 -3.9,1.1 -5.6,-0.9 -11.9,-1.8 4.8,-2.5 -9,-2.7 7.9,-1.1 0.1,-1.7 -8.8,-1.3 3.6,-3.7 6.6,-0.8 6,3.8 7,-3 5.1,1.5 7.3,-2.9 z"
              id="IS"
              data-name="Iceland"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1119.1,288.2 0.4,2.6 -0.6,1 h 0.1 l -0.7,2 -2.1,-0.8 -0.7,4.2 1.5,0.7 -1.3,0.9 -0.1,1.7 2.5,-0.8 0.4,2.5 -1.8,10.2 -0.7,-1.6 -3.9,-9.4 1.4,-2.1 -0.4,-0.4 1.1,-3 0.6,-4.8 0.6,-1.7 h 0.1 1.8 l 0.4,-1.1 z"
              id="IL"
              data-name="Israel"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Italy"
              d="m 1008.2,256.4 -1.7,5.1 0.9,1.9 -0.9,3.3 -4.2,-2.4 -2.7,-0.7 -7.5,-3.2 0.5,-3.3 6.2,0.6 5.4,-0.7 z"
              id="path60"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Italy"
              d="m 974.2,237.4 3.3,4.5 -0.4,8.5 -2.4,-0.4 -2.1,2.1 -2,-1.7 -0.5,-7.7 -1.3,-3.6 2.9,0.3 z"
              id="path61"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Italy"
              d="m 995.9,203.9 -0.4,3.1 1.4,2.7 -4.1,-1 -3.9,2.3 0.4,3.1 -0.5,1.8 1.9,3.2 5,3.2 2.9,5.3 6.1,5.1 4,-0.1 1.4,1.4 -1.4,1.3 4.8,2.3 4,1.9 4.7,3.4 0.6,1.1 -0.8,2.3 -3.1,-3 -4.6,-1 -1.9,4.1 3.9,2.4 -0.4,3.3 -2.1,0.4 -2.5,5.5 -2.2,0.5 -0.1,-2 0.9,-3.4 1.1,-1.4 -2.3,-3.7 -1.8,-3.2 -2.2,-0.8 -1.8,-2.7 -3.4,-1.2 -2.4,-2.6 -3.8,-0.4 -4.3,-2.8 -4.9,-4.2 -3.7,-3.6 -1.9,-6.3 -2.6,-0.7 -4.2,-2.1 -2.3,0.8 -2.9,3 -2.1,0.4 0.5,-2.7 -2.8,-0.8 -1.5,-4.9 1.7,-1.9 -1.5,-2.4 0.1,-1.8 2.2,1.4 2.5,-0.3 2.7,-2.2 0.9,1 2.4,-0.2 1,-2.5 3.8,0.8 2.1,-1.1 0.3,-2.5 3.1,0.9 0.5,-1.2 4.9,-1.1 1.3,2.1 z"
              id="path62"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 496.5,387.1 -1.8,1.1 -3,-1.1 -2.9,-2.3 0.8,-1.5 2.4,-0.4 1.3,0.2 3.7,0.6 2.7,1.5 0.8,1.8 z"
              id="JM"
              data-name="Jamaica"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1138.1,295.3 -0.9,1 -10.4,3.2 6,6.5 -1.6,1 -0.7,2.2 -4.1,0.9 -1.1,2.3 -2.1,2 -6.2,-1.1 -0.3,-0.9 1.8,-10.2 -0.4,-2.5 0.6,-1.9 -0.4,-4 0.7,-2 6.3,2.6 9.7,-6.9 z"
              id="JO"
              data-name="Jordan"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Japan"
              d="m 1648.5,282.6 1.6,2.2 -1.3,3.9 -3.1,-2.1 -2.1,1.5 0.1,3.7 -4.3,-1.8 -1.2,-3 1.3,-3.9 3.4,0.8 1,-2.7 z"
              id="path63"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Japan"
              d="m 1673.1,263.4 0.6,5.1 2.5,3.2 -0.6,4.5 -5.4,3 -9.2,0.4 -4.4,7.4 -4.7,-2.5 -2.4,-4.8 -8.6,1.4 -5.1,3 -6.2,0.2 7.4,4.7 0.8,10.9 -2.5,2.7 -3.6,-2.5 -0.9,-5.8 -4.1,-1.8 -4,-4.4 4.3,-2 1.1,-4.1 3.9,-3.3 2,-4.4 9.7,-1.9 6.3,1.3 v -11.4 l 5.1,3.1 4.5,-6.4 1.7,-2.5 -1,-7.8 -5.1,-7.2 -0.2,-4 4.8,-1.2 8.2,8.9 2.8,5.1 -1.3,6.5 z"
              id="path64"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Japan"
              d="m 1661.2,218.6 4.5,1.3 1.8,-2.6 6,7.1 -6.4,1.7 -0.4,6.3 -10.9,-4.3 1.6,6.9 -5.7,0.1 -4.7,-6.3 -0.6,-4.9 5.2,-0.3 -4.4,-8.8 -1.8,-4.9 10.5,6.6 z"
              id="path65"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1278.3,160.5 4.4,-0.3 9.2,-5.8 -0.8,2 8.4,4.7 18.3,15.6 1.1,-3.2 8.4,3.5 6.2,-1.6 3.3,1.1 4.1,3.6 4,1.2 3.3,2.7 6,-0.9 4.4,3.8 -1.9,4.2 -3.8,0.6 2.5,6.2 -1.6,2.9 -10.8,-2.1 1,11.3 -2,1.4 -9.1,2.5 8.8,11 -2.9,1.6 1.7,3.7 -3.5,-1 -3.4,-2.3 -7.9,-0.6 -8.6,-0.2 -1.6,0.7 -8.2,-2.7 -2.5,1.4 0.5,3.7 -9.2,-2.2 -3.1,0.9 -0.3,2.8 -2.6,1.2 -5.4,4.4 -0.9,4.6 h -2 l -2.3,-3 -6.7,-0.2 -2.5,-5.2 -2.6,-0.1 -1.5,-6.4 -7.6,-4.6 -8.6,0.5 -5.7,0.9 -6.6,-5.7 -4.8,-2.4 -9.2,-4.5 -1.1,-0.5 -12,3.7 6.2,23.4 -2.6,0.3 -4.8,-5 -3.9,-1.8 -5.6,1.3 -1.8,2.2 -0.6,-1.6 0.6,-2.6 -1.5,-2.2 -6.5,-2.2 -3.7,-5.7 -3.2,-1.6 -0.6,-2.1 5.1,0.6 -1,-4.6 4.1,-1 4.7,0.9 -0.7,-6.1 -1.9,-3.9 -5,0.3 -4.7,-1.5 -5.1,2.7 -4.4,1.4 -2.8,-1.1 -0.2,-3.2 -4.3,-4.2 -3.6,0.2 -5.3,-4.2 1.7,-4.8 -1.8,-1.2 2.2,-6.9 6,3.6 -0.6,-4.5 8.1,-6.7 7.6,-0.2 12,4.3 6.6,2.5 4.4,-2.6 7.7,-0.1 7.3,3.2 0.8,-1.9 7,0.3 0.2,-2.9 -9.4,-4.3 3.5,-3 -1.5,-1.6 4,-1.6 -5.1,-4.2 1.4,-2.1 17,-2.1 1.7,-1.5 10.9,-2.3 3.1,-2.5 9.1,1.3 4.4,6.3 4.3,-1.5 7.1,2.1 z"
              id="KZ"
              data-name="Kazakhstan"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1163.5,476.7 -4.9,7.2 0.2,23.4 3.3,5.3 -4,2.6 -1.4,2.7 -2.2,0.4 -0.8,4.6 -1.9,2.6 -1.1,4.2 -2.3,2.1 -8.1,-6.4 -0.3,-3.7 -20.5,-13.1 0.4,-4.7 -1.4,-2.5 v -0.3 l 1.6,-2.6 2.8,-4.2 2.1,-4.7 -2.6,-7.4 -0.7,-3.2 -2.7,-4.5 3.4,-3.8 3.8,-4.2 2.9,1.1 0.1,3.6 1.9,2.1 h 4 l 7.2,5.4 1.8,0.1 1.3,-0.2 1.3,0.7 3.8,0.6 1.6,-2.7 5.2,-2.7 2.3,2.2 z"
              id="KE"
              data-name="Kenya"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1340.5,230.2 -0.2,1.4 -6.9,3.4 -1,2.6 -6.4,0.7 -0.6,4.1 -5.8,-0.9 -3.2,1.3 -4.1,3 1.2,1.5 -1.1,1.4 -9.6,1 -7.1,-2.1 -5.5,0.5 -0.6,-3.6 6,1 1.4,-1.9 4.1,0.6 5.3,-4.6 -7.2,-3.4 -3.2,1.6 -4.6,-2.4 3,-4.1 -1.7,-0.6 0.3,-2.8 3.1,-0.9 9.2,2.2 -0.5,-3.7 2.5,-1.4 8.2,2.7 1.6,-0.7 8.6,0.2 7.9,0.6 3.4,2.3 z"
              id="KG"
              data-name="Kyrgyzstan"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1529.8,410.6 1.8,4.3 0.1,7.7 -9,5 2.8,3.8 -5.9,0.5 -4.6,2.6 -4.8,-0.9 -2.6,-3.4 -3.5,-6.6 -2.1,-7.8 3.1,-5.3 7.1,-1.2 5.3,0.9 5,2.5 2,-4.4 z"
              id="KH"
              data-name="Cambodia"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1592.9,259.5 v -0.6 l 2.5,0.2 0.6,-2.8 3.6,-0.4 2,-0.4 V 254 l 8.3,7.5 3.3,4.2 3.4,7.4 -0.5,3.5 -4.3,1.2 -3.1,2.7 -4.6,0.5 -2.1,-3.5 -1.1,-4.8 -5.3,-6.6 3.4,-1.1 z"
              id="KR"
              data-name="Republic of Korea"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1187.5,309.4 1.5,2.8 -0.3,1.5 2.4,4.8 -3.9,0.2 -1.7,-3.1 -5,-0.6 3.3,-6.2 z"
              id="KW"
              data-name="Kuwait"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1529.8,410.6 -5.3,-2.3 -2,4.4 -5,-2.5 1.5,-2.9 -0.4,-5.4 -5.3,-5.6 -1.3,-6.4 -5,-5.2 -4.3,-0.4 -0.8,2.2 -3.2,0.2 -1.9,-1.1 -5.3,3.8 -1,-5.8 0.4,-6.7 -3.8,-0.3 -0.9,-3.9 -2.7,-2 0.8,-2.3 4.1,-4.2 0.8,1.5 3,0.2 -2,-7.4 2.7,-0.9 4,5.1 3.5,5.8 h 6.8 l 3,5.6 -3.3,1.7 -1.2,2.3 7.3,3.9 5.7,7.6 4.4,5.6 4.9,4.5 2,4.5 z"
              id="LA"
              data-name="Laos"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1119.1,288.2 -1.4,0.1 -0.4,1.1 h -1.8 l 1.3,-5.3 2.2,-4.5 v -0.2 l 2.5,0.3 1.2,2.5 -2.7,2.5 z"
              id="LB"
              data-name="Lebanon"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 878.6,452.5 -0.2,1.8 0.5,3.1 -1.2,2.9 1.6,1.8 1.8,0.4 2.4,2.7 0.2,2.5 -0.6,0.8 -0.4,5.3 -1.5,0.1 -5.8,-3.1 -5.2,-4.9 -4.8,-3.5 -3.8,-4.1 1.4,-2.1 0.3,-1.9 2.6,-3.4 2.6,-3 1.3,-0.2 1.4,-0.7 2.4,3.9 -0.4,2.6 1.1,1.4 h 1.6 l 1.1,-2.6 z"
              id="LR"
              data-name="Liberia"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1062.6,299.1 -1.7,3.1 1,2.8 -1.1,3.9 2,5.2 1.3,22.8 1,23.7 0.5,12.8 h -6.4 v 2.7 l -22.6,-12.3 -22.5,-12.3 -5.5,3.5 -3.8,2.4 -3.2,-3.5 -8.8,-2.8 -2.5,-4 -4.5,-3 -2.5,1.2 -2.1,-3.6 -0.2,-2.7 -3.4,-4.7 2.2,-2.7 -0.6,-4 0.6,-3.5 -0.4,-3 0.8,-5.2 -0.4,-3 -1.9,-5.7 2.6,-1.4 0.4,-2.8 -0.6,-2.6 3.6,-2.5 1.6,-2.1 2.6,-1.8 0.1,-4.9 6.4,2.2 2.3,-0.6 4.5,1.1 7.3,2.9 2.8,5.7 4.9,1.2 7.8,2.7 6,3.2 2.5,-1.7 2.5,-2.9 -1.6,-4.9 1.5,-3.2 3.7,-3 3.7,-0.8 7.4,1.3 2,2.8 2,0.1 1.8,1.1 5.4,0.7 z"
              id="LY"
              data-name="Libya"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1385.9,462 -4.8,1.5 -2.9,-5.1 -1.4,-9.2 2,-10.4 4.1,3.5 2.8,4.5 3.1,6.7 -0.6,6.7 z"
              id="LK"
              data-name="Sri Lanka"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1079.1,697.9 -2,0.7 -3.7,-5 3.2,-4 3.1,-2.5 2.7,-1.4 2.2,2 1.7,2 -1.9,3.1 -1.1,2.1 -3.1,1 z"
              id="LS"
              data-name="Lesotho"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1051.1,147.6 1,2.7 -3.6,2 -0.5,3.4 -4.8,2.3 h -4.7 l -1.4,-1.9 -2.5,-0.7 -0.6,-1.5 0.2,-1.7 -2.2,-0.9 -5.1,-1.1 -1.7,-5.1 5.1,-1.8 7.9,0.4 4.5,-0.6 0.9,1.2 2.5,0.4 z"
              id="LT"
              data-name="Lithuania"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 956.9,185.4 -1.4,0.1 -1.1,-0.5 0.4,-3.5 1.3,-0.2 1,1.4 z"
              id="LU"
              data-name="Luxembourg"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1052.8,136.5 2.5,1.3 1,2.9 2.1,3.6 -4.6,2.3 -2.7,1 -5,-2.9 -2.5,-0.4 -0.9,-1.2 -4.5,0.6 -7.9,-0.4 -5.1,1.8 -0.5,-4.5 1.7,-3.8 4.1,-2 4.4,4.5 3.7,-0.2 0.1,-4.6 3.8,-1 2.1,0.7 4.4,2.2 z"
              id="LV"
              data-name="Latvia"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 914.8,276 1.9,4.1 0.3,3.9 1.9,6.8 1.4,1.4 -1,2.5 -7.1,1.1 -2.5,2.3 -3.1,0.6 -0.3,4.8 -6.4,2.5 -2.1,3.2 -4.5,1.7 -5.4,1 -8.9,4.8 -0.1,7.6 H 878 l 0.1,3.4 -3.4,0.2 -1.8,1.5 h -2.5 l -2,-0.9 -4.6,0.7 -1.9,5 -1.8,0.5 -2.7,8.1 -7.9,6.9 -2,8.9 -2.4,2.9 -0.7,2.3 -12.5,0.5 h -0.1 l 0.3,-3 2.2,-1.7 1.9,-3.4 -0.3,-2.2 2,-4.5 3.2,-4.1 1.9,-1 1.6,-3.7 0.2,-3.5 2.1,-3.9 3.8,-2.4 3.6,-6.5 0.1,-0.1 2.9,-2.5 5.1,-0.7 4.4,-4.4 2.8,-1.7 4.7,-5.4 -1.2,-7.9 2.2,-5.6 0.9,-3.4 3.6,-4.3 5.4,-2.9 4.1,-2.7 3.7,-6.6 1.8,-4 3.9,0.1 3.1,2.7 5.1,-0.4 5.5,1.4 z"
              id="MA"
              data-name="Morocco"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1069.4,210.3 -1.3,-2.9 0.2,-2.7 -0.6,-2.7 -3.4,-3.8 -2,-2.6 -1.8,-1.8 -1.6,-0.7 1.1,-0.9 3.2,-0.6 4,1.9 2,0.3 2.6,1.7 -0.1,2.1 2,1 1.1,2.6 2,1.6 -0.2,1 1,0.6 -1.3,0.5 -3,-0.2 -0.6,-0.9 -1,0.5 0.6,1.1 -1.1,2.1 -0.6,2.1 z"
              id="MD"
              data-name="Moldova"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1207.9,588.9 0.4,7.7 1.3,3 -0.7,3.1 -1.2,1.8 -1.6,-3.7 -1.2,1.9 0.8,4.7 -0.7,2.8 -1.7,1.4 -0.7,5.5 -2.7,7.5 -3.4,8.8 -4.3,12.2 -2.9,8.9 -3.1,7.5 -4.6,1.5 -5.1,2.7 -3,-1.6 -4.2,-2.3 -1.2,-3.4 v -5.7 l -1.5,-5.1 -0.2,-4.7 1.3,-4.6 2.6,-1.1 0.2,-2.1 2.9,-4.9 0.8,-4.1 -1.1,-3 -0.8,-4.1 -0.1,-5.9 2.2,-3.6 1,-4.1 2.8,-0.2 3.2,-1.3 2.2,-1.2 2.4,-0.1 3.4,-3.6 4.9,-4 1.8,-3.2 -0.6,-2.8 2.4,0.8 3.3,-4.4 0.3,-3.9 2,-2.9 1.8,2.8 1.4,2.7 z"
              id="MG"
              data-name="Madagascar"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 389.3,335.9 2.2,-0.2 -3.2,5.7 -1.8,4.6 -1.8,8.6 -1.1,3.1 0.4,3.5 1.3,3.2 0.4,4.9 3,4.8 0.8,3.7 1.7,3.1 5.7,1.7 1.9,2.7 5.2,-1.8 4.3,-0.6 4.4,-1.2 3.6,-1.1 3.9,-2.6 1.8,-3.7 1.2,-5.4 1.2,-1.9 4,-1.7 6.1,-1.5 4.9,0.3 3.4,-0.6 1.2,1.4 -0.6,3.1 -3.5,3.8 -1.8,3.9 0.9,1.1 -1.2,2.8 -2.1,5 -1.2,-1.7 -1.1,0.1 -1.1,0.1 -2.5,3.9 -0.9,-0.8 -0.7,0.3 -0.1,1 -5.2,-0.1 h -5.2 l -0.5,3.6 -2.5,0.1 1.8,2.1 1.9,1.5 0.5,1.4 0.8,0.4 -0.4,2.2 h -7.2 l -3.3,5.2 0.7,1.2 -0.8,1.5 -0.4,1.9 -5.6,-6.9 -2.6,-2.1 -4.4,-1.7 -3.2,0.5 -4.8,2.4 -2.9,0.6 -3.7,-1.7 -4.1,-1.2 -4.8,-2.9 -4.1,-0.9 -5.9,-3 -4.3,-3.1 -1.1,-1.7 -3.1,-0.4 -5.4,-2 -1.9,-2.9 -5.4,-3.7 -2.2,-4 -0.8,-3.2 1.9,-0.6 -0.3,-1.8 1.6,-1.7 0.4,-2.2 -1.5,-2.9 v -2.5 l -1.3,-3.3 -3.8,-6.4 -4.6,-5 -1.9,-4 -4.1,-2.6 -0.7,-1.6 1.7,-3.9 -2.4,-1.5 -2.5,-3.2 -0.2,-4.4 -2.8,-0.6 -2.3,-3.3 -1.7,-3.2 0.3,-2 -1.5,-4.8 -0.3,-4.9 0.8,-2.5 -3.1,-2.6 -1.9,0.3 -2.4,-1.7 -1.8,2.6 -0.1,3 -1,4.9 1,2.6 2.8,4.4 0.4,1.6 0.7,0.4 0.1,2.2 1,-0.1 v 4.2 l 1.3,1.6 0.5,2.3 2.7,3.2 0.4,6 1,2.8 0.9,3 -0.3,3.4 2.6,0.2 1.6,2.9 1.5,2.9 -0.3,1.2 -2.8,2.3 h -1 l -0.7,-3.9 -2.9,-3.7 -3.4,-3.1 -2.5,-1.6 1.2,-4.7 -0.1,-3.5 -2.1,-2 -3.1,-2.8 -0.9,0.8 -1,-1.7 -3,-1.5 -2.2,-3.8 0.5,-0.4 2.1,0.3 2.7,-2.4 1,-2.9 -2.9,-4.6 -2.6,-1.7 -0.8,-4 -0.6,-4.3 -0.8,-5.1 -0.2,-5.8 6.3,-0.5 7.1,-0.7 -0.9,1.3 7,3.1 10.9,4.5 h 10.8 4.3 l 0.8,-2.7 h 9.4 l 1.3,2.3 2.1,2.1 2.4,2.8 0.8,3.3 0.4,3.6 2.3,1.9 4,1.9 4.8,-5 4.5,-0.2 3.2,2.6 1.6,4.4 0.9,3.8 2.4,3.6 0.2,4.5 0.9,3 3.9,2 z"
              id="MX"
              data-name="Mexico"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1045.5,236.6 -1,0.2 -0.8,1.1 -2.8,-0.1 -1.8,1.4 -3.4,0.5 -2.3,-1.5 -1,-2.7 0.5,-2.2 0.7,0.1 0.1,-1.3 2.9,-1 1.2,-0.3 1.7,-0.3 2.4,-0.2 2.8,2.1 z"
              id="MK"
              data-name="North Macedonia"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 950.2,378.8 0.1,14.8 -3.1,4.3 -0.4,4 -5,1 -7.7,0.5 -2,2.3 -3.6,0.3 h -3.6 l -1.4,-1.2 -3.1,0.9 -5.3,2.7 -1.1,2 -4.3,2.8 -0.8,1.7 -2.4,1.3 -2.7,-0.9 -1.5,1.6 -0.9,4.4 -4.5,5.3 0.2,2.2 -1.6,2.7 0.4,3.7 -2.4,1 -1.3,0.8 -0.9,-2.7 -1.6,0.7 -1,-0.1 -1,1.8 h -4.4 l -1.5,-1 -0.8,0.6 -1.7,-1.9 0.3,-1.9 -0.7,-0.7 -1.2,0.6 0.3,-2.1 1.1,-1.6 -2.3,-2.7 -0.6,-1.8 -1.3,-1.4 -1.1,-0.2 -1.3,0.9 -1.9,0.9 -1.5,1.4 -2.4,-0.5 -1.6,-1.7 -0.9,-0.2 -1.5,0.9 h -0.9 l -0.3,-2.4 0.3,-2 -0.5,-2.4 -2,-1.8 -1.1,-3.7 -0.2,-4 1.9,-1.2 1,-3.8 1.8,-0.1 3.9,1.8 3.2,-1.3 2.1,0.4 0.9,-1.4 22.5,-0.1 1.3,-4.5 -1,-0.8 -2.5,-27.7 -2.4,-27.7 8.5,-0.1 18.6,14 18.7,14 1.3,3 3.5,1.8 2.6,1.1 0.1,4.1 z"
              id="ML"
              data-name="Mali"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1488.4,364.2 -4.1,4.2 -0.8,2.3 -3,1.5 -2.8,2.8 -3.9,0.3 -1.5,6.9 -2.2,1.2 3.5,5.6 4.1,4.7 2.9,4.3 -1.4,5.5 -1.8,1.2 1.8,3.2 4.3,5.1 1,3.6 0.2,3 2.7,5.9 -2.6,6 -2.2,6.6 -0.9,-4.8 1.3,-4.9 -2.2,-3.8 -0.2,-7 -2.6,-3.4 -2.7,-7.6 -2,-8.1 -3.1,-5.4 -3.2,3.3 -5.8,4.5 -3.3,-0.5 -3.6,-1.5 0.9,-8 -2,-6 -5.3,-7.4 0.3,-2.3 -3.4,-0.9 -4.6,-5.2 -1.1,-5.2 2.1,1 -0.6,-4.6 2.5,-1.5 -1,-2.7 1,-2.2 -0.9,-6.7 4.6,1.5 1.6,-5.3 -0.3,-3.1 2,-5.4 -0.9,-3.7 6.2,-4.4 4.2,1.1 -1.4,-3.9 1.7,-1.2 -1,-2.4 3.1,-0.5 2.7,3.8 2.7,1.5 1.3,4.9 0.9,5.3 -4.2,5.4 0.7,7.6 5.6,-1.1 2.4,5.9 3.7,1.3 -0.8,5.3 4.5,2.4 2.6,1.2 3.8,-1.9 z"
              id="MM"
              data-name="Myanmar"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1030.6,227.2 -0.8,1.4 -1.4,0.6 -0.4,-1.2 -1.9,3.1 0.5,2.1 -1.1,-0.5 -1.7,-2.1 -2.3,-1.3 0.5,-1 0.4,-3.5 1.6,-1.5 0.9,-0.6 1.4,1.1 0.9,0.9 1.7,0.7 2.1,1.3 z"
              id="ME"
              data-name="Montenegro"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1436.2,181.5 4,-1.2 5.7,-0.8 5.4,0.9 6.6,2.9 4.9,3.2 h 4.6 l 6.8,1 3.6,-1.6 5.9,-1 4.4,-4.4 3.4,0.7 3.9,2.1 5.6,-0.6 0.6,4.7 0.3,6.3 2.8,2.5 2.3,-0.8 5.5,1 2.5,-2.3 5.2,2 7.2,4.4 0.8,2.2 -4.4,-0.7 -6.8,0.8 -2.5,1.8 -1.3,4.2 -6.4,2.4 -3.2,3.4 -5.9,-1.3 -3.2,-0.6 -0.5,4.1 2.9,2.4 1.9,2.1 -2.4,2.2 -2,3.4 -4.9,2.2 -7.6,0.2 -7.2,2.2 -4.4,3.4 -3.3,-1.9 h -6.2 l -9.4,-3.9 -5.6,-0.9 -6.4,0.9 -11.3,-1.5 -5.6,0.2 -4.7,-3.8 -5,-5.8 -3.4,-0.7 -8,-4 -7.2,-0.8 -6.5,-1.1 -3,-2.8 -1.4,-7.3 -5.8,-5.1 -8.2,-2.3 -5.7,-3.3 -3.3,-4.4 4.7,-1.1 6.7,-5.3 5.9,-2.9 5.3,1.9 5.2,0.1 4.8,2.9 5,0.2 8,1.6 2.4,-4.4 -4,-3.6 1.3,-6.4 7,2.5 4.8,0.8 6.7,1.6 3.6,4.6 z"
              id="MN"
              data-name="Mongolia"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1106.7,673.5 h -4.1 l -0.3,-2.9 -0.6,-2.9 -0.4,-2.3 1.4,-7.1 -1.1,-4.6 -2.2,-9 6.2,-7.3 1.7,-4.6 0.8,-0.6 0.9,-3.8 -0.8,-1.9 0.4,-4.8 1.3,-4.4 0.4,-8.2 -2.8,-2 -2.7,-0.5 -1.1,-1.6 -2.6,-1.3 -4.7,0.1 -0.2,-2.4 -0.4,-4.6 17.2,-5.3 3.2,3.1 1.5,-0.6 2.2,1.6 0.2,2.6 -1.3,3 0.2,4.5 3.5,4 1.9,-4.5 2.5,-1.3 -0.1,-8.3 -2.2,-4.6 -1.9,-2.1 h -0.4 l -0.6,-7.3 1.5,-6.1 2.2,-0.2 6.7,1.8 1.5,-0.8 3.9,-0.2 2.1,-1.9 3.4,0.1 6.2,-2.5 4.6,-3.7 0.9,2.8 -0.5,6.4 0.5,5.7 -0.2,10 0.8,3.1 -1.9,4.6 -2.4,4.5 -3.7,4 -5.3,2.4 -6.5,3.1 -6.6,6.9 -2.2,1.2 -4.2,4.6 -2.3,1.4 -0.8,4.6 2.4,4.9 0.9,3.7 v 2 l 1,-0.4 -0.5,6.3 -1.1,3 1.2,1.1 -1,2.7 -2.4,2.3 -4.7,2.1 -6.9,3.5 -2.5,2.4 0.3,2.7 1.3,0.4 z"
              id="MZ"
              data-name="Mozambique"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 899.2,341.5 -8.5,0.1 2.4,27.7 2.5,27.7 1,0.8 -1.3,4.5 -22.5,0.1 -0.9,1.4 -2.1,-0.4 -3.2,1.3 -3.9,-1.8 -1.8,0.1 -1,3.8 -1.9,1.2 -3.6,-4.4 -3.4,-4.8 -3.6,-1.7 -2.7,-1.8 h -3.1 l -2.8,1.4 -2.7,-0.5 -2,2 -0.4,-3.4 1.6,-3.2 0.8,-6 -0.4,-6.4 -0.6,-3.2 0.6,-3.2 -1.4,-3 -2.8,-2.8 1.3,-2.1 h 21.7 l -0.9,-9.3 1.5,-3.3 5.2,-0.5 0.2,-16.5 18,0.4 0.2,-9.8 z"
              id="MR"
              data-name="Mauritania"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1122.3,588.9 h 0.4 l 1.9,2.1 2.2,4.6 0.1,8.3 -2.5,1.3 -1.9,4.5 -3.5,-4 -0.2,-4.5 1.3,-3 -0.2,-2.6 -2.2,-1.6 -1.5,0.6 -3.2,-3.1 -2.9,-1.6 2,-6 1.8,-2.2 -0.9,-5.4 1.3,-5.2 1,-1.7 -1.3,-5.4 -2.6,-2.9 5.5,1.2 1,1.7 -0.1,0.8 1.8,4.1 0.2,7.7 -1.8,3.6 1.6,4.7 -0.2,2.8 1.2,1.9 -0.1,2.4 0.9,1.4 1,-1.6 1.9,2.5 0.2,-0.8 -1,-3.4 -1.1,-0.3 z"
              id="MW"
              data-name="Malawi"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Malaysia"
              d="m 1504.3,461.9 1.4,0.6 3.5,3.9 2.5,4.3 0.6,4.3 -0.5,2.9 0.6,2.2 0.5,3.8 2.1,1.8 2.3,5.7 v 2.1 l -4,0.5 -5.5,-4.8 -6.8,-5.1 -0.8,-3.3 -3.4,-4.3 -1,-5.3 -2.2,-3.5 0.4,-4.7 -1.4,-2.7 0.9,-1.1 4.8,2.8 0.6,3.3 3.7,-0.8 z"
              id="path66"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Malaysia"
              d="m 1594.1,475.3 -5,-1.1 h -6.5 l -1.7,7.3 -2.1,2.2 -2.6,8.9 -4.6,1.4 -5.4,-1.8 -2.7,0.6 -3.3,3.2 -3.6,-0.4 -3.7,1.3 -3.9,-3.7 -1,-4.3 4.2,2.2 4.3,-1.2 1,-5.4 2.4,-1.2 6.8,-1.4 3.8,-5.1 2.6,-4 2.8,3.3 1.1,-2.2 2.7,0.2 0.1,-4.1 0.1,-3.2 4.1,-4.4 2.6,-5 2.3,-0.1 3.1,3.3 0.4,2.8 3.8,1.8 4.8,1.9 -0.2,2.5 -3.8,0.3 1.1,3.2 z"
              id="path67"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1056.2,614.3 4.6,-1.4 3.6,0.3 2.2,1.5 v 0.5 l -3.2,1.5 h -1.7 l -3.7,2.5 -2,-2.7 -8.7,2.3 -4.2,0.2 -0.8,22.9 -5.5,0.2 -0.6,18.7 -1.1,23.7 -5,3.3 -2.9,0.5 -3.4,-1.2 -2.5,-0.5 -0.8,-2.7 -2,-1.8 -2.8,3.2 -3.9,-4.9 -2,-4.6 -1,-6.3 -1.2,-4.6 -1.6,-9.9 0.1,-7.7 -0.6,-3.5 -2.1,-2.7 -2.8,-5.3 -2.8,-7.7 -1.1,-4 -4.4,-6.3 -0.3,-4.9 2.7,-1.2 3.4,-1.1 3.6,0.2 3.3,2.9 0.8,-0.5 22.7,-0.2 3.8,3 13.5,0.9 z"
              id="NA"
              data-name="Namibia"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1008.6,355 1.6,10 2.2,1.7 0.1,2 2.4,2.2 -1.2,2.8 -1.8,13 -0.2,8.4 -7,6 -2.3,8.5 2.4,2.4 v 4.1 l 3.7,0.1 -0.6,3.1 -1.5,0.3 -0.2,2.1 -1,0.1 -3.9,-7 -1.4,-0.3 -4.3,3.6 -4.4,-1.9 -3,-0.3 -1.6,0.9 -3.3,-0.2 -3.3,2.7 -2.9,0.2 -6.8,-3.3 -2.7,1.5 -2.9,-0.1 -2.1,-2.4 -5.6,-2.4 -6.1,0.8 -1.4,1.3 -0.8,3.7 -1.6,2.6 -0.4,5.8 -4.3,-3.7 h -2 l -1.9,1.9 0.1,-4.4 -6.5,-1.5 -0.2,-3.1 -3.1,-4.2 -0.8,-2.9 0.5,-3.1 3.6,-0.3 2,-2.3 7.7,-0.5 5,-1 0.4,-4 3.1,-4.3 -0.1,-14.8 7.8,-2.8 16,-12.6 18.8,-12.3 8.8,2.8 3.2,3.5 z"
              id="NE"
              data-name="Niger"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1006.2,421.7 2.3,2.5 -0.6,1.2 -0.3,2.1 -4.7,5 -1.4,4.1 -0.8,3.3 -1.2,1.5 -1.1,4.5 -3,2.6 -0.8,3.2 -1.3,2.6 -0.5,2.7 -3.9,2.2 -3.2,-2.7 -2.1,0.1 -3.4,3.8 h -1.6 l -2.7,6.2 -1.4,4.6 -5.9,2.3 -2.1,-0.3 -2.2,1.4 -4.5,-0.1 -3.1,-4.1 -1.9,-4.6 -4,-4.2 h -4.2 -5 l 0.3,-10.3 -0.2,-4.1 1.1,-4 1.7,-2 2.8,-4 -0.6,-1.7 1.1,-2.6 -1.3,-3.8 0.2,-2.1 0.4,-5.8 1.6,-2.6 0.8,-3.7 1.4,-1.3 6.1,-0.8 5.6,2.4 2.1,2.4 2.9,0.1 2.7,-1.5 6.8,3.3 2.9,-0.2 3.3,-2.7 3.3,0.2 1.6,-0.9 3,0.3 4.4,1.9 4.3,-3.6 1.4,0.3 3.9,7 z"
              id="NG"
              data-name="Nigeria"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 459.6,405.5 -0.5,0.7 -0.5,1.4 0.4,2.3 -1.5,2.2 -0.8,2.6 -0.5,2.8 0.2,1.7 -0.1,2.9 -0.9,0.6 -0.7,2.8 0.2,1.7 -1.2,1.6 0.1,1.7 0.8,1.1 -1.4,1.4 -1.7,-0.5 -0.8,-1.3 -1.8,-0.5 -1.3,0.8 -3.6,-1.7 -0.9,0.8 -1.8,-2 -2.5,-2.6 -1.1,-2.1 -2.2,-2.1 -2.5,-2.9 0.7,-1 0.8,1 0.5,-0.4 1.8,-0.3 0.8,-1.5 h 0.8 l 0.2,-3.2 1.3,-0.1 h 1.2 l 1.4,-1.7 1.5,1.3 0.6,-0.8 1.2,-0.8 2.1,-1.7 0.2,-1.4 0.5,0.1 0.9,-1.5 0.6,-0.2 0.9,1 1.1,0.2 1.3,-0.8 h 1.4 l 2,-0.8 0.9,-0.9 z"
              id="NI"
              data-name="Nicaragua"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Norway"
              d="m 1053.7,67.5 -6.4,2.1 -3.2,0.5 0.8,-3.8 -5.8,-2.1 -5.9,1.8 -1.1,4 -3.4,2.4 -4.7,-1.3 -5.3,0.2 -5.1,-2.8 -2.2,1.4 -2.6,0.2 0.1,3.6 -8,-0.9 -0.6,3.1 h -4 l -2.3,3.9 -3.4,6.1 -5.7,7.9 1.8,2 -1.3,2.2 -4.3,-0.1 -2.4,5.4 1,7.7 3.1,2.9 -0.8,6.9 -3.4,4 -1.8,3.4 -3.3,-3.6 -8.6,6.8 -6.1,1.4 -6.5,-3 -1.8,-6.3 -2,-13.5 4,-3.7 11.3,-4.9 8.1,-5.9 7.2,-7.8 8.9,-10.7 6.4,-4.1 10.3,-6.8 8.5,-2.4 6.7,0.3 5.2,-4.4 7.4,0.2 7,-1 13.7,3.9 -4.9,1.4 z"
              id="path68"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Norway"
              d="m 1016.6,25.2 -7.6,1.9 -6.8,-1.1 2.2,-1.2 -2.6,-1.5 7.3,-0.9 1.9,1.7 z"
              id="path69"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Norway"
              d="m 991,16.7 12.6,3.4 -8.6,1.8 -1.2,3.4 -3,0.9 -0.9,4 -4.4,0.2 -8.5,-2.9 3,-1.7 -5.7,-1.4 -7.7,-3.9 -3.2,-3.5 9.3,-1.6 2.3,1.5 h 5 l 1,-1.5 5.2,-0.2 z"
              id="path70"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Norway"
              d="m 1015.4,13.7 7.4,1.5 -4.4,2.4 -10.1,0.5 -10.7,-0.8 -1,-1.2 h -5.1 l -4.3,-2 10.5,-1.2 5.4,1 3.1,-1.3 z"
              id="path71"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1409,322.9 0.2,2.7 1.5,4.1 -0.1,2.5 -4.6,0.1 -6.9,-1.5 -4.3,-0.6 -3.8,-3.2 -7.7,-0.9 -7.8,-3.6 -5.8,-3.1 -5.8,-2.4 0.9,-6 2.8,-3 1.9,-1.5 4.8,2 6.4,4.2 3.3,0.9 2.5,3.1 4.5,1.2 5,2.9 6.5,1.4 z"
              id="NP"
              data-name="Nepal"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Oman"
              d="m 1223.8,394.9 -2.2,-4.5 -5.2,-10.6 16.3,-6.4 2.6,-12.8 -3,-4.6 v -2.6 l 1.3,-2.6 -0.2,-2.6 2.4,-1.3 -1.1,-0.9 v -4.2 h 2.8 l 3,4.4 3.3,2.3 4.1,0.9 3.4,1.1 2.9,3.7 1.7,2.1 2,0.9 0.2,1.4 -1.7,3.8 -0.7,1.8 -2.2,2.1 -1.7,4.4 -2.5,-0.4 -1,1.6 -0.7,3.2 1.1,4.3 -0.5,0.8 h -2.5 l -3.3,2.4 -0.3,3.1 -1.2,1.4 -3.5,-0.1 -2,1.6 0.2,2.6 -2.6,1.8 -3.1,-0.6 -3.6,2.2 z"
              id="path72"
            />
            <path onMouseOver={ev => doHover(ev)} data-name="Oman" d="m 1236.2,336.7 -1.3,-2.2 1.4,-2.1 0.7,0.5 -0.2,2.7 z" id="path73" />
            <path onMouseOut={ev => doOut(ev)} data-name="Oman" d="m 1236.2,336.7 -1.3,-2.2 1.4,-2.1 0.7,0.5 -0.2,2.7 z" id="path73" />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1341.6,273.9 -3.8,5.4 -5.7,1 -8.5,-1.6 -2,2.8 3.3,5.6 2.9,4.4 5.1,3.1 -3.8,3.7 1,4.6 -3.9,6.5 -2.2,6.5 -4.5,6.7 -6.5,-0.5 -4.9,6.8 4,2.8 1.4,5 3.5,3.2 1.8,5.5 h -12.1 l -3.2,4.3 -4.2,-1.6 -2.2,-4.6 -4.9,-4.9 -10,1.2 -9,0.1 -7.6,0.9 1.1,-7.4 7.5,-3.4 -0.9,-2.9 -2.7,-1.1 -1,-5.6 -5.7,-2.8 -2.8,-3.9 -3.2,-3.4 9.6,3.3 5.3,-1 3.4,0.8 0.9,-1.4 3.9,0.6 6.6,-2.7 -0.8,-5.4 2.3,-3.7 h 4.1 l 0.2,-1.7 4,-0.9 2.1,0.6 1.8,-1.8 -1.1,-3.9 1.4,-3.8 3.1,-1.7 -3.1,-4.2 5.2,0.2 0.9,-2.3 -0.8,-2.5 2,-2.7 -1.4,-3.2 -1.9,-2.7 2.4,-2.8 5.3,-1.3 5.9,-0.8 2.4,-1.1 2.9,-0.8 4.7,3 2.9,5 z"
              id="PK"
              data-name="Pakistan"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 489.3,446.2 -0.7,0.9 1.1,3.8 -1.1,1.9 -1.8,-0.5 -0.9,3.1 -1.8,-1.8 -1,-3.5 1.4,-1.7 -1.4,-0.4 -0.9,-2.1 -2.8,-1.8 -2.4,0.4 -1.3,2.2 -2.4,1.6 -1.2,0.2 -0.6,1.4 2.5,3.5 -1.6,0.8 -0.8,0.9 -2.7,0.4 -0.8,-3.9 -0.8,1.1 -1.8,-0.4 -1,-2.5 -2.3,-0.5 -1.5,-0.7 h -2.4 l -0.2,1.4 -0.6,-1 0.3,-1.3 0.6,-1.3 -0.2,-1.1 0.9,-0.8 -1.1,-0.9 0.1,-2.6 2.2,-0.6 1.9,2.3 -0.2,1.4 2.2,0.3 0.6,-0.6 1.5,1.6 2.8,-0.5 2.5,-1.6 3.5,-1.3 2,-1.9 3.1,0.4 -0.2,0.6 3.1,0.2 2.4,1.2 1.8,1.9 z"
              id="PA"
              data-name="Panama"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 530.5,529.4 -5.1,-0.3 -0.8,1 -4.6,1.2 -6.3,4.4 -0.3,3 -1.4,2.2 0.7,3.5 -3.4,1.8 0.2,2.8 -1.5,1.1 2.6,5.8 3.3,3.9 -1,2.8 3.8,0.3 2.3,3.5 5,0.1 4.4,-3.7 0.1,9.7 2.6,0.7 3.2,-1.1 5.5,10.4 -1.1,2.1 v 4.6 l 0.3,5.4 -1.9,3.2 1.2,2.4 -1.1,2.2 2.9,5.4 -2.9,6.9 -1.1,3.3 -2.8,1.6 -5.9,-3.7 -0.8,-2.6 -11.7,-6.4 -10.7,-7.1 -4.7,-3.9 -2.8,-5.3 0.8,-1.9 -5.4,-8.4 -6.4,-11.8 -6,-12.8 -2.4,-3 -2,-4.7 -4.6,-4.2 -4.1,-2.6 1.7,-2.8 -3,-6.2 1.7,-4.5 4.4,-4 0.7,2.7 -1.6,1.5 0.3,2.3 2.3,-0.5 2.3,0.7 2.5,3.3 3.1,-2.7 0.9,-4.3 3.4,-5.6 6.7,-2.5 6.1,-6.8 1.7,-4.1 -0.8,-4.9 1.5,-0.6 3.8,3 1.8,3.1 2.6,1.6 3.5,6.7 4.2,0.9 3.1,-1.7 2.1,1.1 3.4,-0.6 4.4,3 -3.5,6.6 1.7,0.1 z"
              id="PE"
              data-name="Peru"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Philippines"
              d="m 1640.5,447.8 0.9,4.3 0.6,3.6 -1.6,5.8 -2.5,-6.5 -2.4,3.3 2.1,4.7 -1.4,3 -6.9,-3.7 -1.9,-4.7 1.5,-3 -3.8,-3.1 -1.6,2.7 -2.6,-0.3 -4,3.6 -1,-1.9 1.8,-5.4 3.4,-1.8 2.9,-2.4 2.2,2.9 4.2,-1.7 0.7,-2.9 4,-0.2 -0.8,-4.9 4.9,3 0.7,3.2 z"
              id="path74"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Philippines"
              d="m 1625.9,435.8 -1.8,2.1 -1.4,4.1 -1.6,1.9 -3.9,-4.4 1,-1.8 1.3,-1.8 0.2,-3.9 3.1,-0.4 -0.5,4.3 3.6,-6.2 z"
              id="path75"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Philippines"
              d="m 1595.6,442 -7.1,6.1 2.4,-4.5 3.8,-4 3,-4.4 2.3,-6.4 1.6,5.3 -3.5,3.5 z"
              id="path76"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Philippines"
              d="m 1613.1,425.5 3.6,2 h 3.5 l 0.2,2.6 -2.3,2.8 -3.4,1.9 -0.5,-3 0.1,-3.3 z"
              id="path77"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Philippines"
              d="m 1633.2,423.7 2.4,7.2 -4.5,-1.7 0.3,2.2 1.8,3.9 -2.6,1.5 -0.6,-4.6 -1.8,-0.3 -1.2,-3.9 3.3,0.5 -0.3,-2.4 -4,-4.9 5.4,0.1 z"
              id="path78"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Philippines"
              d="m 1610.2,417.9 -0.9,5.6 -2.7,-3.2 -3.5,-4.9 4.8,0.2 z"
              id="path79"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Philippines"
              d="m 1603.7,383 3.8,1.9 1.4,-1.7 0.8,1.6 -0.4,2.7 2.6,4.6 -0.6,5.3 -2.9,2.1 -0.1,5.2 2,5.1 3,0.7 2.4,-0.7 7.5,3.5 -0.1,3.5 2.1,1.6 -0.3,2.9 -4.7,-3.1 -2.5,-3.4 -1.2,2.4 -4,-3.9 -5,1 -3,-1.4 -0.1,-2.7 1.6,-1.6 -1.9,-1.5 -0.4,2.3 -3.3,-3.7 -1.3,-2.8 -1.1,-6.1 2.6,2.1 -1.1,-10.1 0.8,-5.8 z"
              id="path80"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Papua New Guinea"
              d="m 1808.1,545.6 -1.6,0.7 -2.3,-2.5 -2.2,-4.1 -0.8,-4.9 0.8,-0.6 0.5,1.9 1.6,1.5 2.4,4 2.5,2.2 z"
              id="path81"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Papua New Guinea"
              d="m 1786.7,537 -3,0.5 -1,1.8 -3.2,1.6 -3,1.5 h -3.1 l -4.5,-1.9 -3.1,-1.8 0.6,-2 5,1 3.2,-0.5 1,-3.1 0.9,-0.2 0.3,3.4 3.2,-0.4 1.8,-2.2 3.3,-2.3 -0.4,-3.8 3.4,-0.1 1.1,1 -0.4,3.6 z"
              id="path82"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Papua New Guinea"
              d="m 1722.9,560.4 1.6,-21 1,-20.9 9.6,4.4 10.3,3.7 3.7,3.3 3,3.2 0.6,3.8 9.2,4 1.1,3.4 -5.2,0.7 0.9,4.3 4.7,4.2 3,6.8 3.3,-0.2 -0.6,2.8 4.3,1.1 -1.8,1.2 5.7,2.7 -0.9,1.9 -3.8,0.4 -1.2,-1.6 -4.7,-0.8 -5.6,-0.9 -4,-4.1 -2.8,-3.6 -2.5,-5.6 -7.1,-2.8 -4.9,1.8 -3.7,2.2 0.3,4.7 -4.6,2.2 -3.1,-1.1 z"
              id="path83"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Papua New Guinea"
              d="m 1793.6,530.7 -1.8,1.7 -0.9,-3.8 -1.1,-2.4 -2.5,-2.1 -3.1,-2.8 -4,-1.9 1.6,-1.5 3,1.8 1.9,1.4 2.3,1.5 2.1,2.7 2.1,2.1 z"
              id="path84"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1019.9,154.8 5.9,0.7 8.8,-0.1 2.5,0.7 1.4,1.9 0.6,2.7 1.7,2.3 0.4,2.4 -2.8,1.3 1.9,2.8 0.5,2.8 3.2,5.4 -0.3,1.7 -2.3,0.7 -3.8,5.2 1.6,2.8 -1.1,-0.4 -5,-2.4 -3.5,0.9 -2.4,-0.6 -2.8,1.3 -2.7,-2.2 -1.9,0.9 -0.3,-0.4 -2.6,-3.1 -3.7,-0.3 -0.7,-2 -3.4,-0.7 -0.6,1.6 -2.8,-1.3 0.2,-1.7 -3.7,-0.5 -2.5,-2 -2.4,-3.9 0.2,-2.2 -1.5,-3.3 -1.9,-2.1 1.2,-1.7 -1.4,-3.1 3.1,-1.8 7.1,-2.8 5.8,-2 4.8,1 0.6,1.5 z"
              id="PL"
              data-name="Poland"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1600.3,229.9 1.4,1.1 -2.2,-0.4 -1,2.2 -0.3,2.1 2.8,4.6 -1.9,1.4 -0.3,1.1 -0.9,1.9 -2.9,1.1 -1.4,1.7 1.3,2.7 -0.3,0.7 2.6,1.1 4.4,2.8 v 1.5 l -2,0.4 -3.6,0.4 -0.6,2.8 -2.5,-0.2 v 0.6 l -3.2,-1.2 -0.1,1.2 -1.3,0.5 -0.7,-1.2 -1.7,-0.6 -1.9,-1 0.1,-2.8 0.9,-0.8 -1,-1.1 -0.4,-3.5 -0.9,-1 -3.4,-0.7 -3.4,-1.7 2.1,-4.1 3.9,-3.4 1.1,-4.6 3.6,2 4.6,0.3 -2.8,-3.4 6.4,-2.7 v -3.6 z"
              id="KP"
              data-name="Republic of Korea"
            /* data-name="Republic of North Korea" */
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 602.5,631.4 2,3.5 0.4,8.7 5.9,1.3 2.2,-1.3 3.9,1.8 1.2,1.9 1.1,5.9 0.8,2.4 2.1,0.3 2,-1 2.1,1.1 0.3,3.6 -0.3,3.8 -0.7,3.7 -0.3,5.6 -4.3,5 -4.2,1 -6.3,-1 -5.8,-1.7 4.2,-9.8 -1.1,-2.8 -5.9,-2.5 -7.3,-4.8 -4.6,-1 -11.3,-10.4 1.5,-7.7 -0.2,-3.5 2.1,-5.6 9.6,-1.9 5.2,0.1 5.4,3.3 z"
              id="PY"
              data-name="Paraguay"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1118.3,293.8 0.4,4 -0.6,1.9 -2.5,0.8 0.1,-1.7 1.3,-0.9 -1.5,-0.7 0.7,-4.2 z"
              id="PS"
              data-name="Palestine"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1210.1,343.7 -1.5,0.5 -1.8,-1.3 -0.8,-4.7 1.1,-3.3 1.5,-0.7 1.8,2 0.5,3.7 z"
              id="QA"
              data-name="Qatar"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1058.9,193.1 1.6,0.7 1.8,1.8 2,2.6 3.4,3.8 0.6,2.7 -0.2,2.7 1.3,2.9 2.4,1.2 2.3,-1.1 2.4,1.1 0.4,1.7 -2.3,1.3 -1.6,-0.6 -0.4,7.7 -3.1,-0.7 -4,-2.3 -5.9,1.5 -2.3,1.6 -7.6,-0.4 -4,-0.9 -1.9,0.4 -1.8,-2.6 -1,-1.1 1,-1.1 -1.3,-0.7 -1.5,1.4 -3.1,-1.9 -0.7,-2.6 -3.2,-1.4 -0.8,-2.1 -3,-2.4 3.9,-1.2 2.6,-4.3 1.9,-4.2 2.9,-1.3 2,-1.4 3.2,0.7 h 3.2 l 2.5,1.6 1.6,-1 3.6,-0.6 1,-1.5 z"
              id="RO"
              data-name="Romania"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1098.8,509.1 2.2,3.6 -0.3,3.8 -1.6,0.8 -3.1,-0.4 -1.7,3.7 -3.5,-0.5 0.6,-3.6 0.8,-0.5 0.2,-3.8 1.6,-1.8 1.4,0.7 z"
              id="RW"
              data-name="Rwanda"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 878.9,324.3 -0.1,0.4 -0.1,1.2 -0.2,9.8 -18,-0.4 -0.2,16.5 -5.2,0.5 -1.5,3.3 0.9,9.3 h -21.7 l -1.3,2.1 0.3,-2.7 h 0.1 l 12.5,-0.5 0.7,-2.3 2.4,-2.9 2,-8.9 7.9,-6.9 2.7,-8.1 1.8,-0.5 1.9,-5 4.6,-0.7 2,0.9 h 2.5 l 1.8,-1.5 3.4,-0.2 -0.1,-3.4 z"
              id="EH"
              data-name="Western Sahara"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1180.5,315 5,0.6 1.7,3.1 3.9,-0.2 2.7,5.6 2.9,1.4 1.2,2.3 4,2.7 0.7,2.6 -0.4,2.2 0.9,2.1 1.8,1.8 0.9,2.1 1,1.6 1.8,1.3 1.5,-0.5 1.3,2.5 0.3,1.4 2.7,6.6 16.9,3.2 1,-1.4 3,4.6 -2.6,12.8 -16.3,6.4 -15.9,2.5 -5,2.9 -3.5,6.7 -2.6,1.1 -1.5,-2.1 -2.1,0.3 -5.5,-0.7 -1.1,-0.6 -6.4,0.1 -1.5,0.6 -2.4,-1.6 -1.3,3.1 0.8,2.7 -2.4,2.1 -0.9,-2.8 -1.8,-1.9 -0.5,-2.6 -3.1,-2.3 -3.3,-5.4 -1.9,-5.2 -4.1,-4.4 -2.5,-1.1 -4.1,-6.1 -0.9,-4.4 v -3.8 l -3.6,-7.2 -2.8,-2.5 -3,-1.3 -2.1,-3.7 0.2,-1.4 -1.8,-3.4 -1.7,-1.4 -2.5,-4.8 -3.8,-5.1 -3.1,-4.4 h -2.7 l 0.5,-3.5 0.1,-2.3 0.4,-2.6 6.2,1.1 2.1,-2 1.1,-2.3 4.1,-0.9 0.7,-2.2 1.6,-1 -6,-6.5 10.4,-3.2 0.9,-1 6.8,1.8 8.6,4.5 16.8,12.9 z"
              id="SA"
              data-name="Saudi Arabia"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1131,409.2 -0.7,5.5 -2,6.4 -3.3,3.1 -2.3,5 -0.5,2.6 -2.6,1.8 -1.5,6.7 v 0.8 l -0.8,-0.2 0.1,-3.2 -0.8,-2.2 -2.9,-2.5 -0.9,-4.6 0.6,-4.8 -2.6,-0.4 -0.4,1.4 -3.4,0.4 1.5,1.8 0.5,3.9 -3,3.5 -2.7,4.6 -2.9,0.7 -4.8,-3.7 -2.1,1.3 -0.5,1.8 -2.9,1.3 -0.2,1.3 h -5.6 l -0.8,-1.3 -4.1,-0.3 -2,1.1 -1.6,-0.5 -2.9,-3.8 -1,-1.7 -4.1,0.9 -1.5,2.9 -1.3,5.8 -2,1.2 -1.7,0.7 -0.5,-0.3 -1.9,-1.9 -0.4,-2 0.8,-2.6 V 437 l -3.3,-4 -0.7,-2.7 v -1.6 l -2.1,-1.9 -0.1,-3.7 -1.3,-2.5 -1.9,0.4 0.5,-2.4 1.4,-2.6 -0.7,-2.7 1.8,-2 -1.2,-1.5 1.3,-3.9 2.5,-4.8 4.8,0.5 -1.1,-25.5 v -2.7 h 6.4 l -0.5,-12.8 h 22.3 21.5 22.1 l 2.1,6.3 -1.2,1.1 1.2,6.7 2.5,7.6 2.2,1.6 3.2,2.4 -2.7,3.6 -4,1.1 -1.7,2 -0.3,4.2 -2,9.5 z"
              id="SD"
              data-name="Sudan"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1118.1,441.1 0.2,5 -0.8,1.9 -3,0.2 -1.9,3.6 3.5,0.5 3,3.1 1,2.6 2.6,1.5 3.5,7 -3.8,4.2 -3.4,3.8 -3.5,3 h -4 l -4.5,1.5 -3.6,-1.5 -2.3,1.8 -5.1,-4.3 -1.4,-2.7 -3.1,1.3 -2.6,-0.4 -1.5,1.1 -2.6,-0.8 -3.5,-5.3 -0.9,-2 -4.3,-2.6 -1.4,-3.8 -2.4,-2.8 -3.9,-3.3 -0.1,-2.1 -3.1,-2.6 -3.9,-2.5 1.7,-0.7 2,-1.2 1.3,-5.8 1.5,-2.9 4.1,-0.9 1,1.7 2.9,3.8 1.6,0.5 2,-1.1 4.1,0.3 0.8,1.3 h 5.6 l 0.2,-1.3 2.9,-1.3 0.5,-1.8 2.1,-1.3 4.8,3.7 2.9,-0.7 2.7,-4.6 3,-3.5 -0.5,-3.9 -1.5,-1.8 3.4,-0.4 0.4,-1.4 2.6,0.4 -0.6,4.8 0.9,4.6 2.9,2.5 0.8,2.2 -0.1,3.2 z"
              id="SS"
              data-name="South Sudan"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 858,408 0.2,4 1.1,3.7 2,1.8 0.5,2.4 -0.3,2 -0.8,0.4 -3.1,-0.5 -0.4,0.7 -1.2,0.1 -4.1,-1.5 -2.7,-0.1 -10.4,-0.3 -1.5,0.8 -1.9,-0.2 -3,1 -0.8,-4.9 5.1,0.1 1.4,-0.9 h 1 l 2.1,-1.5 2.4,1.3 2.4,0.2 2.5,-1.5 -1.1,-1.8 -1.9,1 h -1.7 l -2.2,-1.6 -1.8,0.1 -1.3,1.6 -6.1,0.1 -2.3,-5 -2.7,-2.2 2.5,-1.3 2.8,-4.5 1.4,-3.3 2,-2 2.7,0.5 2.8,-1.4 h 3.1 l 2.7,1.8 3.6,1.7 3.4,4.8 z"
              id="SN"
              data-name="Senegal"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 868.5,447.9 -2.6,3 -2.6,3.4 -0.3,1.9 -1.4,2.1 -1.5,-0.5 -4,-2.6 -3,-3.4 -0.9,-2.4 -0.7,-4.7 3.1,-2.9 0.6,-1.7 1,-1.4 1.6,-0.2 1.3,-1.2 h 4.5 l 1.6,2.3 1.2,2.7 -0.2,1.9 0.9,1.7 -0.1,2.3 z"
              id="SL"
              data-name="Sierra Leone"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 432.5,415.9 -0.7,1.5 -3.3,-0.1 -2,-0.6 -2.2,-1.3 -3,-0.4 -1.5,-1.4 0.3,-0.9 2,-1.6 1.2,-0.7 -0.3,-0.8 1.4,-0.4 1.6,0.6 1.1,1.2 1.6,1.1 0.1,0.8 2.5,-0.7 1.2,0.4 0.7,0.7 z"
              id="SV"
              data-name="El Salvador"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1042,218.2 -1.1,1.4 0.7,2.4 2.8,2.7 -1.8,2 -0.6,2 0.6,0.8 -0.7,0.8 -2.4,0.2 -1.7,0.3 -0.3,-0.5 0.6,-0.7 0.4,-1.6 -0.7,0.1 -1.1,-1.2 -0.9,-0.3 -0.8,-1 -1,-0.4 -0.8,-0.9 -0.9,0.4 -0.5,2.1 -1.2,0.4 0.4,-0.5 -2.1,-1.3 -1.7,-0.7 -0.9,-0.9 -1.4,-1.1 1.1,-0.3 0.5,-2.9 -2.7,-2.5 1.1,-2.8 -1.9,0.1 1.7,-2.4 -1.7,-1.8 -1.5,-2.5 3.7,-1.6 3.2,0.3 3,2.4 0.8,2.1 3.2,1.4 0.7,2.6 3.1,1.9 1.5,-1.4 1.3,0.7 -1,1.1 z"
              id="RS"
              data-name="Serbia"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 621,464.9 -3.1,5.5 0.3,4.4 2.2,3.8 -1.1,2.7 -0.5,3 -1.5,2.7 -3.2,-1.4 -2.7,0.7 -2.3,-0.6 -0.6,1.9 1,1.2 -0.6,1.4 -3.1,-0.6 -3.3,-5.6 -0.7,-3.6 H 600 l -2.4,-4.6 1.1,-3.4 -0.3,-1.5 3.5,-1.6 1,-5.8 6.8,1.3 0.6,-1.2 4.6,-0.5 z"
              id="SR"
              data-name="Suriname"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1038.1,187.7 -1.2,1.7 -0.7,2.5 -1,0.6 -5.5,-1.9 -1.6,0.4 -1,1.5 -2.3,0.8 -0.6,-0.4 -2.3,0.9 -1.9,0.2 -0.3,1.3 -4.1,0.7 -1.9,-0.6 -2.7,-1.7 -0.7,-2.1 0.3,-0.8 0.6,-1.4 2.2,0.1 1.6,-0.6 0.1,-0.6 0.9,-0.3 0.2,-1.4 1.1,-0.3 0.7,-1.1 h 1.5 l 0.3,0.4 1.9,-0.9 2.7,2.2 2.8,-1.3 2.4,0.6 3.5,-0.9 z"
              id="SK"
              data-name="Slovakia"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1009.8,203.9 -3.9,1.7 -0.3,2.5 -1.7,0.7 0.1,1.7 -2,-0.1 -1.8,-1 -0.8,1 -3.6,-0.2 1.1,-0.5 -1.4,-2.7 0.4,-3.1 4.2,0.5 2.4,-1.5 4.4,-0.1 0.9,-1.1 0.8,0.1 z"
              id="SI"
              data-name="Slovenia"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1028.2,87 -7,1.6 -3.5,3.9 1.3,3.5 -6.2,4.5 -7.8,5 -2.1,8.1 3.7,4.1 4.8,3.3 -3.3,6.6 -4.6,1.4 -0.6,10 -2.1,5.7 -5.7,-0.6 -2.2,4.8 -5.5,0.3 -1.9,-5.7 -4.5,-6.9 -4.2,-8.4 1.8,-3.4 3.4,-4 0.8,-6.9 -3.1,-2.9 -1,-7.7 2.4,-5.4 4.3,0.1 1.3,-2.2 -1.8,-2 5.7,-7.9 3.4,-6.1 2.3,-3.9 h 4 l 0.6,-3.1 8,0.9 -0.1,-3.6 2.6,-0.2 6,2.7 7.2,3.7 1.8,8.5 z"
              id="SE"
              data-name="Sweden"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1101.7,667.7 0.6,2.9 0.3,2.9 -1.4,2.8 -3.2,0.7 -3.1,-3.5 0.1,-2.2 1.7,-2.4 0.6,-1.9 1.7,-0.4 z"
              id="SZ"
              data-name="eSwatini"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1135,287.5 -9.7,6.9 -6.3,-2.6 h -0.1 l 0.6,-1 -0.4,-2.6 0.9,-3.5 2.7,-2.5 -1.2,-2.5 -2.5,-0.3 -1.1,-4.9 1,-2.7 1.3,-1.4 1.2,-1.4 -0.2,-3.5 1.9,1.2 5.6,-1.8 3,1.2 h 4.4 l 5.7,-2.4 2.9,0.1 5.9,-1 -2.1,4 -2.7,1.6 1.2,4.7 -1,7.7 z"
              id="SY"
              data-name="Syria"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1059.2,376.1 1.1,25.5 -4.8,-0.5 -2.5,4.8 -1.3,3.9 1.2,1.5 -1.8,2 0.7,2.7 -1.4,2.6 -0.5,2.4 1.9,-0.4 1.3,2.5 0.1,3.7 2.1,1.9 v 1.6 l -3.6,1.1 -2.8,2.6 -4,7 -5.2,3 -5.5,-0.4 -1.6,0.6 0.6,2.2 -2.9,2.3 -2.4,2.5 -7.1,2.4 -1.4,-1.4 -1,-0.2 -1,1.7 -4.6,0.5 0.8,-1.8 -1.8,-4.4 -0.8,-2.6 -2.5,-1.1 -3.4,-3.8 1.2,-3 2.6,0.6 1.6,-0.4 h 3.2 l -3.2,-5.8 0.2,-4.3 -0.5,-4.2 -2.3,-4.1 0.6,-3.1 -3.7,-0.1 V 412 l -2.4,-2.4 2.3,-8.5 7,-6 0.2,-8.4 1.8,-13 1.2,-2.8 -2.4,-2.2 -0.1,-2 -2.2,-1.7 -1.6,-10 5.5,-3.5 22.5,12.3 z"
              id="TD"
              data-name="Chad"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 931.4,431.2 -0.7,3.4 1.7,1.9 2,2.2 0.2,3.2 1.2,1.3 -0.3,14.8 1.4,4.4 -4.5,1.4 -1.3,-2.3 -1.5,-4.1 -0.5,-3.2 1.3,-5.7 -1.4,-2.4 -0.6,-5 v -4.7 l -2.3,-3.3 0.4,-2 z"
              id="TG"
              data-name="Togo"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1517.5,410.2 -5.3,-0.9 -7.1,1.2 -3.1,5.3 2.1,7.8 -5.3,-3 -4.8,0.2 0.3,-5.1 h -4.9 l 0.2,7.1 -2.2,9.4 -1.4,5.7 0.7,4.6 3.7,0.2 2.7,5.9 1.3,5.5 3.4,3.7 3.4,0.7 3.1,3.4 -1.7,2.6 -3.7,0.8 -0.6,-3.3 -4.8,-2.8 -0.9,1.1 -2.3,-2.4 -1.2,-3.2 -3.2,-3.6 -2.9,-3.1 -0.7,3.8 -1.3,-3.6 0.4,-4 1.2,-6.1 2.2,-6.6 2.6,-6 -2.7,-5.9 -0.2,-3 -1,-3.6 -4.3,-5.1 -1.8,-3.2 1.8,-1.2 1.4,-5.5 -2.9,-4.3 -4.1,-4.7 -3.5,-5.6 2.2,-1.2 1.5,-6.9 3.9,-0.3 2.8,-2.8 3,-1.5 2.7,2 0.9,3.9 3.8,0.3 -0.4,6.7 1,5.8 5.3,-3.8 1.9,1.1 3.2,-0.2 0.8,-2.2 4.3,0.4 5,5.2 1.3,6.4 5.3,5.6 0.4,5.4 z"
              id="TH"
              data-name="Thailand"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1297,243.6 -1.4,1.9 -6,-1 0.6,3.6 5.5,-0.5 7.1,2.1 9.6,-1 3.1,6 1.5,-0.7 3.7,1.5 0.5,2.5 1.8,3.6 h -5.4 l -3.8,-0.5 -2.5,2.9 -2.2,0.6 -1.5,1.4 -2.7,-2.1 -0.9,-5.4 -1.7,-0.3 0.1,-2 -3.3,-1.4 -1.7,2.2 0.2,2.6 -0.6,0.9 -3.2,-0.1 -0.9,2.9 -2.1,-1.2 -3.4,2 -1.8,-0.7 1.3,-6.5 -2.4,-4.8 -4.2,-1.5 0.6,-2.8 4.4,0.3 1.5,-3.5 0.5,-4.1 6.5,-1.5 -0.2,3 1.3,1.7 z"
              id="TJ"
              data-name="Tajikistan"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1278.3,262 -1.6,-0.2 -2.9,-1.7 -0.3,2.2 -4.2,1.3 0.2,5.1 -2.6,2 -4,0.9 -0.4,2.9 -3.9,0.9 -5.9,-2.5 -1.7,-5.3 -4,-0.3 -7.3,-5.6 -4.3,-0.7 -6.6,-3.3 -3.9,-0.6 -2,1.2 -3.6,-0.2 -3,3.7 -4.4,1.2 -1.9,-4.5 -0.6,-6.7 -4.6,-2.2 0.4,-4.3 -3.5,-0.4 -0.1,-5.4 5.3,1.6 4.1,-2 -4.7,-3.9 -2.4,-3.6 -3.8,1.6 0.6,4.7 -2.6,-4.1 1.8,-2.2 5.6,-1.3 3.9,1.8 4.8,5 2.6,-0.3 5.9,-0.1 -1.7,-3.2 3.8,-2.2 3.4,-3.7 7.9,3.4 1.9,5 2.3,1.3 5.5,-0.3 2.1,1.2 4.3,6.6 7.1,4.4 4.2,3 6.3,3.1 7.7,2.8 z"
              id="TM"
              data-name="Turkmenistan"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1632.7,562.1 0.1,-1.9 -0.5,-1.3 0.8,-1.5 4.9,-1.4 4,-0.3 1.8,-0.8 2.1,0.8 -2.2,1.8 -6.1,2.8 z"
              id="TL"
              data-name="Timor-Leste"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 988.2,289.1 -0.1,4.9 -2.6,1.8 -1.6,2.1 -3.6,2.5 0.6,2.6 -0.4,2.8 -2.6,1.4 -2.6,-11.5 -3.4,-2.6 -0.1,-1.5 -4.5,-3.9 -0.6,-4.8 3.2,-3.6 1.1,-5.3 -1,-6.1 1,-3.3 5.7,-2.5 3.7,0.7 v 3.3 l 4.4,-2.4 0.4,1.2 -2.5,3.2 0.1,2.9 1.9,1.6 -0.5,5.6 -3.5,3.2 1.2,3.5 2.8,0.1 1.4,3.1 z"
              id="TN"
              data-name="Tunisia"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Turkey"
              d="m 1141.7,235.3 5.5,-0.3 5.6,3.2 1.3,2.2 0.1,3.1 4.2,1.6 2.4,1.8 -3.3,1.9 2.9,7.3 -0.7,2 3.8,5.1 -2.4,1.1 -2.1,-1.6 -6.3,-0.9 -2.1,1 -5.9,1 -2.9,-0.1 -5.7,2.4 h -4.4 l -3,-1.2 -5.6,1.8 -1.9,-1.2 0.2,3.5 -1.2,1.4 -1.3,1.4 -2.3,-2.9 1.7,-2.4 -3.2,0.6 -4.6,-1.5 -3.2,3.7 -8,0.7 -4.7,-3.4 -5.7,-0.2 -1,2.6 -3.6,0.8 -5.4,-3.4 -5.8,0.1 -3.8,-6.4 -4.2,-3.5 2,-5 -3.6,-3.1 5.1,-6.1 8,-0.2 1.6,-4.9 10,0.9 5.6,-4.1 5.8,-1.8 8.5,-0.2 9.8,4.5 7.9,2.5 5.8,-1 4.6,0.6 z"
              id="path85"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Turkey"
              d="m 1061.9,239.9 1.2,-0.7 1.1,-4 -2.7,-1.7 5,-2 4.6,0.8 0.9,2.5 4.8,2 -0.7,1.6 -6.2,0.3 -2,2 -3.9,3.4 -2,-2.9 z"
              id="path86"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1597.9,355.5 -1.4,5.3 -4,-5.5 -1.5,-4.7 1.9,-6.3 3.3,-4.9 3,1.9 -0.1,3.9 z"
              id="TW"
              data-name="Taiwan"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1107,508.4 -0.2,3.9 -1.1,4.5 1.6,2.5 2.5,-1.5 3.3,-0.4 0.7,0.8 3.3,-1.6 -2.3,-2.2 1.9,-2.9 2.8,-2.9 20.5,13.1 0.3,3.7 8.1,6.4 -2.8,8 0.3,3.6 3.5,2.3 0.2,1.7 -1.7,3.9 0.3,1.9 -0.4,3.1 1.8,4 2.2,6.4 2,1.4 -4.6,3.7 -6.2,2.5 -3.4,-0.1 -2.1,1.9 -3.9,0.2 -1.5,0.8 -6.7,-1.8 -2.2,0.2 0.1,-0.1 -1.8,-2.4 -0.3,-6.8 -2.9,-3.4 -0.4,1.2 -1,-1.7 -5.5,-1.2 -3.2,-1.9 -3.6,-1.1 -2.2,-1.1 -0.3,-0.2 -2.7,-6.6 -0.4,-3.9 -4.5,-4.4 1.4,-2.4 -1.1,-2.6 0.2,-2.7 -1,-0.9 0.3,-2.8 0.6,-0.1 2,-2.3 2.3,-3.4 1.4,-1.3 v -2.1 l -1.2,-1.5 -0.3,-2.5 1.6,-0.8 0.3,-3.8 -2.2,-3.6 2,-0.8 z"
              id="TZ"
              data-name="Tanzania"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1119,474.5 2.7,4.5 0.7,3.2 2.6,7.4 -2.1,4.7 -2.8,4.2 -1.6,2.6 v 0.3 l -0.2,-0.4 -3,-1.3 -2.4,1.6 -3.6,0.9 -2.6,3.7 0.3,2.5 -6.2,-0.1 -2,0.8 -3.4,2 -1.4,-0.7 0.1,-4.8 1.3,-2.5 0.3,-5.1 1.2,-3 2.2,-3.3 2.1,-1.8 1.9,-2.2 -2.3,-0.9 0.3,-7.5 2.3,-1.8 3.6,1.5 4.5,-1.5 h 4 z"
              id="UG"
              data-name="Uganda"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1097.2,174.6 2.3,2.7 0.1,1.2 6.7,2.2 3.6,-1 3.6,2.9 2.9,-0.1 7.7,2 0.4,1.9 -1.3,3.2 1.8,3.5 -0.3,2.1 -4.8,0.4 -2.2,1.8 0.4,2.7 -3.9,0.5 -3,2.1 -4.6,0.3 -4,2.4 1,3.9 2.8,1.5 5.1,-0.4 -0.6,2.3 -5.4,1.1 -6.3,3.6 -3.1,-1.3 0.7,-2.9 -5.9,-1.9 0.7,-1.2 4.6,-2.1 -1.7,-1.4 -8.1,-1.6 -0.8,-2.4 -4.5,0.8 -1.3,3.5 -3.3,4.6 -2.4,-1.1 -2.3,1.1 -2.4,-1.2 1.2,-0.7 0.6,-2.1 1.1,-2.1 -0.6,-1.1 1,-0.5 0.6,0.9 3,0.2 1.3,-0.5 -1,-0.6 0.2,-1 -2,-1.6 -1.1,-2.6 -2,-1 0.1,-2.1 -2.6,-1.7 -2,-0.3 -4,-1.9 -3.2,0.6 -1.1,0.9 h -2.1 l -1,1.5 -3.6,0.6 -1.6,1 -2.5,-1.6 h -3.2 l -3.2,-0.7 -2,1.4 -0.5,-1.7 -3,-1.7 0.7,-2.5 1.2,-1.7 1.1,0.4 -1.6,-2.8 3.8,-5.2 2.3,-0.7 0.3,-1.7 -3.2,-5.4 2.3,-0.3 2.4,-1.6 3.8,-0.2 4.9,0.5 5.7,1.5 3.9,0.1 1.9,0.9 1.7,-1.1 1.5,1.5 4.3,-0.3 2.1,0.6 -0.3,-3.1 1.3,-1.4 4.1,-0.3 1.8,0.2 1,-1.4 1.5,0.3 4.9,-0.6 3.8,3.5 -0.9,1.3 0.8,1.9 z"
              id="UA"
              data-name="Ukraine"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 639.7,718.6 -1.6,4.1 -5.4,3.5 -4.2,-1.3 -2.8,0.7 -5.5,-2.7 -3.6,0.2 -3.9,-3.6 -0.4,-4.1 0.9,-1.4 -1.2,-6.4 0.4,-6.6 0.5,-5.2 3.4,-0.7 6.3,5 1.9,-0.2 6.3,4.1 4.8,3.6 3.8,4.3 -1.8,3.1 z"
              id="UY"
              data-name="Uruguay"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1292.7,230.7 1.7,0.6 -3,4.1 4.6,2.4 3.2,-1.6 7.2,3.4 -5.3,4.6 -4.1,-0.6 -2.1,0.1 -1.3,-1.7 0.2,-3 -6.5,1.5 -0.5,4.1 -1.5,3.5 -4.4,-0.3 -0.6,2.8 4.2,1.5 2.4,4.8 -1.3,6.5 -4.3,-1.4 h -3 l -0.8,-3.9 -7.7,-2.8 -6.3,-3.1 -4.2,-3 -7.1,-4.4 -4.3,-6.6 -2.1,-1.2 -5.5,0.3 -2.3,-1.3 -1.9,-5 -7.9,-3.4 -3.4,3.7 -3.8,2.2 1.7,3.2 -5.9,0.1 -6.2,-23.4 12,-3.7 1.1,0.5 9.2,4.5 4.8,2.4 6.6,5.7 5.7,-0.9 8.6,-0.5 7.6,4.6 1.5,6.4 2.6,0.1 2.5,5.2 6.7,0.2 2.3,3 h 2 l 0.9,-4.6 5.4,-4.4 z"
              id="UZ"
              data-name="Uzbekistan"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 588.7,448.1 -4.7,3.8 -0.5,2.3 1.8,2.4 -1.4,1.2 -3.5,1 v 3 l -1.6,1.8 3.7,4.8 0.7,1.8 -2.1,2.5 -6.4,2.4 -4.1,1 -1.7,1.5 -4.5,-1.6 -4.1,-0.8 -1.1,0.6 2.5,1.6 -0.3,4.3 0.7,4.1 4.8,0.5 0.3,1.4 -4.1,1.8 -0.7,2.7 -2.4,1.1 -4.2,1.5 -1.1,2 -4.4,0.4 -3.1,-3.4 -1.6,-6.4 -1.5,-2.3 -2,-1.4 2.9,-3.2 -0.2,-1.4 -1.5,-1.9 -1.1,-4.3 0.6,-4.6 1.3,-2.2 1.2,-3.4 -2,-1.1 -3.2,0.7 -4.1,-0.3 -2.3,0.7 -3.8,-5.6 -3.3,-0.8 -7.3,0.6 -1.2,-2.2 -1.4,-0.5 -0.1,-1.4 0.7,-2.4 -0.3,-2.5 -1.2,-1.5 -0.6,-2.9 -2.9,-0.4 1.8,-3.8 0.9,-4.6 1.8,-2.4 2.3,-1.8 1.6,-3.2 3.7,-1.1 -0.2,1.5 -3.4,0.8 1.7,2.9 -0.3,3.4 -2.7,3.7 1.9,5.1 2.5,-0.4 1.5,-4.7 -1.7,-2.2 v -4.9 l 7.2,-2.6 -0.6,-3 2.1,-2.1 1.7,4.6 4,0.1 3.4,3.5 0.2,2.2 h 5 l 6.1,-0.6 3.1,2.8 4.2,0.8 3.3,-2 0.1,-1.6 7.1,-0.4 6.7,-0.1 -4.9,1.9 1.8,3.1 4.5,0.4 4.2,3.2 0.7,5.1 2.9,-0.1 z"
              id="VE"
              data-name="Venezuela"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1526.5,363.5 -6.5,5.4 -3.7,6.1 -0.6,4.5 5.3,6.7 6.5,8.4 5.7,4 4.1,5.1 4,11.9 0.4,11.3 -4.3,4.2 -6.1,4.2 -4.2,5.3 -6.6,6 -2.3,-4.1 1.2,-4.4 -4.4,-3.6 4.6,-2.6 5.9,-0.5 -2.8,-3.8 9,-5 -0.1,-7.7 -1.8,-4.3 0.2,-6.4 -2,-4.5 -4.9,-4.5 -4.4,-5.6 -5.7,-7.6 -7.3,-3.9 1.2,-2.3 3.3,-1.7 -3,-5.6 h -6.8 l -3.5,-5.8 -4,-5.1 2.7,-1.6 4.4,0.1 5.3,-0.8 4.1,-3.4 3.1,2.4 5.3,1.2 -0.3,3.7 3.1,2.6 z"
              id="VN"
              data-name="Vietnam"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1223.8,394.9 -4,1.7 -0.9,2.9 v 2.2 l -5.4,2.7 -8.8,3 -4.7,4.5 -2.5,0.4 -1.7,-0.4 -3.2,2.7 -3.5,1.2 -4.7,0.3 -1.4,0.4 -1.1,1.7 -1.5,0.5 -0.8,1.6 -2.8,-0.2 -1.7,0.9 -4,-0.3 -1.6,-3.8 v -3.5 l -1,-1.9 -1.3,-4.7 -1.8,-2.6 1.1,-0.4 -0.7,-2.9 0.6,-1.2 -0.4,-2.8 2.4,-2.1 -0.8,-2.7 1.3,-3.1 2.4,1.6 1.5,-0.6 6.4,-0.1 1.1,0.6 5.5,0.7 2.1,-0.3 1.5,2.1 2.6,-1.1 3.5,-6.7 5,-2.9 15.9,-2.5 5.2,10.6 z"
              id="YE"
              data-name="Yemen"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1102.1,556.8 0.3,0.2 2.2,1.1 3.6,1.1 3.2,1.9 2.6,2.9 1.3,5.4 -1,1.7 -1.3,5.2 0.9,5.4 -1.8,2.2 -2,6 2.9,1.6 -17.2,5.3 0.4,4.6 -4.3,0.9 -3.3,2.5 -0.8,2.2 -2,0.6 -5.1,5.2 -3.2,4.2 -1.9,0.1 -1.8,-0.7 -6.2,-0.7 -1,-0.5 v -0.5 l -2.2,-1.5 -3.6,-0.3 -4.6,1.4 -3.6,-4 -3.6,-5.2 0.8,-20.5 11.7,0.1 -0.4,-2.2 0.9,-2.4 -0.9,-3 0.7,-3.1 -0.6,-2 1.9,0.1 0.3,2 2.7,-0.1 3.5,0.6 1.9,2.9 4.4,0.9 3.5,-2 1.2,3.3 4.3,0.9 2,2.8 2.2,3.5 h 4.3 l -0.2,-6.9 -1.6,1.2 -3.9,-2.5 -1.5,-1.2 0.9,-6.4 1.1,-7.6 -1.2,-2.8 1.7,-4.1 1.5,-0.8 7.7,-1.1 0.9,0.3 -0.3,1.4 1.9,0.5 1.2,1.3 1,-0.3 z"
              id="ZM"
              data-name="Zambia"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1099.4,644.7 -2.9,-0.7 -1.9,0.8 -2.7,-1.1 h -2.2 l -3.4,-2.9 -4.3,-1 -1.5,-4.1 0.1,-2.3 -2.3,-0.7 -6.1,-7 -1.6,-3.7 -1.1,-1.2 -1.9,-5.1 6.2,0.7 1.8,0.7 1.9,-0.1 3.2,-4.2 5.1,-5.2 2,-0.6 0.8,-2.2 3.3,-2.5 4.3,-0.9 0.2,2.4 4.7,-0.1 2.6,1.3 1.1,1.6 2.7,0.5 2.8,2 -0.4,8.2 -1.3,4.4 -0.4,4.8 0.8,1.9 -0.9,3.8 -0.8,0.6 -1.7,4.6 z"
              id="ZW"
              data-name="Zimbabwe"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1162.1,512.6 -3.3,-5.3 -0.2,-23.4 4.9,-7.2 1.5,-2.1 3.6,-0.1 5,-4.5 7.3,-0.3 15.6,-19.3 -4.8,0.1 -18.7,-7.6 -2.2,-2.3 -2.2,-3.1 -2.2,-3.6 1.2,-2.2 1.9,-3.5 1.9,1.2 1.2,2.7 2.7,2.7 h 2.8 l 5.2,-1.7 6.1,-0.7 4.9,-2 2.8,-0.4 2,-1.2 3.2,-0.2 1.8,-0.2 2.5,-0.9 3,-0.7 2.5,-2.2 h 2.2 l 0.2,1.8 -0.4,3.7 0.2,3.4 -1.1,2.3 -1.4,7 -2.4,7.1 -3.3,8.2 -4.6,9.4 -4.7,7.2 -6.6,8.8 -5.6,5.2 -8.4,6.4 -5.3,4.8 -6.2,7.8 -1.3,3.4 z"
              id="SO"
              data-name="Somalia"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1037.8,230.8 -1.2,0.3 -2.9,1 -0.1,1.3 -0.7,-0.1 -0.6,-2.3 -1.3,-0.7 -1.2,-1.7 0.8,-1.4 1.2,-0.4 0.5,-2.1 0.9,-0.4 0.8,0.9 1,0.4 0.8,1 0.9,0.3 1.1,1.2 0.7,-0.1 -0.4,1.6 -0.6,0.7 z"
              id="XK"
              data-name="Kosovo"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1099.4,644.7 2.2,9 1.1,4.6 -1.4,7.1 0.4,2.3 -2.7,-1.1 -1.7,0.4 -0.6,1.9 -1.7,2.4 -0.1,2.2 3.1,3.5 3.2,-0.7 1.4,-2.8 h 4.1 l -1.7,4.7 -1,5.3 -1.7,2.9 -4,3.3 -1.1,0.9 -2.6,3.3 -1.8,3.3 -3.5,4.6 -6.7,6.6 -4.1,3.8 -4.3,3 -5.9,2.4 -2.7,0.4 -0.9,1.8 -3.2,-1 -2.7,1.2 -5.7,-1.2 -3.3,0.8 -2.2,-0.4 -5.8,2.6 -4.6,1 -3.5,2.4 -2.4,0.2 -2.1,-2.3 -1.8,-0.1 -2.2,-2.9 -0.3,0.9 -0.6,-1.7 0.3,-3.8 -1.5,-4.3 1.8,-1.2 0.1,-4.9 -3.3,-6 -2.4,-5.4 v -0.1 l -3.6,-8.3 2.8,-3.2 2,1.8 0.8,2.7 2.5,0.5 3.4,1.2 2.9,-0.5 5,-3.3 1.1,-23.7 1.4,1 3,6.1 -0.6,3.9 1.1,2.3 4,-0.7 2.8,-2.9 2.7,-1.9 1.5,-3.1 2.8,-1.4 2.3,0.7 2.5,1.8 4.5,0.3 3.6,-1.4 0.6,-2 1.2,-3.1 3,-0.5 1.8,-2.4 2,-4.3 5.2,-4.8 8.1,-4.7 h 2.2 l 2.7,1.1 1.9,-0.8 z m -20.3,53.2 1.1,-2 3.1,-1 1.1,-2.1 1.9,-3.1 -1.7,-2 -2.2,-2 -2.7,1.4 -3.1,2.5 -3.2,4 3.7,5 z"
              id="ZA"
              data-name="South Africa"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="New Zealand"
              d="m 1826.2,764.4 -0.8,2.6 5.6,-2.6 -0.5,2.7 -2.1,2.7 -4.2,2.9 -7.1,4.7 -4.7,2.6 -0.6,3 -4,0.1 -6.3,2.4 -4.7,4.1 -8.2,6.4 -6.3,2.8 -4,1.8 -4.6,-0.1 -1.5,-2.1 -5.1,-0.4 1,-2.4 6.5,-4.6 11.4,-6.3 4.3,-1.2 5.6,-2.4 7,-3.3 5.7,-3.3 6,-4.7 3.1,-1.6 3.5,-3.6 5.8,-2.9 z"
              id="path87"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="New Zealand"
              d="m 1855.2,733.9 -0.4,6.8 2.9,-4.4 1.3,1.8 -2.4,4.8 2.9,2.1 3.2,0.5 4.7,-2.4 2.2,0.7 -5.2,5.7 -4.2,3.7 -3.9,-0.1 -2.8,1.9 -1.5,2.8 -1.6,1.1 -4.6,3.5 -5.9,4.3 -6,2.6 0.5,-1.7 -1.5,-0.9 6.9,-5.2 0.9,-3.6 -3.8,-2.5 1.8,-2.3 5.3,-2.2 4.2,-5 2.5,-4.1 0.6,-4.3 0.8,-1.1 -0.9,-2.7 -0.7,-5.6 0.4,-4.6 2.2,-0.5 0.9,3.6 3.2,1.6 z"
              id="path88"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Chile"
              d="m 595.1,837.9 6,13.6 h 5 l 3,0.2 -0.5,2.4 -3.2,1.9 -2.4,-0.2 -3.1,-0.5 -4.2,-1.8 -5.4,-0.9 -7.5,-3.4 -6.4,-3.2 -9.8,-6.9 4.6,1.3 8.6,4.1 7.3,2.2 1.2,-2.8 -0.3,-4.2 3.4,-2.6 z"
              id="path89"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Chile"
              d="m 554.4,647.8 0.9,1.6 -1.2,6.7 -5.6,3.1 1.6,10.7 -0.8,2.1 2,2.5 -3.3,4 -2.6,6 -0.9,5.9 1.7,6.2 -2.1,6.6 4.9,11.1 1.6,1.2 1.4,5.9 -1.6,6.2 1.4,5.4 -3,4.2 1.6,5.8 3.3,6.3 -2.5,2.3 0.2,5.7 0.8,6.5 3.3,7.8 -1.7,1.3 3.7,7.3 3.1,2.4 -0.8,2.7 2.8,1.2 1.4,2.4 -1.8,1.2 1.8,3.7 1.1,8.3 -0.7,5.4 1.8,3.2 -0.1,3.9 -2.7,2.8 3.1,6.5 2.6,2.3 3.1,-0.4 1.9,4.6 3.5,3.6 12.1,0.8 4.9,1 h -4.3 l -1.7,1.5 -3.4,2.2 1.7,5.7 -1.9,0.1 -6.3,-1.9 -7.5,-4.3 -7.6,-3.5 -3.2,-3.9 -0.3,-3.6 -4.2,-4.2 -5,-10.6 -0.2,-6 3.4,-4.8 -8.3,-1.9 2.7,-5.5 -2,-10.5 6.5,2.2 -1.8,-13.1 -4,-1.7 1,7.9 -3.5,-0.9 -1.5,-9 -2,-11.8 1.1,-4.4 -3.3,-6.2 -2.4,-7.2 2.2,-0.3 0.6,-10.3 1.2,-10.3 0.1,-9.5 -3.3,-9.7 0.6,-5.3 -2.1,-7.9 1.8,-7.8 -0.9,-12.4 v -13.4 l 0.1,-14.3 -1.5,-10.5 -2.1,-9.1 2.8,-1.6 1.1,-3.3 3.2,4.4 1.2,4.6 3.2,2.7 -1.1,6.2 3.7,7.2 3.1,8.9 z"
              id="path90"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 956.5,177.1 -2.8,-1.5 -3.1,-2.7 -4.5,1.3 -3.6,-0.5 2.5,-1.7 4,-9 6.5,-2.6 4,0.2 0.9,2.1 -0.9,5.6 -1.2,2.3 h -2.9 z"
              id="NL"
              data-name="Netherlands"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 886.9,263.7 -2.2,1.6 -2.8,-0.9 -2.7,0.7 0.9,-5 -0.3,-3.9 -2.4,-0.6 -1.1,-2.4 0.5,-4.2 2.2,-2.3 0.5,-2.6 1.2,-3.8 v -2.7 l -0.9,-2.3 -0.2,-2.2 1.9,-1.6 2.2,-0.9 1.2,3.1 h 3 l 0.9,-0.8 3.1,0.2 1.3,3.2 -2.4,1.7 -0.3,5 -0.8,0.9 -0.3,3.1 -2.3,0.5 2,3.8 -1.6,4.2 1.8,1.9 -0.8,1.7 -2,2.4 z"
              id="PT"
              data-name="Portugal"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Russia"
              d="m 1629.5,177.4 13.7,11 -8.9,-2 3.7,9 9.6,6.4 3,4.4 -6.5,-3.8 0.1,4.9 -4.7,-5.3 -3.8,-6.1 -5.6,-6.7 -2.4,-4.8 -6.4,-8.2 -8,-6.1 -6.8,-8.4 1.9,-2.8 -4.4,-2.8 1.3,-0.9 4.9,4 6.9,5.9 5.2,6.1 z"
              id="path91"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Russia"
              d="m 1034.6,155.4 -8.8,0.1 -5.9,-0.7 0.7,-2.6 6.3,-2 5.1,1.1 2.2,0.9 -0.2,1.7 z"
              id="path92"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Russia"
              d="m 1488.4,48.2 -5.9,0.1 -8.9,-0.6 -1,-0.3 0.7,-2 4.2,-0.5 8.4,2 z"
              id="path93"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Russia"
              d="m 1501,38.7 -1.1,2 -6.9,-0.4 -10.3,-2 -1.8,-1.6 8.3,0.7 z"
              id="path94"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Russia"
              d="m 1475.5,36.3 3.1,3.8 -14.3,-0.2 -4.6,1.2 -12.5,-3.3 -3.4,-3.4 3.5,-0.9 10.2,0.2 z"
              id="path95"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Russia"
              d="m 1158.8,61.3 -2.2,0.4 -13.5,-0.7 -2.3,-2.3 -7.9,-1.4 -2,-2.9 3.5,-1.1 -1.6,-2.8 5.4,-4.4 -4,-0.6 6.7,-4.5 -2.5,-2.3 6.8,-2.6 10.3,-3.2 11.7,-0.9 5,-1.8 6.7,-0.6 4.2,1.9 -1.3,1.5 -11.4,2.5 -9.9,2.3 -8.7,4.8 -2.8,5 -3.3,5 3.1,4.3 z"
              id="path96"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Russia"
              d="m 1601.7,231 -1.4,-1.1 -1.9,-3.3 2.5,-0.1 -3.9,-7.5 -4.7,-5.4 2.9,-2.2 6.9,1.1 -0.6,-6.2 -2.8,-6.8 0.3,-2.3 -1.3,-5.7 -6.9,1.9 -2.6,2.4 h -7.6 l -6,-5.8 -9,-4.5 -10,-2 -6.2,-6 -4.5,-3.8 -3.8,-2.7 -7.7,-6.2 -6,-2.2 -8.6,-1.9 -6.2,0.2 -5.1,1.1 -1.7,3.1 3.7,1.4 2.5,3.4 -1.3,2 0.2,6.5 1.9,2.8 -4.4,3.9 -7.4,-2.4 -5.6,0.6 -3.9,-2.1 -3.4,-0.7 -4.4,4.4 -5.9,1 -3.6,1.6 -6.8,-1 h -4.6 l -4.9,-3.2 -6.6,-2.9 -5.4,-0.9 -5.7,0.8 -4,1.2 -8.5,-2.6 -3.6,-4.6 -6.7,-1.6 -4.8,-0.8 -7,-2.5 -1.3,6.4 4,3.6 -2.4,4.4 -8,-1.6 -5,-0.2 -4.8,-2.9 -5.2,-0.1 -5.3,-1.9 -5.9,2.9 -6.7,5.3 -4.7,1.1 -1.7,0.5 -4.4,-3.8 -6,0.9 -3.3,-2.7 -4,-1.2 -4.1,-3.6 -3.3,-1.1 -6.2,1.6 -8.4,-3.5 -1.1,3.2 -18.3,-15.6 -8.4,-4.7 0.8,-2 -9.2,5.8 -4.4,0.3 -1.1,-3.3 -7.1,-2.1 -4.3,1.5 -4.4,-6.3 -9.1,-1.3 -3.1,2.5 -10.9,2.3 -1.7,1.5 -17,2.1 -1.4,2.1 5.1,4.2 -4,1.6 1.5,1.6 -3.5,3 9.4,4.3 -0.2,2.9 -7,-0.3 -0.8,1.9 -7.3,-3.2 -7.7,0.1 -4.4,2.6 -6.6,-2.5 -12,-4.3 -7.6,0.2 -8.1,6.7 0.6,4.5 -6,-3.6 -2.2,6.9 1.8,1.2 -1.7,4.8 5.3,4.2 3.6,-0.2 4.3,4.2 0.2,3.2 2.8,1.1 -1.4,3.7 -4.6,1 -3.6,6.5 6,6.1 0.4,4.2 7.3,7.5 -2.5,2.6 -0.6,1.6 -2.4,-0.5 -4.3,-3.8 -1.5,-0.2 -3.6,-1.5 -2.1,-2.6 -5.1,-1.3 -2.9,1 -1.2,-1.2 -7.6,-3.1 -7.7,-1 -4.6,-1.1 -0.4,0.8 -7.6,-5.4 -6.2,-2.4 -5.1,-3.7 3.6,-1 3.2,-5.2 -3.3,-2.5 6.9,-2.6 -0.4,-1.4 -4.3,1 -0.4,-2.7 2.2,-1.8 4.8,-0.4 0.3,-2.1 -1.8,-3.5 1.3,-3.2 -0.4,-1.9 -7.7,-2 -2.9,0.1 -3.6,-2.9 -3.6,1 -6.7,-2.2 -0.1,-1.2 -2.3,-2.7 -3.9,-0.3 -0.8,-1.9 0.9,-1.3 -3.8,-3.5 -4.9,0.6 -1.5,-0.3 -1,1.4 -1.8,-0.2 -2,-4 -1.5,-2 0.8,-0.6 3.9,0.2 1.6,-1.3 -1.7,-1.6 -3.4,-1.1 v -1.1 l -2.1,-1.1 -3.8,-4 0.7,-1.6 -1.1,-2.9 -4.8,-1.4 -2.4,0.7 -0.9,-1.5 -5.3,-1.5 -2.1,-3.6 -1,-2.9 -2.5,-1.3 1.6,-1.9 -2.4,-5.6 2.6,-3.4 -0.9,-1 4.5,-3.3 -5.4,-2.8 8,-7.4 3.4,-3.4 0.9,-2.9 -7.4,-3.9 0.9,-3.8 -4.9,-4.2 1.7,-4.8 -6.5,-6.3 2.9,-4.2 -7.3,-3.7 -0.4,-3.8 3.2,-0.5 6.4,-2.1 3.7,-1.9 7.7,3.2 11.7,1.3 17.7,6.2 4.1,2.6 1.5,3.7 -3.7,2.9 -6.5,1.5 -20.2,-4.2 -2.9,0.7 8.1,4.1 1,2.6 1.9,5.8 6.1,1.7 3.8,1.5 -0.2,-2.8 -3.4,-2.4 2.1,-2.2 11.6,3.6 3.2,-1.4 -4.3,-4.2 8.1,-5.4 4.1,0.3 4.6,1.9 1.1,-3.8 -4.7,-3.3 0.8,-3.3 -4.3,-3.4 12.3,1.8 3.6,3 -5.1,0.7 1.2,3.1 4.1,1.9 6,-1.2 -0.4,-3.5 7.7,-2.7 12.4,-4.6 3.2,0.2 -2.5,3.3 5.4,0.6 2.1,-1.9 7.7,-0.1 5,-2.3 6.4,3.3 2.8,-3.6 -6,-3.1 1.2,-1.8 13,1.6 6.6,1.7 18.6,6.2 1.1,-2.8 -5.9,-2.9 -0.8,-1.1 -5.3,-0.6 -0.2,-2.5 -4.7,-4.2 -1.1,-1.7 4.3,-4.7 -0.6,-4.8 2.2,-1 11.4,1.4 2.9,2.9 -0.9,4.2 3.7,1.7 3.8,3.7 3.8,7.4 6.7,3.3 0.5,3.7 -3.5,7.8 5.3,0.8 0.5,-2 3.8,-1.4 -0.5,-2.7 1.9,-2.7 -4.4,-3.1 -0.4,-3.6 -4.8,-0.4 -2.9,-3 -0.4,-5.4 -8.2,-4.3 4.7,-3.5 -3.7,-3.7 1.9,-0.1 4.2,2.8 2.1,5.1 5,1 -4.6,-3.8 5.1,-2.1 8.1,-0.3 9.6,3 -6.9,-4.3 -4.9,-5.5 5.9,-1 9.5,0.2 7.8,-0.7 -5.6,-2.6 1.3,-3.3 4.2,-0.2 4.9,-2.4 9.3,-0.7 -0.2,-1.4 9.3,-0.4 4.3,1.1 5.4,-2.6 7,0.1 -1.5,-2.2 0.9,-2 6.2,-2 8.3,1.6 -3.5,1.2 9.4,0.7 4.1,2.4 1.9,-1.2 10.9,0.1 11.6,2.4 5.5,1.8 2.5,2.6 -2.4,1.5 -6.6,2.8 -1.1,1.5 5.6,0.7 7.2,1.3 2.4,-1 5.8,3.3 0.2,-1.3 5.2,-0.8 13.6,0.8 3.8,2.4 17.4,0.8 -4.8,-3.9 9.5,0.9 6.1,-0.1 9.9,2.7 6,3.3 0.4,2.2 10.1,4.2 9,2.1 -3,-5.5 9.4,2.3 5,-1.4 9.8,1.6 1,-1.4 7.6,0.7 -9.4,-4.9 2.1,-2.2 40.4,3.4 7.9,3.1 16.3,4 14.8,-1 9.3,0.9 6.6,2.2 5.1,3.9 7.3,1.5 3.9,-1.1 7,-0.1 9.3,1 6.9,-0.6 14.3,4.8 2.5,-1.7 -8.5,-3.4 -1.8,-2.4 15.3,1.5 8,-0.3 15.8,2.5 9.5,2.4 33.2,22.1 -2,2.5 -6.2,-0.4 8.2,3 9.1,4.7 4.2,1.5 3.8,2.4 1,1.5 -10,-1.2 -6.6,4.3 -3,0.7 -1.6,4.1 -2,3.6 1.7,2.7 -11.5,-4.1 -6.1,4.6 -4.7,-2.2 -1.4,2.6 -7,-0.9 3.1,3.9 1.1,5.8 2.9,2.4 6.8,1.3 9.1,8.7 -4.1,0.3 3.4,5 4.7,2.6 -5,3.1 5.4,7 -5.7,1.5 4.5,6.2 -1.7,5.8 -5.7,-4.3 -10.5,-8.9 -16.2,-13.6 -6.5,-8.3 0.1,-3.6 -2.8,-2.8 5.7,-1.3 -0.2,-7.5 0.7,-6 2.5,-4.7 -6.6,-8.2 -4.7,0.5 3.2,4.8 -3.6,6.4 -12.3,-7.2 -9.1,2 v 9.8 l 7.7,3.6 -8.5,1.6 -6.4,0.6 -4.3,-4.3 -8,-0.9 -2.5,2.9 -15.1,-1 -13.2,1.7 -3.5,11.7 -5,14.2 8.2,0.8 5.7,3.8 5.8,1.3 0.4,-3 5.6,0.4 12.8,6.7 4.7,5.2 1.4,6.2 5.5,7.4 5.3,9.9 -1,9.1 1.3,4.3 -2,7.4 -2.1,7.3 -0.9,3.7 -4.6,3.7 -3.1,0.1 -5.2,-3.1 -4.1,4.7 z"
              id="path97"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Russia"
              d="m 1307.1,23.1 -18.1,1.8 -1.3,-6.1 2.2,-0.5 3.1,0.3 12.6,2.6 z"
              id="path98"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Russia"
              d="m 1104.8,13.1 -4.3,0.5 -2.9,0.4 v 0.7 l -3.6,0.7 -4.5,-1 1.1,-1.4 -7.8,-0.1 6.3,-0.8 h 5.2 l 1.5,1.1 1.3,-1 2.8,-0.7 5.8,0.9 z"
              id="path99"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Russia"
              d="m 1285.1,20.4 -7.1,0.6 -11.7,-1.3 -8.1,-1.7 -6.6,-3.2 -5.9,-0.8 5.4,-2.9 6.2,-0.9 9.6,2 13.7,4.2 z"
              id="path100"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 916.6,223.4 2,2.4 9.5,2.9 1.9,-1.4 5.8,2.9 5.9,-0.8 0.4,3.7 -4.9,4.2 -6.6,1.4 -0.5,2.1 -3.2,3.5 -2,5.2 2,3.7 -3,2.8 -1.2,4.2 -4,1.3 -3.7,4.9 -6.8,0.1 -5,-0.1 -3.4,2.2 -2.1,2.4 -2.6,-0.5 -1.9,-2.2 -1.4,-3.6 -4.9,-1 -0.4,-2.2 2,-2.4 0.8,-1.7 -1.8,-1.9 1.6,-4.2 -2,-3.8 2.3,-0.5 0.3,-3.1 0.8,-0.9 0.3,-5 2.4,-1.7 -1.3,-3.2 -3.1,-0.2 -0.9,0.8 h -3 l -1.2,-3.1 -2.2,0.9 -1.9,1.6 0.5,-4.5 -2,-2.7 7.4,-4.6 6.2,1.1 h 6.9 l 5.4,1.1 4.3,-0.4 z"
              id="ES"
              data-name="Spain"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="France"
              d="m 975.7,231.4 -1.5,4.9 -2.4,-1.3 -1.3,-4.2 0.9,-2.4 3.2,-2.4 z"
              id="path101"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="France"
              d="m 954.4,185 1.1,0.5 1.4,-0.1 2.4,1.6 7.2,1.2 -2.4,4.2 -0.4,4.5 -1.3,1.1 -2.3,-0.6 0.2,1.6 -3.6,3.5 v 2.9 l 2.4,-1 1.8,2.7 -0.1,1.8 1.5,2.4 -1.7,1.9 1.5,4.9 2.8,0.8 -0.5,2.7 -4.5,3.6 -10.2,-1.7 -7.4,2.1 -0.6,3.8 -5.9,0.8 -5.8,-2.9 -1.9,1.4 -9.5,-2.9 -2,-2.4 2.7,-3.8 1,-12.6 -5.1,-6.6 -3.7,-3.2 -7.6,-2.4 -0.4,-4.6 6.5,-1.3 8.3,1.6 -1.5,-7.1 4.7,2.7 11.4,-4.8 1.5,-5.1 4.2,-1.3 0.8,2.2 2.2,0.1 2.4,2.5 3.5,2.9 2.5,-0.5 z"
              id="path102"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="United States"
              d="m 58.8,379.3 -1.1,1.1 -1.2,-0.9 0.6,-1.8 -0.4,-2.4 0.5,-0.7 1.2,-1 -0.1,-1.3 0.4,-0.6 0.4,0.1 1.9,1.1 0.9,0.6 0.7,0.8 0.9,2.3 -0.2,0.3 -2.5,1.4 z"
              id="path103"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="United States"
              d="m 58.1,369.3 -2,0.4 -0.6,-1.3 -0.5,-0.5 v -0.4 l 0.7,-0.6 1.8,0.6 1.2,1 z"
              id="path104"
            />
            <path onMouseOver={ev => doHover(ev)} data-name="United States" d="m 55.1,365.9 -0.3,0.7 -3,-0.2 0.6,-0.8 z" id="path105" />
            <path onMouseOut={ev => doOut(ev)} data-name="United States" d="m 55.1,365.9 -0.3,0.7 -3,-0.2 0.6,-0.8 z" id="path105" />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="United States"
              d="m 50.4,364.9 -0.4,0.4 -0.4,-0.1 -1.9,-0.2 -0.3,-1.5 -0.2,-0.2 1.7,-0.9 0.4,0.4 z"
              id="path106"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="United States"
              d="m 42,360.7 -0.8,0.6 -1.6,-1.1 0.4,-0.5 1,-0.6 1.3,0.1 z"
              id="path107"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="United States"
              d="m 479.5,194.5 -6.1,2 -4.7,2.5 -4.6,2.7 -0.5,0.9 5.7,-1.3 2.1,2.1 4.6,-1.5 4.9,-2.1 5.4,-2.1 -3.1,3.3 2.5,0.8 2.5,2.4 5.1,-1.4 5.1,-0.5 0.3,1.8 1.5,0.2 1.2,0.2 1.5,2.5 -4.7,0.6 h -0.1 l -3.7,-0.7 -4.5,1.2 -3.7,0.6 -4.7,4.1 -3,2.3 0.4,0.7 5.5,-4.1 h 0.7 l -4.7,4.9 -2.9,4.4 -2.5,3.6 -0.6,3.1 -0.8,1.5 -0.6,1.7 0.1,3.3 0.3,0.5 1.8,-0.1 1.6,-0.7 1.4,-0.8 3.3,-3.1 1.8,-4.2 -0.1,-3.9 1.4,-2.7 2.6,-3.1 2.1,-2.2 2.7,-1.5 -0.4,2.1 2.2,-3.1 1.3,-0.6 1.7,-2.4 3.8,1.3 2.8,2.4 -0.8,2.9 -1.6,2.9 -3.8,2.5 -0.4,1.6 h 1 l 4.3,-2.7 1.6,0.6 -0.5,3.7 -0.7,2.6 -3.7,3.5 -2,2.2 -2.7,2.4 2.7,1.3 2.5,0.4 4,-0.9 3.7,-1.7 3,-0.9 4.6,-1.8 5.8,-3.8 0.1,-0.6 0.3,-1.9 2.7,-0.8 3.9,0.3 4,0.5 4.6,-2.1 0.6,-2.5 -0.2,-0.9 6.8,-4.4 2.7,-1.1 7.8,-0.1 h 9.3 l 1.1,-1.5 1.7,-0.3 2.5,-1 2.8,-2.9 3.2,-4.9 5.5,-4.7 1.1,1.6 3.7,-1 1.6,1.8 -2.9,8.5 2.2,3.6 0.2,2.1 -6.4,3 -6,2.2 -6,1.9 -4,3.8 -1.3,1.4 -1.2,3.4 0.7,3.3 2.1,0.2 0.2,-2.3 1.1,1.4 -1,1.8 -3.8,1 -2.5,-0.1 -4.2,1.1 -2.3,0.3 -3.1,0.3 -5,1.9 8.1,-1.2 1.1,1.2 -7.9,1.9 H 541 l 0.4,-0.8 -2.1,1.8 1.4,0.3 -2.5,4.6 -5.3,4.9 0.1,-1.7 -1.1,-0.3 -1.2,-1.6 v 3.5 l 1,1.1 -0.6,2.4 -2.4,2.5 -4.5,5.1 -0.4,-0.2 2.9,-4.4 -2,-2.4 1,-5.4 -1.9,2.8 v 4.1 l -3.2,-1 3,2 -1.5,6.1 1.4,0.5 v 2.2 l -1,6.4 -4.6,4.7 -6.1,1.9 -4.4,3.8 -2.8,0.4 -3.4,2.4 -1.3,2.1 -6.9,4.2 -3.8,3.1 -3.5,3.8 -1.9,4.5 v 4.5 l 0.6,5.5 1.5,4.5 -0.5,2.8 1.3,7.4 -1,4.4 -0.6,2.5 -2,3.9 -1.8,0.8 -2.6,-0.8 -0.4,-2.8 -1.8,-1.5 -2,-5.5 -1.6,-4.9 -0.4,-2.5 2,-4.3 -0.8,-3.5 -3.1,-5.4 -1.9,-1 -6.1,3 -0.9,-0.4 -2,-3 -3,-1.6 -6.4,0.9 -4.6,-0.8 -4.3,0.5 -2.5,1 0.6,1.7 -0.7,2.6 0.8,1.3 -1.2,0.8 -1.8,-0.9 -2.3,1.2 -3.9,-0.2 -3.3,-3.4 -4.9,0.8 -3.6,-1.5 -3.5,0.5 -5,1.5 -6.1,4.7 -6.1,2.8 -3.7,3 -1.9,2.9 -1,4.5 -0.4,3 0.6,2.2 -2.2,0.2 -3.6,-1.4 -3.9,-2 -0.9,-3 -0.2,-4.5 -2.4,-3.6 -0.9,-3.8 -1.6,-4.4 -3.2,-2.6 -4.5,0.2 -4.8,5 -4,-1.9 -2.3,-1.9 -0.4,-3.6 -0.8,-3.3 -2.4,-2.8 -2.1,-2.1 -1.3,-2.3 h -9.4 l -0.8,2.7 h -4.3 -10.8 l -10.9,-4.5 -7,-3.1 0.9,-1.3 -7.1,0.7 -6.3,0.5 0.3,-3.2 -2.1,-3.7 -2.2,-0.8 0.1,-1.8 -2.9,-0.4 -1.2,-1.7 -4.8,-0.6 -0.9,-1.1 0.8,-3.5 -2.5,-6.4 -0.5,-8.9 0.9,-1.5 -1.3,-2.1 -1.5,-5.4 1.8,-5.2 -0.9,-3.5 3.9,-5.3 2.8,-5.4 1.1,-4.9 5.5,-6 4,-5.7 4,-5.7 4.3,-8.5 1.8,-5.3 0.4,-2.9 1.4,-1.3 5.8,2.2 -1,5.9 2.2,-1.7 2.5,-5.1 1.6,-5.1 h 14.1 14.7 4.8 15.1 14.7 14.8 14.9 16.8 17 10.2 l 1.3,-2.4 h 1.7 l -0.9,3.4 1,1 3.3,0.4 4.6,1 3.9,1.9 4.4,-0.8 z"
              id="path108"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="United States"
              d="m 215,138.6 -7,2.3 -0.8,-1.6 2.3,-2.8 6.4,-2.1 3.5,-0.9 2.6,0.4 v 1.9 z"
              id="path109"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="United States"
              d="m 176,122 -3.9,0.9 -1.7,-1.1 -0.8,-1.6 5.7,-1 3,0.6 z"
              id="path110"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="United States"
              d="m 177.2,99.6 1.2,1 3.5,-0.5 1.6,1.5 3.3,0.7 -1.2,0.7 -4.9,1.2 -1.7,-1.3 -0.3,-1 -4.3,0.3 -0.3,-0.5 z"
              id="path111"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="United States"
              d="m 350,66.6 -24.6,20.4 -35.6,32.7 4.2,0.2 2.8,1.6 0.5,2.6 0.3,3.8 7.6,-3.3 6.5,-1.9 -0.6,3.1 0.8,2.4 1.6,2.7 -1.1,4.2 -1.4,6.9 4.6,3.8 -3.2,3.8 -5.1,2.9 -0.6,-2.2 -2.5,-2 3.3,-5.2 -1.6,-4.9 2.7,-5.6 -4.1,-0.4 -7.1,-0.1 -3.8,-1.8 -3.3,-6.1 -3.3,-1.1 -5.7,-2.1 -6.8,0.5 -6,-2.7 -2.7,-2.5 -6.3,1.2 -3.5,4.1 -2.9,0.4 -6.6,1.2 -6.2,2 -6.4,1.3 3.2,-3.5 8.4,-5.8 6.8,-1.8 0.4,-1.4 -9.4,3.2 -7.4,3.9 -11.2,4.2 0.2,2.9 -9,4.2 -7.7,2.5 -6.6,1.9 -4,2.6 -10.6,3.1 -4.5,2.8 -8.2,2.6 -2.7,-0.4 -6.2,1.6 -7,2.1 -6.1,2 -10,1.8 0.4,-1.1 8.2,-2.8 6.6,-1.9 8.6,-3.3 6.5,-0.6 5,-2.5 10.4,-3.6 2.3,-1.2 5.7,-2.1 5.8,-4.5 6.2,-3.5 -7.3,1.8 -0.3,-1.1 -4.9,2.2 0.4,-3 -3.6,2.1 1.6,-2.9 -7.3,2.3 h -2.8 l 3.7,-3.5 3.3,-2.2 -0.4,-2.1 -7.2,1.2 -0.6,-2.8 -1.3,-1.4 4,-3.3 -0.4,-2.5 5.9,-3.3 7.7,-3.3 5.3,-2.9 4.1,-0.4 1.8,0.9 7.1,-2.8 2.5,0.5 5.6,-1.8 2.5,-2.6 -1.1,-1 6,-2.2 -2.8,0.1 -6.2,1.2 -2.9,1.3 -1.8,-1.3 -6.9,0.7 -4.6,-1.4 1.2,-2.3 -1,-3.2 9.2,-2.4 13.2,-2.7 h 3.5 l -4.3,2.8 9.2,-0.2 1.2,-3.5 -2.3,-2.1 0.8,-2.8 -0.7,-2.3 -3.3,-1.7 6.5,-2.9 7.5,-0.2 8.8,-2.4 4.8,-2.6 7.9,-2.6 4.8,-0.6 11.2,-2.4 3.1,0.4 10.4,-2.8 4.4,1.1 -0.5,2.4 3.3,-1 6.3,0.3 -1.9,1.2 4.9,0.9 4.9,-0.5 6.2,1.6 7.2,0.6 2.2,0.6 6.6,-0.8 4.1,1.6 z"
              id="path112"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 617.3,487 1.5,-2.8 0.5,-2.9 1,-2.7 -2.1,-3.8 -0.3,-4.4 3.1,-5.5 1.9,0.7 4.1,1.5 5.9,5.4 0.8,2.6 -3.4,5.9 -1.8,4.7 -2.2,2.5 -2.7,0.4 -0.8,-1.8 -1.3,-0.2 -1.7,1.7 z"
              id="GF"
              data-name="French Guiana"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 532.9,422 -0.5,-0.2 -0.5,-0.5 0.1,-0.6 0.2,0.3 0.4,0.4 0.3,0.5 z"
              id="AW"
              data-name="Aruba"
            />
            <path onMouseOver={ev => doHover(ev)} d="M 574.2,384.9 H 574 l 0.3,-0.4 h 0.3 l -0.2,0.3 z" id="AI" data-name="Anguilla" />
            <path onMouseOut={ev => doOut(ev)} d="M 574.2,384.9 H 574 l 0.3,-0.4 h 0.3 l -0.2,0.3 z" id="AI" data-name="Anguilla" />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="American Samoa"
              d="m -32.3,593.3 -0.3,0.4 -0.2,0.3 -0.2,0.1 -0.4,-0.3 0.2,-0.2 h 0.3 l 0.1,-0.2 z"
              id="path113"
            />
            <path onMouseOver={ev => doHover(ev)} data-name="American Samoa" d="m -25.7,593.3 -0.5,0.1 -0.1,-0.2 0.4,-0.1 z" id="path114" />
            <path onMouseOut={ev => doOut(ev)} data-name="American Samoa" d="m -25.7,593.3 -0.5,0.1 -0.1,-0.2 0.4,-0.1 z" id="path114" />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Antigua and Barbuda"
              d="m 580.7,391.9 0.6,0.3 -0.2,0.3 h -0.2 l -0.7,0.1 -0.2,-0.1 V 392 l 0.3,-0.1 0.1,-0.3 h 0.2 z"
              id="path115"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Antigua and Barbuda"
              d="m 580.7,388.2 h 0.2 l 0.2,0.2 0.1,0.4 -0.1,0.3 -0.2,0.1 -0.1,-0.2 -0.3,-0.2 v -0.5 z"
              id="path116"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1204.1,333.3 0.3,0.1 0.2,-0.1 0.4,0.7 -0.1,0.2 0.1,0.9 v 0.7 l -0.2,0.4 -0.1,-0.4 -0.6,-0.8 0.1,-0.4 -0.2,-0.7 v -0.4 z"
              id="BH"
              data-name="Bahrain"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Bahamas"
              d="m 520.4,366 -0.4,0.5 -0.2,0.5 -0.6,0.3 h -0.5 l -0.1,-0.1 -0.4,0.2 -0.5,0.1 -0.6,-0.2 -0.4,0.1 -0.1,-0.5 0.3,-0.2 0.2,-0.3 0.4,-0.2 0.3,-0.4 h 0.4 l 0.3,-0.2 0.2,0.3 0.5,0.2 0.5,-0.2 0.7,-1 h 0.3 v 0.2 z"
              id="path117"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Bahamas"
              d="m 520.6,364.3 -0.2,-0.6 0.6,-0.3 0.3,0.3 v 0.2 L 521,364 Z"
              id="path118"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Bahamas"
              d="m 521,357.8 0.2,-0.1 0.5,0.3 h 0.4 l 0.4,0.1 0.3,0.2 v 0.3 l -0.2,0.1 -0.5,-0.4 h -0.4 l -0.1,-0.1 -0.5,0.2 -0.5,-0.2 v -0.1 l 0.2,-0.5 z"
              id="path119"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Bahamas"
              d="m 517.1,356 -0.2,0.4 v 0.7 l -0.1,0.4 -0.4,0.3 -0.2,0.4 -0.4,0.3 -0.7,0.3 -0.1,0.2 -0.2,-0.2 0.1,-0.2 0.4,-0.1 0.2,-0.2 v -0.2 l 0.4,-0.1 0.2,-0.4 0.4,-0.1 0.3,-0.4 -0.2,-0.3 h -0.4 l -0.2,-0.2 0.4,-0.5 0.1,-0.1 z"
              id="path120"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Bahamas"
              d="m 515.2,355.7 0.1,0.1 h 0.4 l 0.4,0.2 -0.4,0.4 -0.1,-0.2 h -0.2 l -0.4,-0.1 -0.4,-0.2 -0.3,-0.6 0.3,-0.1 0.4,0.1 z"
              id="path121"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Bahamas"
              d="m 506,349.8 0.6,0.7 0.3,0.2 0.3,0.5 -0.3,-0.1 -0.1,-0.2 -0.3,-0.1 -0.4,-0.4 -0.2,-0.1 -0.2,-0.4 z"
              id="path122"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Bahamas"
              d="m 509.7,349.8 0.3,0.6 0.2,0.5 v 0.4 l 0.2,0.2 0.2,0.7 v 0.9 l 0.2,0.3 0.5,0.2 0.4,0.6 v 0.8 l -0.4,-0.7 v -0.2 l -0.3,-0.4 -0.6,-0.2 0.2,-0.2 -0.3,-0.3 v -0.3 l 0.2,-0.3 -0.1,-0.5 -0.3,-0.4 0.1,-0.1 -0.3,-0.4 -0.1,-0.6 -0.2,0.1 z"
              id="path123"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Bahamas"
              d="m 512.6,349.8 -0.3,0.2 -0.3,-0.1 -0.1,-0.2 0.6,-0.2 z"
              id="path124"
            />
            <path onMouseOver={ev => doHover(ev)} data-name="Bahamas" d="m 504.4,347.9 -0.1,-0.1 -0.3,-0.7 h 0.2 z" id="path125" />
            <path onMouseOut={ev => doOut(ev)} data-name="Bahamas" d="m 504.4,347.9 -0.1,-0.1 -0.3,-0.7 h 0.2 z" id="path125" />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Bahamas"
              d="m 514.9,347.4 -0.4,0.6 h -0.4 l 0.2,-0.3 0.1,-0.6 0.4,-0.3 0.1,0.4 z"
              id="path126"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Bahamas"
              d="m 496.4,346.2 -0.3,0.1 -0.2,0.3 -0.3,-0.1 0.6,-0.4 z"
              id="path127"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Bahamas"
              d="m 496.6,346.9 0.4,0.2 0.2,-0.2 0.1,-0.5 0.2,-0.1 0.2,0.6 v 0.5 l -0.1,0.3 0.1,0.6 v 0.3 l -0.4,0.8 -0.2,0.1 -0.4,-0.2 0.2,-0.3 0.4,-0.2 -0.1,-0.1 -0.6,0.4 -0.2,-0.2 0.4,-0.3 h -0.4 l -0.2,0.1 -0.2,-0.2 v -0.7 l 0.1,-0.2 -0.4,-0.5 v -0.2 l 0.4,-0.2 0.1,-0.3 0.3,-0.1 0.1,-0.2 0.6,-0.3 0.1,0.4 -0.5,0.4 z"
              id="path128"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Bahamas"
              d="m 510.1,346.3 0.1,0.5 -0.2,-0.1 -0.5,0.1 -0.4,0.1 -0.1,-0.2 0.3,-0.2 0.4,-0.3 V 346 l -0.4,-0.2 -0.2,-0.6 -0.1,-0.6 -0.4,-0.4 V 344 l -0.5,-0.5 0.3,-0.3 0.4,0.4 v 0.5 l 0.2,0.3 0.1,0.5 0.3,0.5 0.4,0.3 0.1,0.3 z"
              id="path129"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Bahamas"
              d="m 499.8,340.8 0.3,0.2 -0.6,0.3 -0.3,-0.1 -0.2,0.2 -0.5,-0.1 0.2,-0.3 0.4,-0.2 z"
              id="path130"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Bahamas"
              d="m 495.6,340.3 0.4,-0.2 0.3,0.3 -0.1,0.2 0.1,0.2 -0.2,0.4 0.3,0.3 0.2,0.9 0.2,0.3 0.4,0.5 -0.2,0.7 0.1,0.6 -0.2,0.3 -0.3,0.1 -0.4,0.4 -0.3,0.2 h -0.3 l -0.3,0.2 H 495 v -0.4 l -0.3,-0.2 0.1,-0.6 -0.3,0.3 -0.2,-0.1 -0.6,-0.4 -0.3,-0.3 -0.2,-0.3 0.7,-0.3 0.5,0.7 0.1,-0.6 -0.3,-0.1 -0.1,-0.3 0.1,-0.3 0.6,-0.6 0.2,-0.4 -0.1,-0.1 0.3,-0.4 v -0.5 l -0.2,-0.7 0.1,-0.1 h 0.3 z"
              id="path131"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Bahamas"
              d="m 503.7,337.7 0.1,0.2 0.3,0.4 0.8,0.7 0.5,0.1 0.1,0.1 0.2,0.4 0.3,0.4 0.5,0.4 v 0.2 l -0.2,0.8 -0.1,0.2 v 0.3 l -0.1,0.5 -0.2,0.3 -0.1,0.7 -0.1,0.1 -0.2,-0.6 -0.4,-0.3 0.1,-0.2 0.5,0.1 0.2,-0.2 -0.1,-0.2 0.1,-0.4 0.3,-0.4 0.1,-0.5 v -0.3 l -0.5,-0.4 -0.4,-0.7 -0.3,-0.2 -0.6,-0.3 -0.3,-0.3 -0.6,-0.2 -0.4,0.2 0.4,-0.9 z"
              id="path132"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Bahamas"
              d="m 494.9,330.2 0.5,0.2 h 0.1 l 0.7,0.1 0.2,-0.2 0.2,0.1 h 0.5 l 0.4,-0.2 h 0.4 l 0.3,-0.2 0.1,0.5 -0.1,0.2 h -0.3 -0.4 l -1.1,0.2 h -0.3 l -1.5,0.4 -0.7,0.4 h -0.4 l -0.2,-0.1 -0.3,-0.3 -0.5,-0.6 0.6,0.3 0.1,0.2 h 0.5 l 0.5,-0.2 0.4,-0.6 -0.3,-0.1 0.2,-0.3 0.1,-0.3 z"
              id="path133"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Bahamas"
              d="m 499.2,328.9 0.8,0.2 0.2,-0.1 0.4,0.3 0.9,1 0.2,0.6 0.4,0.1 0.7,0.5 v 0.2 l -0.2,0.5 0.2,0.7 h -0.4 l -0.5,0.4 -0.1,0.2 -0.3,1 -0.1,0.9 -0.2,0.2 -0.3,-0.2 -0.1,-0.4 -0.4,-0.1 0.3,-0.5 h 0.2 l 0.5,-0.4 -0.1,-0.4 0.2,-0.4 v -0.3 l 0.2,-0.3 V 332 l 0.2,-0.1 0.2,-0.3 0.1,-0.3 -0.3,-0.1 -0.5,-0.1 -0.1,-0.3 v -0.2 l -0.4,-0.2 v -0.3 l -0.3,-0.7 -0.2,-0.1 -0.3,0.1 -0.5,-0.1 h -0.3 l -0.6,-0.4 z"
              id="path134"
            />
            <path onMouseOver={ev => doHover(ev)} d="m 575.2,387 -0.1,-0.3 0.3,0.1 z" id="BL" data-name="Saint-Barthélemy" />
            <path onMouseOut={ev => doOut(ev)} d="m 575.2,387 -0.1,-0.3 0.3,0.1 z" id="BL" data-name="Saint-Barthélemy" />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="M 577.3,294 H 577 l -0.1,0.1 0.1,0.2 -0.4,0.2 -0.1,-0.1 0.2,-0.1 h 0.1 l 0.1,-0.3 0.3,-0.1 z"
              id="BM"
              data-name="Bermuda"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 591.5,418 -0.6,-0.2 -0.1,-0.5 v -0.8 l 0.2,-0.4 0.2,0.2 0.2,0.6 0.5,0.3 0.1,0.4 z"
              id="BB"
              data-name="Barbados"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Comoros"
              d="m 1173.2,581.3 -0.9,-0.1 -0.2,-0.4 v -0.3 l 0.5,0.1 0.7,0.5 z"
              id="path135"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Comoros"
              d="m 1176.9,579.4 0.2,1 v 0.7 l -0.1,0.2 -0.2,-0.3 -0.4,-0.3 -0.1,-0.2 -0.3,-0.1 -0.6,-0.4 0.1,-0.1 0.5,0.2 0.3,-0.1 0.2,-0.4 v -0.2 l 0.3,-0.1 z"
              id="path136"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Comoros"
              d="m 1171.2,578.4 -0.5,-0.4 -0.3,-0.1 -0.3,-0.2 -0.2,-0.6 0.1,-0.3 v -0.2 l 0.2,-1.2 -0.1,-0.1 0.2,-0.4 0.5,-0.1 0.2,0.3 -0.2,1.2 0.1,0.3 0.2,0.4 0.1,0.5 0.2,0.6 z"
              id="path137"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Cape Verde"
              d="m 787.8,406.5 -0.2,0.3 -0.2,-0.2 v -0.3 l 0.3,-0.1 z"
              id="path138"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Cape Verde"
              d="m 789.7,406.6 -0.2,0.1 -0.4,-0.1 -0.3,-0.3 -0.1,-0.3 0.2,-0.4 0.5,-0.3 h 0.4 l 0.2,0.7 -0.1,0.4 z"
              id="path139"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Cape Verde"
              d="m 793.2,403.5 0.2,0.1 v 0.2 l 0.2,0.2 0.4,0.5 h 0.2 l 0.2,0.3 0.2,0.5 0.2,0.2 -0.3,0.5 -0.3,0.1 -0.5,-0.1 -0.3,-0.1 -0.3,-0.3 v -0.2 l -0.2,-0.1 -0.1,-0.4 0.1,-0.2 v -0.3 l 0.2,-0.4 -0.2,-0.5 z"
              id="path140"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Cape Verde"
              d="m 796.3,403.5 0.3,0.1 0.1,0.6 -0.1,0.4 -0.4,0.2 -0.4,-0.4 0.2,-0.4 -0.1,-0.2 z"
              id="path141"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Cape Verde"
              d="m 798.3,397.8 0.3,-0.2 0.5,0.2 0.1,0.2 v 0.7 l -0.4,0.3 -0.3,0.2 h -0.3 l -0.5,-0.2 v -0.5 l 0.2,-0.2 v -0.6 l 0.1,-0.1 z"
              id="path142"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Cape Verde"
              d="m 790.3,395 0.4,-0.1 0.3,0.2 h 0.4 l 0.3,0.2 0.1,0.2 h -0.5 l -0.7,-0.3 -0.2,0.1 -0.3,0.6 -0.3,-0.6 -0.1,-0.1 -0.1,-0.4 0.3,-0.1 z"
              id="path143"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Cape Verde"
              d="m 798.1,394.5 0.1,0.1 -0.1,0.6 -0.2,0.1 v -0.5 l -0.2,-0.3 v -0.3 l -0.1,-0.3 0.4,-0.3 0.2,0.2 -0.1,0.6 z"
              id="path144"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Cape Verde"
              d="m 786.8,393.2 0.2,0.3 0.1,0.3 -0.7,0.3 -0.3,-0.2 -0.2,-0.2 0.4,-0.4 z"
              id="path145"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Cape Verde"
              d="m 786,391.4 0.3,0.1 v 0.2 l 0.3,0.3 -0.2,0.4 -0.6,0.3 -0.4,0.4 -0.7,0.1 v -0.1 -0.5 l -0.2,-0.2 v -0.2 l 0.2,-0.2 h 0.2 l 0.2,-0.2 0.7,-0.4 z"
              id="path146"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 539,424.5 h -0.3 l -0.4,-0.3 -0.3,-0.1 -0.3,-0.3 -0.1,-0.2 -0.3,-0.1 -0.2,-0.4 -0.3,-0.3 0.1,-0.5 0.5,0.3 0.1,0.5 0.4,0.4 0.7,0.2 0.2,0.3 0.3,0.4 z"
              id="CW"
              data-name="Curaçao"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Cayman Islands"
              d="m 472.7,377.8 0.3,0.1 0.2,-0.4 0.4,0.1 h 0.5 l 0.1,0.2 -0.2,0.2 -0.2,-0.1 -0.4,0.1 -0.2,0.1 h -0.7 z"
              id="path147"
            />
            <path onMouseOver={ev => doHover(ev)} data-name="Cayman Islands" d="m 480.8,375.3 -0.7,0.3 0.2,-0.3 z" id="path148" />
            <path onMouseOut={ev => doOut(ev)} data-name="Cayman Islands" d="m 480.8,375.3 -0.7,0.3 0.2,-0.3 z" id="path148" />
            <path onMouseOver={ev => doHover(ev)} data-name="Cayman Islands" d="m 481.4,375.4 -0.1,-0.1 0.8,-0.3 -0.2,0.3 z" id="path149" />
            <path onMouseOut={ev => doOut(ev)} data-name="Cayman Islands" d="m 481.4,375.4 -0.1,-0.1 0.8,-0.3 -0.2,0.3 z" id="path149" />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Cyprus"
              d="m 1108.2,276.7 0.1,0.2 0.3,0.4 -0.4,-0.1 h -0.3 l -0.4,0.2 -0.3,-0.3 v -0.3 l 0.3,-0.1 0.2,0.1 z"
              id="path150"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Cyprus"
              d="m 1106.5,277.2 v 0.1 l -0.2,0.2 -0.1,0.6 -0.1,0.2 h -0.3 l -0.2,0.2 -0.5,0.2 -0.2,0.1 -0.6,0.3 -0.4,-0.1 -0.5,0.1 -0.3,0.4 -0.2,-0.3 -0.3,0.1 h -0.2 l -0.3,-0.3 -0.4,0.3 h -0.5 l -0.5,-0.2 -0.5,-0.1 -0.4,-0.3 -0.3,-0.6 -0.3,-0.3 -0.2,-0.7 -0.2,-0.3 0.1,-0.3 0.5,0.3 0.4,-0.1 0.2,-0.3 0.1,-0.3 0.3,-0.1 0.2,0.1 0.2,-0.2 h 0.2 l 0.1,0.4 0.5,0.2 0.1,0.2 h 0.6 l 0.6,-0.5 0.4,0.1 0.3,-0.2 0.3,0.1 0.4,0.2 0.2,-0.3 h 0.3 l 0.3,0.4 v 0.6 l 0.3,-0.2 0.3,0.2 0.1,-0.1 z"
              id="path151"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 582,401.7 0.5,0.1 0.2,0.5 v 0.6 l -0.1,0.8 -0.1,0.2 -0.2,0.1 -0.4,0.2 0.1,-0.4 -0.1,-0.2 -0.1,-0.7 -0.3,-0.5 v -0.3 l 0.1,-0.3 v -0.3 h 0.2 z"
              id="DM"
              data-name="Dominica"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Falkland Islands"
              d="m 637.4,836.2 0.4,-0.1 v 0.4 l -0.8,-0.3 0.3,-0.3 0.2,-0.1 z"
              id="path152"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Falkland Islands"
              d="m 636.7,834.8 0.2,0.2 0.4,0.1 0.1,0.4 -0.3,0.1 -0.1,-0.4 -0.2,-0.2 z"
              id="path153"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Falkland Islands"
              d="m 642.9,834 0.2,0.1 -0.1,0.4 -0.3,-0.1 -0.2,-0.3 0.3,-0.2 z"
              id="path154"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Falkland Islands"
              d="m 630.8,833.1 v 0.2 l 0.1,0.3 -0.4,0.1 -0.3,-0.1 -0.2,-0.2 -0.3,-0.1 -0.1,-0.4 h 0.2 l 0.1,-0.2 0.3,-0.1 0.2,0.1 -0.3,0.3 0.3,0.1 0.3,-0.3 z"
              id="path155"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Falkland Islands"
              d="m 633.7,831.8 -0.4,-0.2 -0.5,-0.3 -0.8,-0.3 0.1,-0.4 -0.7,-0.1 -0.3,-0.1 -0.3,-0.4 0.2,-0.1 0.8,0.3 0.8,0.4 0.5,0.1 0.4,0.1 0.3,-0.3 0.1,-0.3 0.2,0.1 0.4,-0.2 0.1,0.2 h 0.5 v 0.3 h 0.3 l 0.9,-0.2 0.1,0.2 h 0.3 l 0.4,-0.1 -0.3,-0.2 -0.1,-0.3 h 0.4 l 0.6,0.2 0.1,0.4 -0.4,0.5 0.1,0.3 -0.2,0.2 h -0.4 l -0.3,0.8 -0.3,0.3 -0.3,0.6 -0.1,0.3 -0.5,0.3 -0.1,-0.2 h -0.4 v 0.3 l -0.8,-0.1 -0.1,0.1 0.3,0.4 -0.1,0.1 -0.2,0.4 h -0.4 l -0.3,0.4 -0.3,0.1 h -0.2 l -0.2,-0.3 -0.4,-0.3 v -0.2 h -0.5 l 0.6,0.4 h -0.4 l -0.5,-0.3 -0.2,-0.1 -0.4,-0.2 -0.3,-0.2 V 834 l 0.7,0.2 0.6,-0.2 -0.5,-0.2 -0.1,-0.1 h 0.9 l 0.4,0.1 0.3,0.2 v -0.2 l 0.4,-0.1 0.1,-0.3 -0.4,-0.2 -0.2,-0.5 0.1,-0.2 h 0.6 l 0.2,0.1 0.4,-0.1 -0.1,-0.3 h -0.8 v 0.1 l -0.4,0.2 h -0.6 l -0.5,-0.3 v -0.3 l 0.7,0.2 0.6,-0.2 h 0.3 l 0.5,-0.1 0.4,0.2 v -0.1 z"
              id="path156"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Falkland Islands"
              d="m 635.3,829.9 h 0.3 l 0.3,0.3 -0.3,0.1 h -0.3 z"
              id="path157"
            />
            <path onMouseOver={ev => doHover(ev)} data-name="Falkland Islands" d="M 634.3,829.9 H 634 l -0.1,-0.3 0.4,0.1 z" id="path158" />
            <path onMouseOut={ev => doOut(ev)} data-name="Falkland Islands" d="M 634.3,829.9 H 634 l -0.1,-0.3 0.4,0.1 z" id="path158" />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Falkland Islands"
              d="m 632.9,829.7 0.6,-0.1 0.2,0.3 -0.3,0.4 -0.2,-0.1 -0.3,0.1 -0.3,-0.2 0.3,-0.2 0.3,0.2 0.1,-0.2 -0.5,-0.1 z"
              id="path159"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Falkland Islands"
              d="m 640.1,829.8 h 0.6 l 0.1,-0.1 0.5,-0.1 0.4,0.2 0.4,0.3 0.1,0.3 v 0.1 l -0.5,0.1 -0.2,-0.3 -0.2,-0.1 -0.1,0.3 0.2,0.1 0.1,0.3 0.3,-0.2 0.2,0.1 0.1,0.4 0.3,0.1 0.1,-0.1 0.5,0.3 0.1,-0.4 -0.8,-0.2 0.1,-0.5 0.3,-0.2 1.5,-0.1 0.7,0.6 0.2,0.1 v 0.4 l -0.6,-0.1 -0.5,-0.2 -0.6,0.2 0.3,0.2 0.4,0.1 0.9,0.1 0.3,0.1 0.1,0.2 -0.2,0.5 h -0.5 l -0.1,0.1 -0.7,0.1 -0.5,0.2 0.3,0.2 -0.9,0.4 -0.4,-0.1 -0.5,0.1 h -0.7 l -0.6,-0.2 -0.6,-0.4 v 0.3 l 0.3,0.2 0.6,0.2 0.3,0.3 0.2,-0.1 0.4,0.1 0.4,0.3 -0.2,0.1 0.2,0.5 H 642 l -0.3,-0.3 -0.4,-0.1 -0.5,0.4 -0.2,-0.3 -0.3,-0.2 H 640 l -0.5,-0.2 -0.2,0.1 0.2,0.4 h 0.3 l 0.2,0.2 -0.2,0.1 0.7,0.6 -0.2,0.1 -0.4,-0.2 h -0.3 l -0.3,-0.3 -0.3,-0.1 -0.3,-0.1 -0.1,0.6 0.5,0.1 v 0.3 l -0.1,0.2 -0.4,-0.1 -0.1,-0.2 -0.5,-0.2 -0.1,-0.2 h -0.2 l -0.4,-0.5 0.3,-0.4 v -0.2 l -0.4,-0.5 v -0.2 l 0.5,-0.2 -0.1,-0.2 0.5,-0.1 -0.1,-0.3 0.6,-0.4 0.6,-0.2 0.4,0.4 v 0.4 l 0.3,-0.1 -0.5,-0.6 0.1,-0.3 -0.6,-0.2 -0.4,-0.3 0.1,-0.2 0.4,0.2 0.1,-0.5 -0.7,-0.2 0.1,-0.3 0.2,0.1 0.3,-0.2 h 0.3 l 0.2,-0.3 -0.3,-0.3 h 0.4 z"
              id="path160"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Falkland Islands"
              d="m 635.1,829.4 h 0.7 l 0.2,0.2 0.2,-0.2 0.2,0.1 0.2,0.3 -0.2,0.1 -0.4,-0.1 -0.4,-0.2 -0.8,-0.1 0.1,-0.2 z"
              id="path161"
            />
            <path onMouseOver={ev => doHover(ev)} data-name="Falkland Islands" d="m 628.3,828.3 -0.5,-0.1 0.1,-0.2 z" id="path162" />
            <path onMouseOut={ev => doOut(ev)} data-name="Falkland Islands" d="m 628.3,828.3 -0.5,-0.1 0.1,-0.2 z" id="path162" />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Faeroe Islands"
              d="m 895.6,112 0.4,0.2 h 0.3 l 0.1,0.2 v 0.4 l 0.2,0.3 -0.1,0.2 -0.6,-0.4 -0.2,-0.4 -0.2,-0.2 -0.2,-0.3 z"
              id="path163"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Faeroe Islands"
              d="m 895.9,110.4 0.8,0.2 0.2,0.2 -0.1,0.4 -0.1,0.1 -0.4,-0.5 -0.5,-0.1 -0.2,-0.4 z"
              id="path164"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Faeroe Islands"
              d="m 894.62,109.04 0.08,0.16 h 0.3 v 0.3 h -0.4 l -0.2,0.2 -0.6,-0.2 -0.2,-0.1 -0.2,-0.3 0.5,-0.1 0.1,-0.1 0.55714,0.0929 L 894.3,108.8 l 0.2,-0.8 0.5,0.1 0.3,0.5 v 0.1 l 0.6,0.2 0.3,0.5 0.3,0.2 -0.1,0.6 -0.5,-0.4 -0.2,-0.2 -0.2,-0.1 -0.1,-0.2 -0.2,-0.2 h -0.5 z"
              id="path165"
            />
            <path onMouseOver={ev => doHover(ev)} data-name="Faeroe Islands" d="m 898.3,108.4 -0.2,-0.2 0.3,-0.2 z" id="path166" />
            <path onMouseOut={ev => doOut(ev)} data-name="Faeroe Islands" d="m 898.3,108.4 -0.2,-0.2 0.3,-0.2 z" id="path166" />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Faeroe Islands"
              d="m 895.9,108.9 -0.4,-0.2 -0.3,-0.3 -0.1,-0.3 0.1,-0.1 0.4,-0.1 h 0.3 l 0.6,0.4 -0.1,0.2 0.1,0.2 0.6,0.2 v 0.2 l -0.4,0.3 z"
              id="path167"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Faeroe Islands"
              d="m 898.1,108.3 -0.3,0.4 -0.3,-0.2 h -0.3 l 0.2,-0.3 -0.1,-0.4 0.1,-0.1 0.2,0.4 z"
              id="path168"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Faeroe Islands"
              d="M 897.2,108.3 H 897 l -0.2,-0.4 0.1,-0.3 0.2,0.4 z"
              id="path169"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Federated States of Micronesia"
              d="m 1849.4,467.7 -0.2,0.3 -0.5,-0.1 v -0.2 l 0.5,-0.4 z"
              id="path170"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Federated States of Micronesia"
              d="m 1821.2,457.1 h 0.4 l 0.3,0.2 0.1,0.4 -0.2,0.1 0.1,0.2 -0.1,0.2 h -0.6 L 1821,458 v -0.2 l -0.2,-0.3 v -0.3 z"
              id="path171"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Federated States of Micronesia"
              d="m 1706.5,440.5 0.1,0.3 h -0.3 l -0.3,0.5 -0.1,-0.1 0.3,-0.8 0.4,-0.1 z"
              id="path172"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 579.2,424.5 -0.4,0.3 -0.2,-0.1 -0.1,-0.5 0.2,-0.5 0.3,-0.4 h 0.3 l 0.1,0.3 -0.1,0.7 z"
              id="GD"
              data-name="Grenada"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1740.8,415.5 -0.1,0.4 v 0.6 l -0.1,0.3 h -0.3 l -0.2,-0.3 -0.1,-0.5 v -0.5 l 0.6,-0.5 0.1,-0.2 0.1,-0.5 0.2,-0.1 0.1,0.2 0.4,0.1 -0.2,0.5 z"
              id="GU"
              data-name="Guam"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Saint Kitts and Nevis"
              d="M 576.3,392 H 576 l -0.1,-0.2 0.2,-0.4 h 0.2 l 0.1,0.2 z"
              id="path173"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Saint Kitts and Nevis"
              d="m 575.6,390.5 -0.1,0.3 h -0.2 l -0.4,-0.2 -0.2,-0.2 0.3,-0.4 0.5,0.4 z"
              id="path174"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 583.7,413.8 -0.2,-0.2 -0.4,-0.2 -0.1,-0.2 v -0.6 l 0.1,-0.2 0.7,-1.1 0.3,0.2 v 0.7 l -0.1,0.8 -0.1,0.4 z"
              id="LC"
              data-name="Saint Lucia"
            />
            <path onMouseOver={ev => doHover(ev)} d="m 574.2,386 -0.4,-0.1 0.2,-0.3 0.3,-0.1 z" id="MF" data-name="Saint-Martin" />
            <path onMouseOut={ev => doOut(ev)} d="m 574.2,386 -0.4,-0.1 0.2,-0.3 0.3,-0.1 z" id="MF" data-name="Saint-Martin" />
            <path onMouseOver={ev => doHover(ev)} d="m 1342.9,474.8 v 0.2 l -0.2,-0.1 0.2,-0.2 z" id="MV" data-name="Maldives" />
            <path onMouseOut={ev => doOut(ev)} d="m 1342.9,474.8 v 0.2 l -0.2,-0.1 0.2,-0.2 z" id="MV" data-name="Maldives" />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Malta"
              d="m 1003.9,271.7 -0.2,0.3 -0.5,-0.2 -0.5,-0.3 V 271 l -0.1,-0.1 h 0.6 l 0.4,0.3 0.2,0.2 z"
              id="path175"
            />
            <path onMouseOver={ev => doHover(ev)} data-name="Malta" d="m 1002.3,270.6 -0.5,-0.1 v -0.2 l 0.4,-0.1 0.4,0.3 z" id="path176" />
            <path onMouseOut={ev => doOut(ev)} data-name="Malta" d="m 1002.3,270.6 -0.5,-0.1 v -0.2 l 0.4,-0.1 0.4,0.3 z" id="path176" />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Northern Mariana Islands"
              d="m 1742.5,411.1 -0.1,0.1 -0.2,-0.1 -0.1,-0.2 0.5,-0.2 0.2,0.2 z"
              id="path177"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Northern Mariana Islands"
              d="m 1744,406 h -0.2 l -0.3,-0.6 0.1,-0.3 h 0.3 v 0.3 l 0.2,0.2 z"
              id="path178"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Northern Mariana Islands"
              d="m 1744.5,404.4 -0.2,0.2 0.1,0.3 h -0.4 v -0.7 l 0.1,-0.2 0.4,-0.2 -0.1,0.5 z"
              id="path179"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Northern Mariana Islands"
              d="m 1742.6,396.9 h -0.3 l -0.1,-0.2 h 0.4 z"
              id="path180"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Northern Mariana Islands"
              d="m 1740.7,385.9 -0.1,-0.2 v -0.5 l 0.3,-0.1 0.2,0.3 z"
              id="path181"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Northern Mariana Islands"
              d="m 1739.5,381.6 -0.4,-0.1 v -0.3 l 0.2,-0.1 0.2,0.2 z"
              id="path182"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 578.2,393.9 0.2,0.4 v 0.3 l -0.2,0.2 -0.2,-0.1 -0.1,-0.3 z"
              id="MS"
              data-name="Montserrat"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Mauritius"
              d="m 1247.7,630.8 0.4,0.9 -0.2,0.6 -0.4,0.4 0.1,0.3 -0.3,0.3 -0.5,0.2 h -0.5 l -0.6,-0.1 -0.1,0.1 -0.3,-0.3 0.2,-0.2 0.1,-0.4 0.1,-0.7 0.2,-0.4 0.5,-0.4 0.1,-0.2 0.2,-0.5 0.4,-0.3 0.4,0.1 z"
              id="path183"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Mauritius"
              d="m 1279.5,628.7 -0.3,-0.3 0.4,-0.2 0.3,-0.1 0.2,0.1 -0.1,0.2 z"
              id="path184"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="New Caledonia"
              d="m 1855.2,646.9 -0.2,0.1 -0.2,0.4 -0.4,-0.2 0.2,-0.5 0.1,-0.2 0.3,0.1 z"
              id="path185"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="New Caledonia"
              d="m 1859.6,639.1 -0.1,0.1 0.2,0.4 h 0.3 l 0.4,-0.2 -0.1,0.6 -0.2,0.2 -0.1,0.4 -0.5,0.3 -0.4,-0.2 v -0.1 l -0.3,-0.3 0.1,-0.2 -0.2,-0.2 0.1,-0.4 -0.1,-0.4 h 0.1 l 0.4,0.1 z"
              id="path186"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="New Caledonia"
              d="m 1856.9,634.8 -0.2,0.5 v 0.4 l -0.2,0.3 0.3,0.2 0.2,0.1 0.1,0.2 -0.1,0.2 0.3,0.4 h -0.2 l -0.2,0.5 -0.2,0.2 -0.3,-0.1 -0.2,-0.3 -0.1,-0.2 -0.6,-0.1 -0.3,-0.5 v -0.2 l -0.1,-0.3 h 0.3 l 0.3,-0.2 0.4,-0.3 0.1,-0.3 -0.4,-0.2 -0.4,0.1 0.2,-0.4 0.3,-0.1 0.2,0.1 0.4,-0.3 z"
              id="path187"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="New Caledonia"
              d="m 1853.5,633.2 -0.3,0.6 -0.1,0.3 h 0.3 l -0.5,0.5 -0.2,0.2 -0.1,-0.2 0.3,-0.4 0.2,-0.5 z"
              id="path188"
            />
            <path onMouseOver={ev => doHover(ev)} data-name="New Caledonia" d="m 1853.5,633.2 -0.2,-0.4 h 0.4 l 0.1,0.4 z" id="path189" />
            <path onMouseOut={ev => doOut(ev)} data-name="New Caledonia" d="m 1853.5,633.2 -0.2,-0.4 h 0.4 l 0.1,0.4 z" id="path189" />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="New Caledonia"
              d="m 1839.6,630.8 0.2,0.1 0.5,0.9 0.3,0.3 0.3,-0.1 0.2,-0.3 0.9,0.5 0.3,0.5 0.7,0.6 0.3,0.4 0.1,0.3 0.4,0.4 0.1,0.2 h 0.2 l 0.3,0.3 0.9,0.2 0.1,0.3 v 0.4 l 0.3,0.4 0.4,0.1 -0.3,0.5 0.1,0.2 0.4,0.5 h 0.1 l 0.4,0.5 -0.1,0.4 0.7,0.2 0.4,0.5 h 0.3 l 0.3,0.2 0.5,0.4 -0.1,0.3 h 0.3 l 0.4,0.5 0.6,0.4 v 0.2 l 0.3,0.1 0.3,0.3 v 0.2 l 0.3,0.6 0.4,0.4 0.1,-0.1 0.4,0.6 0.5,0.1 0.3,0.3 v 0.4 l 0.1,0.4 0.1,0.1 -0.2,0.6 -0.7,0.4 -0.1,-0.3 -0.3,0.1 -0.3,0.3 -0.6,-0.8 h -0.4 l -0.1,-0.2 h -0.2 l -0.2,0.3 -0.9,-0.9 h -0.2 l -0.4,-0.5 0.1,-0.8 h -0.3 -0.4 l -0.3,-0.2 -0.1,-0.2 -0.2,-0.1 h -0.3 v -0.3 l -0.2,-0.5 -0.4,0.1 -0.8,-0.5 -0.1,-0.2 v -0.3 l -0.3,0.2 -0.6,-0.3 -0.1,-0.4 -0.4,-0.3 -0.2,-0.5 -0.5,-0.1 0.2,-0.2 -0.3,-0.3 -0.3,-0.1 -0.3,-0.7 v -0.4 l -0.2,-0.3 h -0.3 l -0.2,-0.6 0.1,-0.2 -0.7,-0.4 -0.3,-0.2 -0.4,-0.6 0.3,-0.2 -0.2,-0.2 -0.2,-0.3 v -0.5 l -0.5,-0.3 V 633 l -0.2,-0.3 h 0.3 l 0.1,-0.3 -0.1,-0.2 h -0.6 l -0.2,-0.3 0.5,-0.7 -0.3,-0.3 z"
              id="path190"
            />
            <path onMouseOver={ev => doHover(ev)} data-name="New Caledonia" d="m 1840.7,631.1 -0.3,-0.1 0.1,-0.4 z" id="path191" />
            <path onMouseOut={ev => doOut(ev)} data-name="New Caledonia" d="m 1840.7,631.1 -0.3,-0.1 0.1,-0.4 z" id="path191" />
            <path onMouseOver={ev => doHover(ev)} data-name="New Caledonia" d="m 1838.4,628.7 -0.2,0.2 -0.1,-0.4 0.2,-0.2 z" id="path192" />
            <path onMouseOut={ev => doOut(ev)} data-name="New Caledonia" d="m 1838.4,628.7 -0.2,0.2 -0.1,-0.4 0.2,-0.2 z" id="path192" />
            <path onMouseOver={ev => doHover(ev)} d="m 1873,505.3 h -0.2 l -0.1,-0.3 h 0.3 z" id="NR" data-name="Nauru" />
            <path onMouseOut={ev => doOut(ev)} d="m 1873,505.3 h -0.2 l -0.1,-0.3 h 0.3 z" id="NR" data-name="Nauru" />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 1687.7,453.1 -0.2,0.4 0.1,0.1 -0.2,0.6 0.1,0.2 -0.5,0.2 -0.2,-0.7 0.3,-0.2 -0.2,-0.2 0.3,-0.6 0.3,-0.1 z"
              id="PW"
              data-name="Palau"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Puerto Rico"
              d="m 547.1,385.9 -0.3,-0.2 0.1,-0.2 h 0.3 l 0.1,0.1 z"
              id="path193"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Puerto Rico"
              d="m 561.7,385.4 h -0.2 l -0.9,0.3 H 560 l 0.2,-0.2 0.4,-0.2 0.4,-0.1 0.6,0.1 z"
              id="path194"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Puerto Rico"
              d="m 552.2,383 0.6,0.1 h 0.6 l 0.3,0.1 0.6,-0.1 0.3,0.1 0.4,-0.1 0.2,0.1 0.5,-0.1 0.4,0.1 h 0.3 l 0.8,0.2 v -0.2 l 0.6,0.2 0.1,-0.1 0.8,0.1 0.2,0.2 h 0.2 l 0.6,0.3 0.2,-0.1 -0.1,0.7 0.2,0.3 -0.9,0.3 -0.3,0.4 -0.3,0.6 -0.3,0.2 -0.3,0.1 h -0.4 l -0.6,0.1 -0.3,0.2 -0.7,-0.1 -0.2,-0.2 -0.5,0.2 -0.3,-0.3 -0.7,0.2 -0.9,-0.1 -0.3,0.1 -0.6,0.1 -0.2,0.1 -0.2,-0.2 -0.4,-0.1 -0.3,0.2 -0.6,-0.1 0.3,-0.7 v -0.4 l 0.2,-0.4 -0.2,-0.6 -0.2,-0.1 -0.1,-0.4 0.4,-0.2 0.2,-0.1 v -0.5 l 0.4,-0.2 z"
              id="path195"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="French Polynesia"
              d="m 135.3,679.3 -0.1,-0.1 -0.2,-0.3 0.1,-0.2 0.3,0.2 z"
              id="path196"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="French Polynesia"
              d="m 145.6,641.2 -0.1,0.1 -0.3,-0.2 0.2,-0.2 z"
              id="path197"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="French Polynesia"
              d="m 139.4,616.5 -0.2,-0.1 0.2,-0.6 0.5,-0.4 h 0.3 v 0.2 L 140,616 Z"
              id="path198"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="French Polynesia"
              d="m 91.7,615.5 0.7,0.2 0.3,0.4 v 0.3 l -0.2,0.1 -0.5,-0.1 -0.4,-0.6 -0.1,-0.2 -0.6,0.2 h -0.2 l -0.6,-0.1 -0.2,-0.4 -0.3,-0.5 v -0.3 l 0.1,-0.2 0.5,-0.1 h 0.5 l 0.5,0.2 0.2,0.4 0.1,0.6 z"
              id="path199"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="French Polynesia"
              d="m 88.7,614 -0.2,0.6 -0.5,-0.2 0.1,-0.3 0.5,-0.2 z"
              id="path200"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="French Polynesia"
              d="m 81.1,609.7 -0.2,0.1 -0.2,-0.3 0.3,-0.1 z"
              id="path201"
            />

            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="French Polynesia"
              d="m 79,610.1 -0.3,0.2 h -0.3 l -0.2,-0.8 0.2,-0.2 0.7,0.8 z"
              id="path202"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="French Polynesia"
              d="m 78,608.3 0.2,0.1 v 0.5 l -0.4,-0.2 -0.1,-0.3 z"
              id="path203"
            />
            <path onMouseOver={ev => doHover(ev)} data-name="French Polynesia" d="m 106.3,605.4 -0.3,0.1 0.1,-0.3 z" id="path204" />
            <path onMouseOut={ev => doOut(ev)} data-name="French Polynesia" d="m 106.3,605.4 -0.3,0.1 0.1,-0.3 z" id="path204" />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="French Polynesia"
              d="M 144.3,569.5 H 144 v -0.4 l -0.2,-0.3 0.4,0.1 0.1,0.4 z"
              id="path205"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="French Polynesia"
              d="M 141.2,566 H 141 v -0.4 l 0.2,-0.3 0.3,0.2 -0.2,0.2 z"
              id="path206"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="French Polynesia"
              d="m 142.4,564.4 v 0.3 l -0.4,0.1 h -0.6 v 0.3 l -0.4,-0.1 -0.2,-0.2 -0.1,-0.3 0.7,-0.4 h 0.3 l 0.2,0.2 z"
              id="path207"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="French Polynesia"
              d="m 135.5,561.8 v 0.4 0.2 h -0.3 l -0.3,-0.4 0.3,-0.3 z"
              id="path208"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="French Polynesia"
              d="m 137.9,558.8 0.3,0.1 0.1,0.1 -0.6,0.2 -0.1,-0.3 z"
              id="path209"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="French Polynesia"
              d="m 134.2,558.2 0.9,0.1 0.3,0.3 v 0.2 l -0.4,0.3 h -0.8 l -0.1,-0.5 -0.1,-0.4 z"
              id="path210"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Solomon Islands"
              d="m 1866.8,576.2 0.3,0.2 -0.1,0.4 h 0.3 v 0.2 h -0.8 l -0.3,-0.5 0.2,-0.3 z"
              id="path211"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Solomon Islands"
              d="m 1828.5,575.6 h 0.2 l 1,0.8 0.5,0.3 0.9,0.7 -0.1,0.3 h -0.2 l -0.2,0.2 -0.2,-0.3 h -0.1 l -0.2,-0.2 -0.1,-0.4 -0.4,-0.1 v -0.3 l -0.3,-0.1 -0.1,0.1 h -0.2 l -0.9,-0.4 -0.2,-0.4 0.3,-0.4 z"
              id="path212"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Solomon Islands"
              d="m 1865.4,574.1 -0.2,0.3 -0.3,-0.2 V 574 l 0.3,-0.2 z"
              id="path213"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Solomon Islands"
              d="m 1863.1,570.2 0.1,0.1 h 0.3 l -0.1,0.4 -0.5,0.2 h -0.3 l -0.4,0.1 -0.4,0.6 -0.1,-0.3 -0.3,0.1 -0.2,-0.2 v -0.3 l 0.5,-0.1 v -0.2 l 0.3,-0.4 0.7,0.1 z"
              id="path214"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Solomon Islands"
              d="m 1836.8,567.4 0.3,-0.1 0.6,0.3 0.5,0.5 0.3,0.3 h 0.2 l 0.2,0.2 h 0.2 l 0.3,0.3 0.3,-0.1 0.4,0.1 0.2,0.2 h 0.4 l 0.3,-0.1 0.2,0.3 0.2,0.8 0.3,0.3 v 0.5 l -0.2,0.2 0.1,0.3 -0.4,-0.2 -0.3,0.2 -0.3,-0.1 -0.5,-0.3 h -0.2 l -0.6,-0.2 -0.4,-0.1 -0.2,-0.3 -0.3,-0.2 -0.3,-0.1 -0.2,-0.3 -0.4,-0.2 0.2,-0.4 -0.1,-0.4 v -0.4 l -0.2,-0.1 -0.6,-0.2 -0.3,0.1 -0.1,-0.2 0.1,-0.3 0.1,-0.3 z"
              id="path215"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Solomon Islands"
              d="m 1840.8,564 -0.1,0.2 v 0.7 l -0.2,-0.2 v -0.5 z"
              id="path216"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Solomon Islands"
              d="m 1837.9,562.2 0.3,0.9 0.2,0.4 v 0.4 l 0.1,0.5 -0.2,0.3 -0.4,-0.7 -0.1,0.3 -0.3,-0.5 0.1,-1 0.1,-0.2 v -0.3 z"
              id="path217"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Solomon Islands"
              d="m 1829.5,562.4 h 0.3 l 0.3,-0.1 0.4,0.1 0.1,-0.1 h 0.5 0.8 l 0.2,0.3 0.3,0.1 0.2,0.3 h 0.2 l 0.2,0.1 0.4,0.4 v 0.6 h 0.2 l 0.4,0.2 0.1,0.3 v 0.6 l -0.1,0.1 -0.7,0.2 -0.2,0.1 -0.4,-0.1 -0.4,-0.2 h -0.4 l -0.1,-0.2 -0.5,-0.3 h -0.6 l -0.5,0.1 h -0.5 l -0.5,-0.1 -0.3,-0.2 -0.3,0.1 -0.3,-0.4 -0.3,-0.2 -0.3,-0.8 -0.2,-0.4 0.2,-0.2 -0.1,-0.2 v -0.7 l 0.1,-0.3 0.6,-0.3 0.4,0.2 0.4,0.5 0.1,0.3 z"
              id="path218"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Solomon Islands"
              d="m 1831.8,560 0.5,0.5 -0.3,0.3 -0.3,-0.2 v -0.1 z"
              id="path219"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Solomon Islands"
              d="m 1831.8,560 -0.2,0.4 h -0.1 l -0.4,-0.3 -0.3,0.1 -0.2,-0.1 -0.1,-0.2 0.3,-0.1 0.2,-0.2 0.5,0.1 z"
              id="path220"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Solomon Islands"
              d="m 1825.2,559.5 0.1,0.2 0.2,0.1 -0.2,0.4 -0.4,0.2 -0.3,-0.4 z"
              id="path221"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Solomon Islands"
              d="m 1816.7,557.7 0.2,0.3 -0.1,0.3 -0.8,-0.4 0.5,-0.3 z"
              id="path222"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Solomon Islands"
              d="m 1820.1,558.5 -0.3,-0.2 0.1,-0.3 0.3,-0.3 v 0.5 l 0.1,0.2 z"
              id="path223"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Solomon Islands"
              d="m 1819.2,556.7 0.2,-0.1 h 0.4 v 0.2 l -0.4,0.3 0.2,0.2 v 0.3 l -0.4,0.4 -0.2,0.1 -0.3,-0.1 -0.4,-0.4 0.1,-0.6 0.3,-0.1 0.2,-0.4 0.3,-0.1 z"
              id="path224"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Solomon Islands"
              d="m 1815.6,556.8 -0.2,0.1 -0.2,0.5 0.4,0.5 -0.5,-0.2 v -0.2 l -0.1,-0.3 -0.4,-0.4 v -0.2 l 0.4,-0.2 0.1,-0.3 0.4,-0.3 0.3,0.2 v 0.4 z"
              id="path225"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Solomon Islands"
              d="m 1828.5,556.3 0.2,0.2 -0.1,0.2 -0.2,-0.1 -0.6,-0.5 0.2,-0.4 0.3,-0.1 0.2,0.2 -0.1,0.3 z"
              id="path226"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Solomon Islands"
              d="m 1835,555.5 0.4,0.8 0.6,0.8 v 0.3 l -0.4,0.2 v 0.5 0.3 l 0.1,0.2 h 0.2 l 0.2,0.3 0.5,0.4 0.1,0.5 0.1,0.3 0.2,0.2 -0.2,0.2 0.3,0.3 -0.1,0.1 0.1,0.5 -0.2,0.2 0.3,0.3 0.1,0.5 0.2,0.5 v 0.6 l -0.1,0.1 -0.3,-0.3 -0.3,-0.5 v -0.3 l -0.3,-0.4 -0.4,-0.3 -0.3,-0.3 -0.5,-0.6 -0.4,-0.3 -0.3,-0.9 -0.2,-1 -0.2,-0.7 v -0.5 l -0.1,-0.4 0.4,-0.4 -0.1,-0.3 -0.5,-0.7 -0.1,-0.3 0.1,-0.1 0.4,0.1 0.2,0.1 0.3,-0.3 z"
              id="path227"
            />
            <path onMouseOver={ev => doHover(ev)} data-name="Solomon Islands" d="m 1814.3,555.2 -0.2,-0.4 -0.3,-0.3 h 0.4 z" id="path228" />
            <path onMouseOut={ev => doOut(ev)} data-name="Solomon Islands" d="m 1814.3,555.2 -0.2,-0.4 -0.3,-0.3 h 0.4 z" id="path228" />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Solomon Islands"
              d="m 1814.2,554.2 0.4,0.1 0.1,0.1 0.1,0.5 h -0.2 l -0.2,-0.4 z"
              id="path229"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Solomon Islands"
              d="m 1817.3,554.4 -0.1,0.3 h 0.2 0.5 l 0.4,0.7 v 0.2 l 0.2,0.3 0.1,0.5 -0.2,0.2 v 0.3 l -0.6,-0.2 -0.2,-0.2 h -0.3 l -0.4,-0.3 -0.1,-0.2 -0.1,-0.3 0.4,0.1 -0.3,-0.8 -0.1,-0.2 -0.5,0.1 -0.2,0.1 h -0.4 l -0.3,0.4 -0.4,-0.2 v -0.6 l 0.2,-0.2 h 0.4 V 554 l 0.4,-0.6 0.4,-0.3 0.3,-0.2 0.4,0.3 0.2,0.4 -0.1,0.7 z"
              id="path230"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Solomon Islands"
              d="m 1811.4,554.4 h -0.1 l -0.2,-0.8 0.1,-0.3 v -0.4 l 0.2,0.1 0.1,0.4 v 0.7 z"
              id="path231"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Solomon Islands"
              d="m 1814.8,553.9 -0.3,0.2 -0.1,-0.1 h -0.4 l -0.3,-0.3 -0.1,-0.3 -0.1,-0.3 0.1,-0.3 0.3,-0.4 0.5,-0.2 0.2,0.2 0.3,0.5 v 0.6 z"
              id="path232"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Solomon Islands"
              d="m 1811.8,550.4 0.4,0.5 v 0.1 l 0.7,0.4 -0.1,0.3 -0.6,0.7 v 0.3 l -0.3,0.1 v -0.4 h -0.2 V 552 l -0.2,-0.4 -0.3,-0.2 -0.1,-0.3 0.1,-0.3 0.2,-0.2 0.2,-0.2 z"
              id="path233"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Solomon Islands"
              d="m 1822.1,550.5 0.3,0.2 -0.2,0.1 -0.5,0.1 -0.1,-0.3 0.2,-0.2 z"
              id="path234"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Solomon Islands"
              d="m 1823,550.5 0.2,-0.1 0.5,0.3 0.3,0.1 0.2,0.2 0.3,0.5 0.3,0.1 0.3,0.3 v 0.3 l 0.5,0.1 v 0.3 l 0.3,0.1 0.3,-0.1 0.1,0.1 0.4,0.2 0.1,0.2 0.3,-0.1 0.3,0.1 0.1,0.3 0.4,0.3 0.3,0.3 0.4,0.3 1,1 -0.3,0.4 0.3,0.5 0.1,0.6 -0.3,-0.1 -0.3,-0.4 -0.7,-0.8 -0.4,-0.1 -0.5,-0.4 -0.6,-0.1 -0.1,-0.3 -0.6,-0.2 -0.5,-0.5 h -0.2 l -0.8,-0.6 -0.5,-0.3 v -0.2 l -0.4,-0.2 -0.2,-0.2 -0.2,-0.4 -0.4,-0.3 -0.1,-0.2 v -0.4 l -0.4,-0.5 -0.2,-0.1 v -0.3 z"
              id="path235"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Solomon Islands"
              d="m 1821.5,549.9 0.2,0.2 0.2,-0.1 0.3,0.2 -0.1,0.2 -0.3,-0.1 z"
              id="path236"
            />
            <path onMouseOver={ev => doHover(ev)} data-name="Solomon Islands" d="m 1817,549.3 h 0.5 l -0.2,0.2 -0.3,-0.1 z" id="path237" />
            <path onMouseOut={ev => doOut(ev)} data-name="Solomon Islands" d="m 1817,549.3 h 0.5 l -0.2,0.2 -0.3,-0.1 z" id="path237" />
            <path onMouseOver={ev => doHover(ev)} data-name="Solomon Islands" d="m 1821.3,549.3 -0.2,0.5 -0.1,-0.2 z" id="path238" />
            <path onMouseOut={ev => doOut(ev)} data-name="Solomon Islands" d="m 1821.3,549.3 -0.2,0.5 -0.1,-0.2 z" id="path238" />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Solomon Islands"
              d="m 1818.6,549.7 -0.5,0.1 -0.2,-0.2 0.3,-0.4 0.3,0.1 z"
              id="path239"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Solomon Islands"
              d="m 1806.1,548.8 0.2,0.3 -0.2,0.2 -0.3,-0.1 -0.1,-0.1 z"
              id="path240"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Solomon Islands"
              d="m 1807.6,546.9 0.3,0.2 -0.1,0.3 -0.7,0.2 -0.3,-0.3 0.3,-0.6 0.2,-0.1 z"
              id="path241"
            />
            <path onMouseOver={ev => doHover(ev)} data-name="Solomon Islands" d="m 1809.3,546 v 0.5 l -0.2,-0.2 v -0.2 z" id="path242" />
            <path onMouseOut={ev => doOut(ev)} data-name="Solomon Islands" d="m 1809.3,546 v 0.5 l -0.2,-0.2 v -0.2 z" id="path242" />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Solomon Islands"
              d="m 1812.2,544.5 0.3,0.1 0.4,0.5 0.3,0.2 0.3,0.1 0.3,0.3 0.8,0.4 0.4,0.5 v 0.4 l 0.1,0.6 0.2,0.2 0.3,0.3 h 0.2 l 0.1,0.4 0.7,0.3 0.4,-0.1 0.1,0.1 v 0.3 l -0.3,0.1 -0.2,0.3 -0.5,-0.2 -0.8,-0.4 h -0.5 l -0.3,-0.4 -0.7,-0.4 -0.6,-1 -0.6,-1 -0.5,-0.3 -0.7,-0.7 v -0.5 -0.2 l 0.3,-0.2 0.3,0.1 z"
              id="path243"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="São Tomé and Principe"
              d="m 963.9,501.3 h -0.2 l -0.2,0.3 h -0.2 l -0.1,-0.4 -0.2,-0.8 v -0.3 l 0.4,-0.5 0.3,-0.1 0.3,-0.3 0.4,0.1 0.2,0.4 0.1,0.3 -0.1,0.4 -0.2,0.3 -0.3,0.4 z"
              id="path244"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="São Tomé and Principe"
              d="m 968.5,491.5 -0.1,0.3 -0.2,0.1 -0.3,-0.1 v -0.3 l 0.2,-0.1 v -0.3 l 0.2,-0.2 0.3,0.1 z"
              id="path245"
            />
            <path onMouseOver={ev => doHover(ev)} d="m 574.2,386 v 0.1 l -0.4,-0.1 v -0.1 z" id="SX" data-name="Sint Maarten" />
            <path onMouseOut={ev => doOut(ev)} d="m 574.2,386 v 0.1 l -0.4,-0.1 v -0.1 z" id="SX" data-name="Sint Maarten" />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Seychelles"
              d="m 1189,562.1 -0.3,0.2 h -0.5 l -0.4,0.2 h -0.4 v -0.2 h 0.5 l 0.4,-0.1 0.4,-0.3 h 0.2 z"
              id="path246"
            />
            <path onMouseOver={ev => doHover(ev)} data-name="Seychelles" d="m 1188.5,561.8 -0.2,0.1 h -0.4 v -0.2 z" id="path247" />
            <path onMouseOut={ev => doOut(ev)} data-name="Seychelles" d="m 1188.5,561.8 -0.2,0.1 h -0.4 v -0.2 z" id="path247" />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Seychelles"
              d="m 1240.4,531.5 0.4,0.4 -0.2,0.3 -0.2,-0.3 -0.3,-0.2 0.2,-0.5 z"
              id="path248"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Turks and Caicos Islands"
              d="m 527.7,361.6 h 0.7 l 0.3,0.4 h -0.3 l -0.3,-0.1 -0.5,0.1 -0.1,-0.3 z"
              id="path249"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Turks and Caicos Islands"
              d="m 525,361.5 0.3,0.4 0.6,-0.1 -0.2,0.2 h -0.6 l -0.4,-0.2 z"
              id="path250"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Turks and Caicos Islands"
              d="m 527.2,360.9 v 0.5 l -0.5,-0.2 -0.1,-0.3 0.1,-0.1 z"
              id="path251"
            />
            <path onMouseOver={ev => doHover(ev)} data-name="Tonga" d="m -45.3,639.5 -0.5,-0.3 V 639 l 0.3,-0.2 z" id="path252" />
            <path onMouseOut={ev => doOut(ev)} data-name="Tonga" d="m -45.3,639.5 -0.5,-0.3 V 639 l 0.3,-0.2 z" id="path252" />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Tonga"
              d="m -48.1,637.4 h 0.3 l 0.4,0.3 0.3,0.1 0.2,-0.4 0.3,0.3 -0.3,0.3 0.1,0.2 -0.1,0.2 -0.2,-0.1 -0.3,-0.3 -0.7,-0.2 z"
              id="path253"
            />
            <path onMouseOver={ev => doHover(ev)} data-name="Tonga" d="m -48.9,628.8 -0.2,0.1 -0.1,-0.5 0.2,0.1 z" id="path254" />
            <path onMouseOut={ev => doOut(ev)} data-name="Tonga" d="m -48.9,628.8 -0.2,0.1 -0.1,-0.5 0.2,0.1 z" id="path254" />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Tonga"
              d="m -44.5,621.3 -0.5,0.3 h -0.2 l -0.1,-0.1 0.3,-0.5 0.3,0.1 z"
              id="path255"
            />
            <path onMouseOver={ev => doHover(ev)} data-name="Tonga" d="m -58.6,602 -0.1,0.1 -0.3,-0.1 0.1,-0.2 h 0.3 z" id="path256" />
            <path onMouseOut={ev => doOut(ev)} data-name="Tonga" d="m -58.6,602 -0.1,0.1 -0.3,-0.1 0.1,-0.2 h 0.3 z" id="path256" />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Trinidad and Tobago"
              d="m 582.8,432.2 -0.2,0.5 -0.3,0.4 -0.2,0.1 -0.1,0.4 0.2,0.6 -0.2,0.1 v 0.7 l 0.2,0.3 0.2,0.2 -0.2,0.2 -0.1,0.3 v 0.7 l -0.2,0.1 -0.4,0.2 -0.5,0.1 h -0.3 l -0.5,0.1 -0.5,-0.1 -0.4,0.1 -0.3,-0.1 -0.5,0.2 -0.4,-0.2 h -0.6 l -0.3,0.2 -0.3,-0.1 0.5,-0.2 0.3,-0.3 0.4,-0.1 0.4,-0.3 0.2,-0.3 0.6,0.1 0.3,-0.4 -0.2,-0.8 0.2,-0.4 v -0.5 -0.2 l -0.3,-0.4 -0.3,-0.1 -0.4,-0.1 -0.1,-0.1 0.4,-0.3 1.1,-0.1 0.2,-0.2 h 1.1 l 0.1,-0.1 1.2,-0.2 z"
              id="path257"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Trinidad and Tobago"
              d="m 585.2,429 -0.1,0.5 -0.3,0.1 -0.4,0.3 h -0.2 l -0.7,0.4 -0.2,-0.2 0.3,-0.3 0.7,-0.5 z"
              id="path258"
            />
            <path onMouseOver={ev => doHover(ev)} d="m 1938.9,556.6 v -0.2 h 0.1 v 0.1 z" id="TV" data-name="Tuvalu" />
            <path onMouseOut={ev => doOut(ev)} d="m 1938.9,556.6 v -0.2 h 0.1 v 0.1 z" id="TV" data-name="Tuvalu" />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 582.2,417.4 -0.1,0.1 -0.5,-0.3 v -0.4 l 0.2,-0.3 0.2,-0.5 h 0.4 l 0.1,0.4 -0.1,0.8 z"
              id="VC"
              data-name="Saint Vincent and the Grenadines"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="British Virgin Islands"
              d="m 566.1,383.4 -0.4,0.2 h -0.1 l -0.3,0.2 -0.1,-0.1 0.1,-0.3 0.6,-0.1 z"
              id="VG"
            />
            <path onMouseOver={ev => doHover(ev)} d="m 564.5,387.8 0.3,0.3 -1.1,0.2 -0.1,-0.5 0.7,-0.2 z" id="path259" />
            <path onMouseOut={ev => doOut(ev)} d="m 564.5,387.8 0.3,0.3 -1.1,0.2 -0.1,-0.5 0.7,-0.2 z" id="path259" />
            <path onMouseOver={ev => doHover(ev)} d="m 565.2,384 -0.2,0.2 h -0.5 V 384 l 0.3,-0.1 z" id="path260" />
            <path onMouseOut={ev => doOut(ev)} d="m 565.2,384 -0.2,0.2 h -0.5 V 384 l 0.3,-0.1 z" id="path260" />
            <path onMouseOver={ev => doHover(ev)} d="m 563.8,383.8 0.4,0.3 -0.2,0.2 -0.3,-0.2 h -0.5 l 0.2,-0.2 z" id="path261" />
            <path onMouseOut={ev => doOut(ev)} d="m 563.8,383.8 0.4,0.3 -0.2,0.2 -0.3,-0.2 h -0.5 l 0.2,-0.2 z" id="path261" />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Vanuatu"
              d="m 1871.8,631.8 -0.5,-0.2 0.2,-0.4 0.5,-0.1 0.2,0.4 -0.1,0.2 z"
              id="path262"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Vanuatu"
              d="m 1870.6,628 h -0.2 l -0.3,-0.1 -0.4,-0.5 -0.1,-0.4 v -0.4 l 0.2,-0.2 0.1,-0.4 0.3,-0.1 h 0.4 l -0.2,0.3 v 0.5 l 0.7,0.5 -0.3,0.3 z"
              id="path263"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Vanuatu"
              d="m 1870.6,622.1 h 0.3 l 0.1,0.2 -0.5,0.1 0.1,0.3 0.4,0.2 0.1,0.3 -0.1,0.4 -0.4,0.1 -0.4,-0.3 h -0.4 l -0.2,-0.2 -0.3,-0.2 0.1,-0.4 v -0.3 l 0.2,-0.5 0.3,-0.4 h 0.5 l 0.2,0.1 -0.1,0.4 z"
              id="path264"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Vanuatu"
              d="m 1867.6,614.5 0.6,-0.1 0.1,0.1 0.2,0.6 0.2,0.3 0.1,0.1 -0.4,0.6 -0.8,0.2 -0.3,-0.3 -0.1,-0.5 -0.3,-0.1 -0.4,0.3 -0.1,-0.1 0.2,-0.4 0.4,-0.3 0.4,-0.5 z"
              id="path265"
            />
            <path onMouseOver={ev => doHover(ev)} data-name="Vanuatu" d="m 1869.9,610.6 -0.1,-0.3 h 0.3 z" id="path266" />
            <path onMouseOut={ev => doOut(ev)} data-name="Vanuatu" d="m 1869.9,610.6 -0.1,-0.3 h 0.3 z" id="path266" />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Vanuatu"
              d="m 1868.3,608.2 0.1,0.5 v 0.2 l 0.4,0.1 0.2,0.5 h 0.5 v 0.4 l -0.1,0.1 -0.3,-0.3 -0.3,-0.1 -0.6,0.2 -0.3,-0.1 -0.1,-0.2 -0.1,-0.4 0.2,-0.5 0.2,-0.3 z"
              id="path267"
            />
            <path onMouseOver={ev => doHover(ev)} data-name="Vanuatu" d="m 1869.2,608 h -0.1 l -0.1,-0.3 h 0.2 z" id="path268" />
            <path onMouseOut={ev => doOut(ev)} data-name="Vanuatu" d="m 1869.2,608 h -0.1 l -0.1,-0.3 h 0.2 z" id="path268" />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Vanuatu"
              d="m 1869.4,606.6 -0.2,0.2 h -0.6 l -0.3,0.1 -0.2,-0.2 -0.4,-0.1 -0.5,-0.4 0.1,-0.2 0.5,-0.2 0.4,-0.1 0.4,-0.3 0.1,-0.3 h 0.2 l 0.1,0.3 v 0.6 l 0.5,0.4 z"
              id="path269"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Vanuatu"
              d="m 1864.7,605.3 0.2,0.3 0.6,0.4 0.7,0.7 0.1,0.1 v 0.4 l 0.2,0.3 -0.3,0.2 -0.4,0.4 v -0.2 l -0.3,-0.1 h -0.4 l -0.2,0.1 v 0.2 l -0.4,0.2 -0.3,-0.1 v -0.7 l -0.1,-0.6 0.1,-0.6 0.1,-0.5 -0.2,-0.5 -0.6,0.3 -0.2,-0.2 -0.1,-0.3 v -0.3 l 0.3,-0.3 v -0.4 l 0.1,-0.3 0.3,-0.1 0.6,0.3 -0.1,0.2 0.2,0.5 -0.1,0.2 z"
              id="path270"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Vanuatu"
              d="m 1864.1,602.9 h -0.3 l -0.5,-0.3 v -0.1 l 0.2,-0.3 0.2,-0.1 0.5,0.1 -0.1,0.4 z"
              id="path271"
            />
            <path onMouseOver={ev => doHover(ev)} data-name="Vanuatu" d="m 1863.6,601.9 0.4,-0.3 0.1,0.1 0.1,0.3 h -0.5 z" id="path272" />
            <path onMouseOut={ev => doOut(ev)} data-name="Vanuatu" d="m 1863.6,601.9 0.4,-0.3 0.1,0.1 0.1,0.3 h -0.5 z" id="path272" />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Vanuatu"
              d="m 1869.3,604.5 -0.2,-0.1 0.1,-1.2 -0.1,-0.3 0.1,-0.5 0.3,-0.8 0.1,-0.5 0.2,0.6 -0.1,0.3 v 0.6 1 l -0.1,0.6 z"
              id="path273"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Vanuatu"
              d="m 1868,601.2 h -0.7 l -0.3,-0.1 v -0.2 l 0.9,-0.7 0.5,-0.2 0.5,-0.1 v 0.2 l -0.3,0.4 -0.2,0.3 z"
              id="path274"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Vanuatu"
              d="m 1869.9,600.5 v 0.2 h -0.3 l 0.1,-0.3 0.2,-1.3 V 599 l 0.1,-1.2 0.2,0.1 -0.1,1.3 0.1,0.3 -0.1,0.5 z"
              id="path275"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Vanuatu"
              d="m 1863.6,601.9 -0.9,-0.1 -0.6,0.3 -0.1,0.2 h -0.2 l -0.1,-0.6 -0.2,-0.1 -0.4,-1 0.4,-0.8 v -0.4 l -0.1,-0.2 v -1.4 l -0.1,-0.3 V 597 l 0.2,-0.3 v -0.3 l 0.2,-0.3 v -0.2 l 0.3,-0.1 0.1,0.5 0.2,0.4 0.2,0.3 0.1,1.3 -0.1,0.8 v 0.1 l 0.6,-0.1 0.3,-0.3 0.2,-0.8 v -0.2 l 0.3,-0.2 0.3,0.1 -0.1,0.4 v 0.9 l 0.3,0.1 v 0.5 l -0.2,0.1 0.3,0.4 -0.2,0.2 v 0.5 l 0.2,0.5 -0.1,0.2 h -0.3 z"
              id="path276"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Vanuatu"
              d="m 1867.8,592.6 0.4,0.3 -0.1,0.4 -0.3,0.3 -0.2,0.2 h -0.6 v -0.4 l 0.1,-0.4 0.2,-0.3 z"
              id="path277"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Vanuatu"
              d="m 1868.4,590.7 -0.3,0.2 -0.2,0.1 v 0.2 l -0.2,0.1 V 591 l -0.2,-0.2 -0.1,-0.3 0.1,-0.4 0.2,-0.1 0.4,-0.2 0.1,0.2 0.1,0.4 v 0.1 z"
              id="path278"
            />
            <path onMouseOver={ev => doHover(ev)} data-name="Vanuatu" d="m 1863.4,586.5 -0.1,-0.1 0.1,-0.5 0.2,0.2 z" id="path279" />
            <path onMouseOut={ev => doOut(ev)} data-name="Vanuatu" d="m 1863.4,586.5 -0.1,-0.1 0.1,-0.5 0.2,0.2 z" id="path279" />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Samoa"
              d="m -38.1,591.3 0.3,0.1 0.3,0.1 0.3,0.2 -0.1,0.3 h -1 l -0.3,-0.1 -0.3,0.1 -0.2,-0.1 -0.4,-0.2 -0.3,0.1 -0.3,-0.2 -0.2,-0.2 -0.6,-0.3 0.1,-0.4 0.4,-0.2 h 0.4 0.5 l 0.9,0.4 0.5,0.1 z"
              id="path280"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Samoa"
              d="m -42.6,588.5 0.6,0.6 0.2,0.7 -0.1,0.3 0.1,0.3 h -0.3 l -0.3,-0.2 -0.3,0.2 -0.9,0.1 -0.3,-0.3 -0.2,-0.4 -0.2,-0.1 -0.3,-0.3 -0.5,-0.4 -0.2,-0.2 v -0.2 l 0.4,0.1 0.3,-0.1 0.6,-0.2 h 0.4 l 0.5,-0.1 h 0.3 z"
              id="path281"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 542,424.6 h -0.2 l -0.1,-0.5 0.1,-0.3 -0.1,-0.3 -0.4,-0.1 -0.3,-0.3 0.1,-0.3 1.2,0.6 -0.1,0.2 v 0.4 l -0.2,0.2 z"
              id="BQBO"
              data-name="Netherlands"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 574.3,389.6 -0.2,0.1 v -0.2 l 0.1,-0.1 z"
              id="BQSE"
              data-name="St. Eustatius (Netherlands)"
            />
            <path onMouseOver={ev => doHover(ev)} d="m 572.8,388.7 h -0.1 l 0.1,-0.2 0.1,0.1 z" id="BQSA" data-name="Saba (Netherlands)" />
            <path onMouseOut={ev => doOut(ev)} d="m 572.8,388.7 h -0.1 l 0.1,-0.2 0.1,0.1 z" id="BQSA" data-name="Saba (Netherlands)" />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              d="m 584,406.9 v 0.2 l 0.4,-0.1 -0.2,0.5 0.2,0.2 v 0.2 l 0.2,0.2 0.2,0.9 -0.3,0.3 -0.1,-0.4 -0.1,0.1 -0.6,-0.1 h -0.4 l -0.2,-0.3 0.6,-0.5 h -0.4 l -0.4,-0.4 -0.1,-0.5 -0.2,-0.5 0.3,-0.4 0.4,0.1 0.5,0.3 z"
              id="MQ"
              data-name="Martinique"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Spain"
              d="m 828.4,323.4 -0.3,0.5 -0.4,0.5 -0.3,-0.4 H 827 l -0.2,-0.2 0.2,-0.3 0.4,0.1 0.4,-0.4 0.3,-0.2 0.2,0.1 z"
              id="path282"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Spain"
              d="m 842,321.1 v 0.5 l 0.2,0.4 -0.2,0.7 0.1,0.3 -0.4,0.4 -0.5,0.2 -0.2,0.2 -0.6,-0.2 -0.5,-0.5 -0.2,-0.4 v -0.6 l 0.6,-0.4 0.1,-0.5 V 321 l 0.6,0.1 h 0.4 l 0.3,0.1 z"
              id="path283"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Spain"
              d="m 832.1,321.9 h -0.2 l -0.3,-0.2 -0.2,-0.3 0.1,-0.4 0.1,-0.3 h 0.3 0.3 l 0.5,0.4 0.1,0.3 -0.5,0.5 z"
              id="path284"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Spain"
              d="m 838.2,318.4 v 0.2 l -0.6,0.3 -0.4,0.5 -0.3,0.2 v 0.4 l -0.4,0.7 -0.1,0.4 -0.5,0.6 -0.1,0.2 h -0.2 l -0.6,0.2 -0.1,-0.1 -0.1,-0.4 -0.3,-0.4 -0.1,-0.2 -0.2,-0.3 v -0.3 l -0.4,-0.6 0.5,-0.3 0.3,0.2 0.6,-0.2 h 0.4 l 0.5,-0.2 0.5,-0.4 v -0.2 l 0.6,-0.3 h 0.6 l 0.3,-0.1 z"
              id="path285"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Spain"
              d="m 848.4,321.2 -0.3,0.4 -0.4,0.1 -0.3,-0.1 H 847 v -0.2 h 0.3 l 0.6,-0.2 0.4,-0.3 0.3,-0.3 0.1,-0.5 0.1,-0.3 0.2,-0.5 0.3,-0.4 0.3,-0.6 0.2,-0.8 0.2,-0.2 0.4,-0.1 0.3,0.3 0.1,0.5 -0.1,0.5 -0.1,0.5 v 0.5 l -0.1,0.1 -0.3,0.7 -0.3,0.3 -0.6,0.1 -0.7,0.3 z"
              id="path286"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Spain"
              d="m 828.8,316.7 0.3,-0.1 0.2,0.3 0.2,0.5 -0.2,0.3 0.1,0.4 -0.6,1 -0.1,-0.1 -0.1,-0.4 -0.4,-0.9 -0.1,-0.3 -0.1,-0.2 0.2,-0.4 0.3,-0.2 z"
              id="path287"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Spain"
              d="m 852.9,314.7 v 0.4 l -0.2,0.5 -0.7,0.5 -0.5,0.1 -0.4,0.5 -0.5,-0.2 v -0.1 l 0.2,-0.4 v -0.4 l 0.2,-0.3 0.3,-0.2 h 0.3 l 0.3,-0.3 h 0.5 l 0.1,-0.1 0.2,-0.5 0.2,-0.1 0.2,0.2 z"
              id="path288"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Mayotte"
              d="m 1180.2,583.1 0.2,0.3 0.5,0.2 v 0.3 l -0.2,0.2 0.1,0.2 -0.3,0.6 0.1,0.2 -0.3,0.1 -0.2,-0.3 v -0.3 l 0.2,-0.2 -0.2,-0.7 -0.1,-0.1 -0.1,-0.2 z"
              id="YT"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Reunion"
              d="m 1235,635.8 h 0.4 l 0.4,0.2 0.3,0.3 v 0.3 l 0.1,0.5 0.3,0.2 0.2,0.2 0.1,0.2 -0.2,0.6 -0.1,0.4 -0.2,0.2 -0.4,0.1 h -0.9 l -0.2,-0.2 -0.8,-0.4 -0.3,-0.5 v -0.3 l -0.3,-0.6 0.1,-0.4 0.2,-0.2 0.2,-0.4 h 0.1 l 0.5,-0.2 z"
              id="RE"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Guadeloupe"
              d="m 583,399.9 h -0.3 l -0.2,-0.4 0.1,-0.2 0.3,-0.3 0.3,0.2 0.1,0.3 v 0.2 z"
              id="path289"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Guadeloupe"
              d="m 581.2,397.3 h 0.3 v 0.2 0.1 l -0.2,0.1 v 0.8 0.4 l -0.2,0.2 -0.6,0.3 v -0.2 l -0.2,-0.2 -0.1,-0.5 V 398 l -0.1,-0.5 v -0.3 l 0.2,-0.3 0.3,-0.1 0.5,0.3 z"
              id="path290"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Guadeloupe"
              d="m 582.6,396.9 0.4,0.1 0.5,0.4 -1.3,0.3 -0.3,0.1 -0.4,-0.3 0.1,-0.6 0.2,-0.1 -0.1,-0.6 0.1,-0.2 0.3,-0.2 0.3,0.4 v 0.4 z"
              id="path291"
            />
            <path onMouseOver={ev => doHover(ev)} data-name="Fiji" d="m 1929.1,624.9 -0.3,0.1 0.1,-0.4 z" id="path292" />
            <path onMouseOut={ev => doOut(ev)} data-name="Fiji" d="m 1929.1,624.9 -0.3,0.1 0.1,-0.4 z" id="path292" />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Fiji"
              d="m 1921.6,623.3 0.2,0.2 0.3,0.1 v 0.3 l -0.5,0.2 -0.5,-0.3 -0.5,0.3 h -0.3 l -0.2,0.3 0.1,0.3 -0.4,-0.1 -0.1,0.2 -0.4,-0.1 -0.1,0.1 -0.4,-0.2 0.3,-0.1 0.2,-0.1 0.2,-0.2 0.4,0.1 0.3,-0.3 0.2,-0.3 0.5,-0.1 0.5,-0.3 z"
              id="path293"
            />
            <path onMouseOver={ev => doHover(ev)} data-name="Fiji" d="m 1922.5,623.2 -0.2,0.1 -0.2,-0.1 0.2,-0.2 z" id="path294" />
            <path onMouseOut={ev => doOut(ev)} data-name="Fiji" d="m 1922.5,623.2 -0.2,0.1 -0.2,-0.1 0.2,-0.2 z" id="path294" />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Fiji"
              d="m 1928.4,617.1 0.1,0.5 -0.2,0.6 -0.1,-0.2 -0.1,-0.4 h -0.2 l 0.1,-0.5 0.2,-0.1 z"
              id="path295"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Fiji"
              d="m 1925.8,615.7 h -0.1 l -0.1,-0.4 0.2,-0.2 0.4,-0.1 v 0.4 l -0.2,0.2 z"
              id="path296"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Fiji"
              d="m 1923.6,613.2 -0.1,0.4 0.3,0.2 0.1,0.3 0.3,0.4 0.3,0.1 0.1,0.3 h 0.2 l 0.1,0.4 -0.3,0.5 0.1,0.2 0.1,0.5 -0.3,0.2 v 0.5 h 0.2 l 0.1,0.5 -0.3,0.3 -0.6,0.2 -0.1,-0.2 -0.3,0.1 -0.1,0.2 -0.3,-0.3 -0.8,0.3 -0.8,0.7 -0.3,-0.1 -0.4,0.2 -0.3,-0.1 -0.6,0.1 -0.3,-0.2 -0.9,-0.3 -0.3,-0.1 -0.6,-0.1 -0.2,-0.1 -0.5,-0.2 -0.2,-1 0.3,-0.7 h 0.3 l 0.3,-0.1 0.1,-0.5 0.3,-0.1 0.1,-0.4 -0.2,-0.2 0.6,-0.4 0.4,-0.5 0.1,0.1 0.6,-0.5 h 0.2 l 0.9,-0.4 0.6,0.2 0.3,-0.1 0.5,-0.2 0.6,-0.1 0.3,-0.3 z"
              id="path297"
            />
            <path onMouseOver={ev => doHover(ev)} data-name="Fiji" d="m 1929.9,613.4 -0.2,0.1 0.2,-0.9 h 0.4 l -0.1,0.4 z" id="path298" />
            <path onMouseOut={ev => doOut(ev)} data-name="Fiji" d="m 1929.9,613.4 -0.2,0.1 0.2,-0.9 h 0.4 l -0.1,0.4 z" id="path298" />
            <path onMouseOver={ev => doHover(ev)} data-name="Fiji" d="m 1918.5,611.4 -0.2,0.3 -0.5,0.3 v -0.3 l 0.4,-0.4 z" id="path299" />
            <path onMouseOut={ev => doOut(ev)} data-name="Fiji" d="m 1918.5,611.4 -0.2,0.3 -0.5,0.3 v -0.3 l 0.4,-0.4 z" id="path299" />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Fiji"
              d="m 1933.4,611 -0.2,-0.2 0.1,-0.2 0.5,-0.5 0.3,-0.5 -0.3,1.1 z"
              id="path300"
            />
            <path
              onMouseOver={ev => doHover(ev)}
              onMouseOut={ev => doOut(ev)}
              data-name="Fiji"
              d="m 1934.4,606 -0.4,0.4 -0.8,1.1 -0.3,0.1 -0.7,0.4 -0.2,0.6 -0.4,0.2 -0.2,0.3 -0.1,0.2 0.3,0.1 0.6,-0.3 0.1,-0.1 0.3,-0.3 0.2,-0.3 0.6,-0.3 0.3,-0.3 0.6,-0.3 v 0.3 l -0.5,0.7 -0.2,0.1 0.1,0.6 -0.3,0.3 -0.3,-0.3 h -0.4 l -0.5,0.1 -0.4,0.3 -0.7,0.1 h -1 l 0.5,-0.5 -0.4,-0.2 -0.6,0.2 -0.4,0.2 v 0.2 l -0.3,0.1 -0.2,0.1 -0.1,0.4 -0.2,0.3 -0.3,-0.1 v -0.2 l -0.4,-0.1 -0.4,0.2 -0.2,0.5 -0.3,0.2 h -0.3 v -0.3 -0.4 l -0.2,-0.4 0.1,-0.2 -0.1,-0.1 -0.6,0.2 v -0.4 l 0.4,-0.3 h 0.1 l -0.1,-0.5 0.3,-0.1 0.5,0.3 0.6,-0.4 h 0.2 l 0.3,-0.3 h 0.2 l 0.3,-0.3 v -0.2 l 0.8,-0.1 0.9,-0.3 0.3,-0.1 0.4,0.1 0.5,-0.2 0.2,-0.4 h 0.2 l 0.2,-0.4 0.4,0.1 0.1,-0.2 0.2,0.1 1,-0.5 0.1,0.3 0.2,-0.1 0.2,0.1 0.3,-0.3 0.5,-0.2 0.1,0.1 -0.5,0.4 z"
              id="path301"
            />
            <circle cx="937.90002" cy="189.10001" id="0" r="0" />
            <circle cx="613.5" cy="724.09998" id="1" r="0" />
            <circle cx="1738.2" cy="719.29999" id="2" r="0" />
          </svg>
        </ReactSVGPanZoom>
      </div>
      <span onClick={() => setshowTable(!showTable)} style={{ cursor: "pointer" }}>
        .
      </span>
      {showTable && <Table data={data} />}
    </Box>
  );
};

export default HeatMap;
